/* OldHifiAudio lightweight interactions. Keep Shopify-safe and dependency-free. */
window.dataLayer = window.dataLayer || [];

function ohaPushAnalytics(eventName, payload = {}){
  window.dataLayer.push({
    event: eventName,
    ...payload
  });
}

function ohaTrackAddToCartForm(form){
  const variantInput = form.querySelector('[name="id"]');
  ohaPushAnalytics('oha_add_to_cart_submit', {
    variant_id: variantInput ? String(variantInput.value || '') : ''
  });
}

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-oha-toggle]');
  if (!toggle) return;
  const id = toggle.getAttribute('data-oha-toggle');
  const panel = document.getElementById(id);
  if (!panel) return;
  const expanded = toggle.getAttribute('aria-expanded') === 'true';
  toggle.setAttribute('aria-expanded', String(!expanded));
  panel.hidden = expanded;
});

function ohaInitTabs(){
  document.querySelectorAll('[data-oha-tabs]').forEach(group => {
    group.addEventListener('click', e => {
      const btn = e.target.closest('[data-oha-tab]');
      if(!btn) return;
      const target = btn.dataset.ohaTab;
      group.querySelectorAll('[data-oha-tab]').forEach(b => b.setAttribute('aria-selected', String(b === btn)));
      document.querySelectorAll(`[data-oha-tab-panel][data-oha-group="${group.dataset.ohaTabs}"]`).forEach(panel => {
        panel.hidden = panel.dataset.ohaTabPanel !== target;
      });
    });
  });
}
document.addEventListener('DOMContentLoaded', ohaInitTabs);

function ohaInitCheckoutGuards(){
  document.querySelectorAll('[data-oha-checkout-guard]').forEach(form => {
    if (form.dataset.ohaGuardReady === 'true') return;
    form.dataset.ohaGuardReady = 'true';
    const checks = Array.from(form.querySelectorAll('[data-oha-guard-check]'));
    const submit = form.querySelector('[data-oha-guard-submit]');
    if(!submit || !checks.length) return;
    const sync = () => {
      submit.disabled = !checks.every(check => check.checked);
    };
    checks.forEach(check => check.addEventListener('change', sync));
    sync();
  });
}
document.addEventListener('DOMContentLoaded', ohaInitCheckoutGuards);

function ohaInitCheckoutPreflight(){
  document.querySelectorAll('[data-oha-checkout-preflight]').forEach(root => {
    if (root.dataset.ohaPreflightReady === 'true') return;
    root.dataset.ohaPreflightReady = 'true';

    const datasetText = (key, fallback) => {
      const value = root.dataset[key];
      return typeof value === 'string' && value.trim() ? value : fallback;
    };
    const attrEscape = value => String(value || '').replace(/\\/g, '\\\\').replace(/"/g, '\\"');
    const moneySuffix = datasetText('moneySuffix', 'Ft');
    const zeroMoney = datasetText('zeroMoney', '0 Ft');
    const addonFallbackName = datasetText('addonFallbackName', 'Kiegészítő');
    const statusReadyHeading = datasetText('statusReadyHeading', 'Fizetésre kész');
    const statusReadyText = datasetText('statusReadyText', 'Minden kötelező pont rendben. A Shopify-fizetési gomb aktív.');
    const statusMissingHeading = datasetText('statusMissingHeading', 'Hiányzó ellenőrzések');
    const statusMissingText = datasetText('statusMissingText', 'Pipáld ki a kötelező pontokat a fizetéshez.');
    const errorMissing = datasetText('errorMissing', 'Hiányzik legalább egy kötelező ellenőrzés. 100 V-os készüléknél trafó vagy saját trafó jelölése is szükséges.');
    const faqOpenSymbol = datasetText('faqOpenSymbol', '-');
    const faqClosedSymbol = datasetText('faqClosedSymbol', '+');
    const trafoAddonKey = datasetText('trafoAddonKey', 'trafo');
    const ownTrafoKey = datasetText('ownTrafoKey', 'own_trafo');
    const voltageAckKey = datasetText('voltageAckKey', 'voltage');
    const conditionAckKey = datasetText('conditionAckKey', 'condition');
    const shippingAckKey = datasetText('shippingAckKey', 'shipping');
    const termsAckKey = datasetText('termsAckKey', 'terms');
    const formatCents = cents => {
      const amount = Math.max(0, Number(cents || 0)) / 100;
      if (amount === 0) return zeroMoney;
      return new Intl.NumberFormat('hu-HU', { maximumFractionDigits: 0 }).format(amount) + ' ' + moneySuffix;
    };
    const baseCents = Number(root.dataset.baseCents || 0);
    const discountCents = Number(root.dataset.discountCents || 0);
    const requires100v = root.dataset.has100v === 'true';
    const shippingInputs = Array.from(root.querySelectorAll('[data-oha-preflight-shipping]'));
    const paymentInputs = Array.from(root.querySelectorAll('[data-oha-preflight-payment]'));
    const addonInputs = Array.from(root.querySelectorAll('[data-oha-preflight-addon]'));
    const contactInputs = Array.from(root.querySelectorAll('[data-oha-preflight-contact]'));
    const submit = root.querySelector('[data-oha-preflight-submit]');
    const statusBox = root.querySelector('[data-oha-preflight-status]');
    const error = root.querySelector('[data-oha-preflight-error]');
    const confirmation = root.querySelector('[data-oha-preflight-confirmation]');
    const addonTotalEl = root.querySelector('[data-oha-preflight-addon-total]');
    const shippingTotalEl = root.querySelector('[data-oha-preflight-shipping-total]');
    const discountTotalEl = root.querySelector('[data-oha-preflight-discount-total]');
    const grandTotalEl = root.querySelector('[data-oha-preflight-grand-total]');
    const addonLines = root.querySelector('[data-oha-preflight-addon-lines]');
    const addonHidden = root.querySelector('[data-oha-preflight-addon-hidden]');
    const shippingHidden = root.querySelector('[data-oha-preflight-shipping-hidden]');
    const discountHidden = root.querySelector('[data-oha-preflight-discount-hidden]');
    const shipBadge = root.querySelector('[data-oha-preflight-ship-badge]');

    const ack = key => root.querySelector(`[data-oha-preflight-ack="${attrEscape(key)}"]`);
    const selectedShipping = () => shippingInputs.find(input => input.checked) || shippingInputs[0];
    const selectedTrafoAddon = () => addonInputs.find(input => input.dataset.addonKey === trafoAddonKey);
    const ownTrafo = ack(ownTrafoKey);
    const voltageAck = ack(voltageAckKey);
    const conditionAck = ack(conditionAckKey);
    const shippingAck = ack(shippingAckKey);
    const termsAck = ack(termsAckKey);

    const setState = (name, done) => {
      root.querySelectorAll(`[data-oha-preflight-state="${name}"]`).forEach(item => item.classList.toggle('is-done', done));
    };

    const contactOk = () => contactInputs.every(input => {
      const value = String(input.value || '').trim();
      if (input.type === 'email') return value.includes('@') && value.includes('.');
      return value.length > 2;
    });

    const renderAddonLines = activeAddons => {
      if (!addonLines) return;
      addonLines.innerHTML = '';
      activeAddons.forEach(input => {
        const row = document.createElement('div');
        row.className = 'oha-checkout-preflight__addon-line';
        const name = document.createElement('span');
        name.textContent = input.dataset.addonName || addonFallbackName;
        const price = document.createElement('strong');
        price.textContent = formatCents(input.dataset.cents);
        row.append(name, price);
        addonLines.appendChild(row);
      });
    };

    const syncCards = inputs => {
      inputs.forEach(input => {
        const card = input.closest('.oha-checkout-preflight__option');
        if (card) card.classList.toggle('is-selected', input.checked);
      });
    };

    const validate = showMessage => {
      const activeAddons = addonInputs.filter(input => input.checked);
      const addonCents = activeAddons.reduce((sum, input) => sum + Number(input.dataset.cents || 0), 0);
      const shipping = selectedShipping();
      const shippingCents = Number(shipping ? shipping.dataset.cents || 0 : 0);
      const trafo = selectedTrafoAddon();
      const hasTrafoChoice = !requires100v || Boolean((voltageAck && voltageAck.checked) && ((ownTrafo && ownTrafo.checked) || (trafo && trafo.checked)));
      const discount = trafo && trafo.checked && addonCents > 0 ? discountCents : 0;
      const grand = baseCents + addonCents + shippingCents - discount;
      const checks = {
        contact: contactOk(),
        voltage: hasTrafoChoice,
        condition: Boolean(conditionAck && conditionAck.checked),
        shipping: Boolean(shipping && shippingAck && shippingAck.checked),
        terms: Boolean(termsAck && termsAck.checked)
      };
      const allOk = Object.values(checks).every(Boolean);

      renderAddonLines(activeAddons);
      if (addonTotalEl) addonTotalEl.textContent = formatCents(addonCents);
      if (shippingTotalEl) shippingTotalEl.textContent = formatCents(shippingCents);
      if (discountTotalEl) discountTotalEl.textContent = discount ? '-' + formatCents(discount) : formatCents(0);
      if (grandTotalEl) grandTotalEl.textContent = formatCents(grand);
      if (addonHidden) addonHidden.value = String(addonCents);
      if (shippingHidden) shippingHidden.value = String(shippingCents);
      if (discountHidden) discountHidden.value = String(discount);
      if (shipBadge && shipping) shipBadge.textContent = shipping.dataset.label || shipping.value;

      Object.entries(checks).forEach(([key, value]) => setState(key, value));
      if (submit) submit.disabled = !allOk;
      if (statusBox) {
        statusBox.classList.toggle('is-ready', allOk);
        const title = statusBox.querySelector('strong');
        const text = statusBox.querySelector('p');
        if (title) title.textContent = allOk ? statusReadyHeading : statusMissingHeading;
        if (text) text.textContent = allOk ? statusReadyText : statusMissingText;
      }
      if (confirmation) confirmation.classList.toggle('is-visible', allOk);
      if (error) error.textContent = allOk || !showMessage ? '' : errorMissing;
      return allOk;
    };

    shippingInputs.forEach(input => {
      input.addEventListener('change', () => {
        syncCards(shippingInputs);
        validate(false);
      });
    });
    paymentInputs.forEach(input => {
      input.addEventListener('change', () => syncCards(paymentInputs));
    });
    addonInputs.forEach(input => {
      input.addEventListener('change', () => {
        if (input.dataset.addonKey === trafoAddonKey && input.checked && ownTrafo) ownTrafo.checked = false;
        validate(false);
      });
    });
    if (ownTrafo) {
      ownTrafo.addEventListener('change', () => {
        const trafo = selectedTrafoAddon();
        if (ownTrafo.checked && trafo) trafo.checked = false;
        validate(false);
      });
    }
    root.querySelectorAll('[data-oha-preflight-ack]').forEach(input => input.addEventListener('change', () => validate(false)));
    contactInputs.forEach(input => input.addEventListener('input', () => validate(false)));
    root.querySelectorAll('[data-oha-preflight-faq]').forEach(button => {
      button.addEventListener('click', () => {
        const item = button.closest('article');
        if (!item) return;
        item.classList.toggle('is-open');
        button.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');
        const marker = button.querySelector('b');
        if (marker) marker.textContent = item.classList.contains('is-open') ? faqOpenSymbol : faqClosedSymbol;
      });
    });
    const form = root.querySelector('form');
    if (form) {
      form.addEventListener('submit', event => {
        if (!validate(true)) event.preventDefault();
      });
    }
    syncCards(shippingInputs);
    syncCards(paymentInputs);
    validate(false);
  });
}
document.addEventListener('DOMContentLoaded', ohaInitCheckoutPreflight);

function ohaPatchP300StaleProductRender(){
  const isP300 = window.location && window.location.pathname.replace(/\/$/, '') === '/products/accuphase-p-300';
  const core = document.querySelector('.oha-product-core');
  if (!isP300 || !core) return;

  core.querySelectorAll('.oha-product-gallery__play').forEach(node => node.remove());

  const setText = (node, value) => {
    if (node && String(node.textContent || '').trim() !== value) node.textContent = value;
  };
  const replaceStaleCopy = root => {
    const replacements = [
      [
        /Európai hálózatról, külön step-down trafó nélkül használható\\.?/g,
        'Minden készüléket 110 V-os trafóval tesztelünk.'
      ],
      [
        /Európai hálózatról működik, tehát nem kell hozzá külön átalakító trafó\\.?/g,
        'A tesztelési protokoll szerint minden készüléket 110 V-os trafóval ellenőrzünk; a használati feszültséget vásárlás előtt külön egyeztetjük.'
      ]
    ];
    const walker = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(node => {
      let value = node.nodeValue || '';
      replacements.forEach(([pattern, replacement]) => {
        value = value.replace(pattern, replacement);
      });
      node.nodeValue = value;
    });
  };

  replaceStaleCopy(document.body);

  document.querySelectorAll('a, button').forEach(node => {
    const text = String(node.textContent || '').trim();
    if (/^showroom[-\s]*időpont$/i.test(text)) {
      node.classList.add('oha-product-buy__showroom');
      node.innerHTML = '<span class="oha-product-buy__showroom-status" aria-hidden="true"></span><span>Személyes meghallgatás kérhető</span>';
    }
    if (/^teljes specifikáció$/i.test(text)) {
      node.remove();
    }
  });

  const stock = core.querySelector('.oha-product-stock');
  const oldStatus = core.querySelector('.oha-product-buy__status');
  if (stock && !oldStatus) {
    const status = document.createElement('div');
    status.className = 'oha-product-buy__status';
    status.setAttribute('aria-label', 'Állapotjelzők');
    status.innerHTML = [
      '<span class="oha-product-status-chip oha-product-status-chip--success">B / dokumentált állapot</span>',
      '<span class="oha-product-status-chip">Dokumentált</span>',
      '<span class="oha-product-status-chip">1 db elérhető</span>',
      '<span class="oha-product-status-chip oha-product-status-chip--dark">Videó demo</span>',
      '<span class="oha-product-status-chip oha-product-status-chip--warning">110 V-os trafóval teszteljük</span>',
      '<span class="oha-product-status-chip">230V hálózat</span>'
    ].join('');
    stock.insertAdjacentElement('afterend', status);
  } else if (oldStatus && !/110\s*V-os trafóval teszteljük/i.test(oldStatus.textContent || '')) {
    const chip = document.createElement('span');
    chip.className = 'oha-product-status-chip oha-product-status-chip--warning';
    chip.textContent = '110 V-os trafóval teszteljük';
    oldStatus.appendChild(chip);
  }

  const trustList = core.querySelector('.oha-product-buy__trust');
  if (trustList && !/110\s*V-os trafóval tesztelünk/i.test(trustList.textContent || '')) {
    const item = document.createElement('li');
    item.innerHTML = '<span aria-hidden="true">✓</span><span>Minden készüléket 110 V-os trafóval tesztelünk.</span>';
    trustList.insertBefore(item, trustList.firstChild);
  }

  const gallery = core.querySelector('.oha-product-gallery');
  if (gallery && !gallery.querySelector('[data-oha-product-main-image]')) {
    const primaryFigure = gallery.querySelector('.oha-product-gallery__item.is-primary') || gallery.querySelector('figure, .oha-product-gallery__item');
    const primaryImage = primaryFigure ? primaryFigure.querySelector('img') : gallery.querySelector('img');
    if (primaryImage) {
      primaryImage.setAttribute('data-oha-product-main-image', '');
      primaryImage.dataset.ohaMainFullSrc = primaryImage.currentSrc || primaryImage.src || '';
      if (primaryFigure && !primaryFigure.querySelector('[data-oha-gallery-open]')) {
        const open = document.createElement('button');
        open.className = 'oha-product-gallery__zoom';
        open.type = 'button';
        open.setAttribute('data-oha-gallery-open', '');
        open.dataset.ohaGalleryIndex = '0';
        open.setAttribute('aria-label', 'Termékfotó nagyítása');
        open.textContent = '+';
        primaryFigure.appendChild(open);
      }
      if (primaryFigure && !primaryFigure.querySelector('[data-oha-gallery-step]')) {
        const prev = document.createElement('button');
        const next = document.createElement('button');
        prev.className = 'oha-product-gallery__nav oha-product-gallery__nav--prev';
        next.className = 'oha-product-gallery__nav oha-product-gallery__nav--next';
        prev.type = next.type = 'button';
        prev.dataset.ohaGalleryStep = '-1';
        next.dataset.ohaGalleryStep = '1';
        prev.setAttribute('aria-label', 'Előző termékfotó');
        next.setAttribute('aria-label', 'Következő termékfotó');
        prev.innerHTML = '&lsaquo;';
        next.innerHTML = '&rsaquo;';
        primaryFigure.append(prev, next);
      }
    }

    let thumbs = Array.from(gallery.querySelectorAll('.oha-product-gallery__thumb'));
    if (!thumbs.length) {
      thumbs = Array.from(gallery.querySelectorAll('.oha-product-gallery__item img')).map((img, index) => {
        if (index === 0) return null;
        const button = document.createElement('button');
        button.className = 'oha-product-gallery__thumb';
        button.type = 'button';
        const clone = img.cloneNode(true);
        clone.removeAttribute('id');
        button.appendChild(clone);
        return button;
      }).filter(Boolean);
      if (thumbs.length) {
        const wrap = document.createElement('div');
        wrap.className = 'oha-product-gallery__thumbs';
        thumbs.forEach(thumb => wrap.appendChild(thumb));
        gallery.appendChild(wrap);
      }
    }
    thumbs.forEach((thumb, index) => {
      const img = thumb.querySelector('img') || thumb;
      const src = thumb.getAttribute('href') || img.currentSrc || img.src || '';
      thumb.setAttribute('data-oha-product-thumb', '');
      thumb.dataset.ohaGalleryIndex = String(index);
      thumb.dataset.ohaThumbSrc = src;
      thumb.dataset.ohaFullSrc = src;
      thumb.dataset.ohaThumbAlt = img.alt || 'Accuphase P-300 termékfotó';
      if (index === 0) thumb.classList.add('is-active');
    });
    gallery.dataset.ohaGalleryReady = '';
  }

  if (!core.querySelector('[data-oha-product-lightbox]')) {
    const lightbox = document.createElement('div');
    lightbox.className = 'oha-product-lightbox';
    lightbox.setAttribute('data-oha-product-lightbox', '');
    lightbox.hidden = true;
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-label', 'Termékfotó nagyítása');
    lightbox.innerHTML = '<button class="oha-product-lightbox__close" type="button" data-oha-lightbox-close aria-label="Nagyított fotó bezárása">&times;</button><button class="oha-product-lightbox__nav oha-product-lightbox__nav--prev" type="button" data-oha-lightbox-prev aria-label="Előző nagyított fotó">&lsaquo;</button><figure><img data-oha-lightbox-image alt=""><figcaption data-oha-lightbox-caption></figcaption></figure><button class="oha-product-lightbox__nav oha-product-lightbox__nav--next" type="button" data-oha-lightbox-next aria-label="Következő nagyított fotó">&rsaquo;</button>';
    core.appendChild(lightbox);
  }

  const details = document.querySelector('.oha-product-details');
  if (details) {
    const combinedPanels = Array.from(details.querySelectorAll('.oha-product-tested-panel'));
    combinedPanels.forEach(panel => {
      const layout = panel.parentElement;
      if (!layout) return;
      if (!details.querySelector('.oha-product-tested-card')) {
        const headings = Array.from(panel.querySelectorAll('h3'));
        const listFor = pattern => {
          const heading = headings.find(node => pattern.test(String(node.textContent || '')));
          const list = heading && heading.parentElement ? heading.parentElement.querySelector('ul') : null;
          return list ? list.innerHTML : '';
        };
        const doneList = (listFor(/tesztelt|tesztelünk/i) || '<li><span>Részletes bemutató és hangteszt videó elérhető.</span></li><li><span>A készülék működőképesként dokumentált.</span></li>')
          .replace(/Európai hálózatról, külön step-down trafó nélkül használható\\.?/g, 'Minden készüléket 110 V-os trafóval tesztelünk.');
        const limitList = listFor(/nem/i) || '<li><span>Nincs külön nem tesztelt funkció rögzítve.</span></li>';
        const doneCard = document.createElement('article');
        doneCard.className = 'oha-product-detail-panel oha-product-tested-card oha-product-tested-card--done';
        doneCard.innerHTML = '<span class="oha-product-tested-card__eyebrow">Átlátható teszt</span><h3>Mit teszteltünk?</h3><ul class="oha-product-check-list">' + doneList + '</ul>';
        const limitCard = document.createElement('article');
        limitCard.className = 'oha-product-detail-panel oha-product-tested-card oha-product-tested-card--limits';
        limitCard.innerHTML = '<span class="oha-product-tested-card__eyebrow">Őszinte teszthatár</span><h3>Mit nem teszteltünk?</h3><ul class="oha-product-check-list">' + limitList + '</ul>';
        layout.insertBefore(doneCard, panel);
        layout.insertBefore(limitCard, panel);
      }
      panel.remove();
    });
  }

  if (details && !details.querySelector('.oha-product-tested-card') && !/Átlátható teszthatárok/.test(details.textContent || '')) {
    const layout = details.querySelector('.oha-product-detail-layout') || details.querySelector('.oha-container');
    if (layout) {
      const doneCard = document.createElement('article');
      doneCard.className = 'oha-product-detail-panel oha-product-tested-card oha-product-tested-card--done';
      doneCard.innerHTML = '<span class="oha-product-tested-card__eyebrow">Átlátható teszt</span><h3>Mit teszteltünk?</h3><ul class="oha-product-check-list"><li><span>Részletes bemutató és hangteszt videó elérhető.</span></li><li><span>A készülék működőképesként dokumentált.</span></li></ul>';
      const limitCard = document.createElement('article');
      limitCard.className = 'oha-product-detail-panel oha-product-tested-card oha-product-tested-card--limits';
      limitCard.innerHTML = '<span class="oha-product-tested-card__eyebrow">Őszinte teszthatár</span><h3>Mit nem teszteltünk?</h3><ul class="oha-product-check-list"><li><span>Nincs külön nem tesztelt funkció rögzítve.</span></li></ul>';
      layout.append(doneCard, limitCard);
    }
  }

  const videoCard = document.querySelector('.oha-product-video-card');
  if (videoCard && !videoCard.querySelector('.oha-product-video-card__media img')) {
    const image = core.querySelector('.oha-product-gallery img');
    const href = (videoCard.querySelector('a[href*="youtu"], a[href*="youtube"]') || {}).href || '#';
    if (image) {
      const media = document.createElement('a');
      media.className = 'oha-product-video-card__media';
      media.href = href;
      media.target = '_blank';
      media.rel = 'noopener';
      media.innerHTML = `<img src="${image.currentSrc || image.src}" loading="lazy" alt="Videó és hangdemo"><b>Videó demo</b><span>▶</span>`;
      videoCard.insertBefore(media, videoCard.querySelector('p') || videoCard.firstChild);
    }
  }
}

function ohaInitProductGallery(){
  document.querySelectorAll('.oha-product-gallery').forEach(gallery => {
    if (gallery.dataset.ohaGalleryReady === 'true') return;
    gallery.dataset.ohaGalleryReady = 'true';

    const root = gallery.closest('.oha-product-core') || gallery;
    const mainImage = gallery.querySelector('[data-oha-product-main-image]');
    const thumbs = Array.from(gallery.querySelectorAll('[data-oha-product-thumb]'));
    if (!mainImage || !thumbs.length) return;

    const items = thumbs.map((thumb, fallbackIndex) => ({
      index: Number(thumb.dataset.ohaGalleryIndex || fallbackIndex),
      preview: thumb.dataset.ohaThumbSrc || thumb.getAttribute('href') || '',
      full: thumb.dataset.ohaFullSrc || thumb.dataset.ohaThumbSrc || thumb.getAttribute('href') || '',
      alt: thumb.dataset.ohaThumbAlt || thumb.getAttribute('aria-label') || mainImage.alt || ''
    })).filter(item => item.preview || item.full);
    if (!items.length) return;

    const normalizeIndex = index => {
      const count = items.length;
      return ((Number(index) || 0) % count + count) % count;
    };
    let activeIndex = Math.max(0, thumbs.findIndex(thumb => thumb.classList.contains('is-active')));
    const lightbox = root.querySelector('[data-oha-product-lightbox]');
    const lightboxImage = lightbox ? lightbox.querySelector('[data-oha-lightbox-image]') : null;
    const lightboxCaption = lightbox ? lightbox.querySelector('[data-oha-lightbox-caption]') : null;
    const openButtons = Array.from(root.querySelectorAll('[data-oha-gallery-open]'));
    let lastFocused = null;
    let lockedScrollY = 0;

    const syncOpenButtons = () => {
      openButtons.forEach(button => {
        button.dataset.ohaGalleryIndex = String(activeIndex);
      });
    };

    const setActive = index => {
      activeIndex = normalizeIndex(index);
      const item = items[activeIndex];
      if (!item) return;
      if (item.preview) mainImage.src = item.preview;
      mainImage.removeAttribute('srcset');
      mainImage.alt = item.alt || mainImage.alt;
      mainImage.dataset.ohaMainFullSrc = item.full || item.preview;
      thumbs.forEach((thumb, thumbIndex) => {
        const selected = thumbIndex === activeIndex;
        thumb.classList.toggle('is-active', selected);
        thumb.setAttribute('aria-current', selected ? 'true' : 'false');
      });
      syncOpenButtons();
      if (lightbox && !lightbox.hidden) renderLightbox(activeIndex);
    };

    const renderLightbox = index => {
      if (!lightboxImage) return;
      const item = items[normalizeIndex(index)];
      if (!item) return;
      lightboxImage.src = item.full || item.preview;
      lightboxImage.alt = item.alt || mainImage.alt || '';
      if (lightboxCaption) {
        const label = item.alt || mainImage.alt || 'Termékfotó';
        lightboxCaption.textContent = `${label} - ${activeIndex + 1}/${items.length}`;
      }
    };

    const openLightbox = index => {
      if (!lightbox || !lightboxImage) return;
      lastFocused = document.activeElement;
      setActive(index);
      renderLightbox(activeIndex);
      lockedScrollY = window.scrollY || window.pageYOffset || 0;
      lightbox.hidden = false;
      document.documentElement.classList.add('oha-lightbox-open');
      document.body.classList.add('oha-lightbox-open');
      document.body.style.position = 'fixed';
      document.body.style.top = `-${lockedScrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      const close = lightbox.querySelector('[data-oha-lightbox-close]');
      if (close) close.focus();
    };

    const closeLightbox = () => {
      if (!lightbox) return;
      lightbox.hidden = true;
      document.documentElement.classList.remove('oha-lightbox-open');
      document.body.classList.remove('oha-lightbox-open');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, lockedScrollY || 0);
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    };

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', event => {
        event.preventDefault();
        const index = thumbs.indexOf(thumb);
        if (index >= 0) setActive(index);
      });
    });

    gallery.querySelectorAll('[data-oha-gallery-step]').forEach(button => {
      button.addEventListener('click', event => {
        event.preventDefault();
        setActive(activeIndex + Number(button.dataset.ohaGalleryStep || 0));
      });
    });

    openButtons.forEach(button => {
      button.addEventListener('click', event => {
        event.preventDefault();
        openLightbox(Number(button.dataset.ohaGalleryIndex || activeIndex));
      });
    });

    if (lightbox) {
      lightbox.hidden = true;
      document.documentElement.classList.remove('oha-lightbox-open');
      document.body.classList.remove('oha-lightbox-open');
      lightbox.querySelectorAll('[data-oha-lightbox-close]').forEach(button => button.addEventListener('click', event => {
        event.preventDefault();
        closeLightbox();
      }));
      lightbox.querySelectorAll('[data-oha-lightbox-prev]').forEach(button => button.addEventListener('click', event => {
        event.preventDefault();
        setActive(activeIndex - 1);
      }));
      lightbox.querySelectorAll('[data-oha-lightbox-next]').forEach(button => button.addEventListener('click', event => {
        event.preventDefault();
        setActive(activeIndex + 1);
      }));
      lightbox.addEventListener('click', event => {
        if (event.target === lightbox) closeLightbox();
      });
      document.addEventListener('keydown', event => {
        if (lightbox.hidden) return;
        if (event.key === 'Escape') closeLightbox();
        if (event.key === 'ArrowLeft') setActive(activeIndex - 1);
        if (event.key === 'ArrowRight') setActive(activeIndex + 1);
      });
    }

    setActive(activeIndex);
  });
}
function ohaInitProductGalleryWithPatches(){
  ohaPatchP300StaleProductRender();
  ohaInitProductGallery();
}
function ohaRunP300ProductGalleryGuard(){
  ohaInitProductGalleryWithPatches();
  window.setTimeout(ohaInitProductGalleryWithPatches, 500);
  window.setTimeout(ohaInitProductGalleryWithPatches, 1800);
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ohaRunP300ProductGalleryGuard);
} else {
  ohaRunP300ProductGalleryGuard();
}

function ohaNormalizeHeaderBrandLinks(){
  const normalize = (value) => String(value || '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
  const pathFrom = (value) => {
    try {
      return new URL(value || '/', window.location.origin).pathname;
    } catch (error) {
      return String(value || '/').split('?')[0] || '/';
    }
  };
  document.querySelectorAll('.oha-header__nav, .oha-mobile-drawer__inner').forEach(nav => {
    const header = nav.closest('[data-oha-site-header]');
    const brandLabel = header?.dataset.ohaMenuBrandsLabel || 'Márkák';
    const brandUrl = header?.dataset.ohaMenuBrandsUrl || '/collections/markak';
    const brandActivePath = header?.dataset.ohaMenuBrandsActivePath || pathFrom(brandUrl);
    const brandPath = pathFrom(brandUrl);
    let rendered = false;
    Array.from(nav.querySelectorAll('a')).forEach(link => {
      const key = normalize(link.textContent);
      const linkPath = pathFrom(link.getAttribute('href') || link.href);
      const isBrandLink = link.hasAttribute('data-oha-header-brand-link')
        || key === 'markak'
        || linkPath === brandPath
        || linkPath === brandActivePath;
      if (!isBrandLink) return;
      if (rendered) {
        link.remove();
        return;
      }
      link.textContent = brandLabel;
      link.setAttribute('href', brandUrl);
      link.setAttribute('data-oha-header-brand-link', '');
      if (window.location.pathname === brandActivePath) {
        link.setAttribute('aria-current', 'page');
      } else {
        link.removeAttribute('aria-current');
      }
      rendered = true;
    });
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ohaNormalizeHeaderBrandLinks);
} else {
  ohaNormalizeHeaderBrandLinks();
}
window.setTimeout(ohaNormalizeHeaderBrandLinks, 500);
window.setTimeout(ohaNormalizeHeaderBrandLinks, 1500);

function ohaInitAuctionPro(){
  document.querySelectorAll('.oha-auction-pro').forEach(root => {
    const datasetText = (key, fallback = '') => String(root.dataset[key] || fallback);
    const cards = Array.from(root.querySelectorAll('[data-oha-auction-card]'));
    const tabs = Array.from(root.querySelectorAll('[data-oha-auction-filter]'));
    const search = root.querySelector('[data-oha-auction-search]');
    const clear = root.querySelector('[data-oha-auction-clear]');
    let activeFilter = 'all';

    const syncCards = () => {
      const term = String(search ? search.value : '').trim().toLowerCase();
      cards.forEach(card => {
        const category = String(card.dataset.ohaAuctionCategory || '');
        const name = String(card.dataset.ohaAuctionName || '').toLowerCase();
        const categoryOk = activeFilter === 'all' || category === activeFilter;
        const searchOk = !term || name.includes(term) || category.toLowerCase().includes(term);
        card.hidden = !(categoryOk && searchOk);
      });
    };

    tabs.forEach((tab, index) => {
      tab.classList.toggle('is-active', index === 0);
      tab.addEventListener('click', event => {
        event.preventDefault();
        activeFilter = tab.dataset.ohaAuctionFilter || 'all';
        tabs.forEach(item => item.classList.toggle('is-active', item === tab));
        syncCards();
      });
    });

    if (search) search.addEventListener('input', syncCards);
    if (clear) {
      clear.addEventListener('click', () => {
        if (search) search.value = '';
        activeFilter = 'all';
        tabs.forEach((item, index) => item.classList.toggle('is-active', index === 0));
        syncCards();
      });
    }

    root.querySelectorAll('[data-oha-auction-demo]').forEach(form => {
      form.addEventListener('submit', event => {
        event.preventDefault();
        const button = form.querySelector('button[type="submit"]');
        if (!button) return;
        const original = button.textContent;
        button.textContent = datasetText('demoSuccessLabel', 'Rögzítve');
        window.setTimeout(() => {
          button.textContent = original;
        }, 1800);
      });
    });

    syncCards();
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ohaInitAuctionPro);
} else {
  ohaInitAuctionPro();
}

function ohaInitBrandPro(){
  document.querySelectorAll('.oha-brand-pro').forEach(root => {
    const datasetText = (key, fallback = '') => String(root.dataset[key] || fallback);
    const cards = Array.from(root.querySelectorAll('[data-oha-brand-card]'));
    const filters = Array.from(root.querySelectorAll('[data-oha-brand-filter]'));
    const search = root.querySelector('[data-oha-brand-search]');
    let activeFilter = 'all';

    const syncCards = () => {
      const term = String(search ? search.value : '').trim().toLowerCase();
      cards.forEach(card => {
        const categories = String(card.dataset.ohaBrandCategory || '').toLowerCase();
        const name = String(card.dataset.ohaBrandName || '').toLowerCase();
        const text = String(card.textContent || '').toLowerCase();
        const filterOk = activeFilter === 'all' || categories.split(/\s+/).includes(activeFilter);
        const searchOk = !term || name.includes(term) || text.includes(term);
        card.hidden = !(filterOk && searchOk);
      });
    };

    filters.forEach((filter, index) => {
      filter.classList.toggle('is-active', index === 0);
      filter.addEventListener('click', () => {
        activeFilter = filter.dataset.ohaBrandFilter || 'all';
        filters.forEach(item => item.classList.toggle('is-active', item === filter));
        syncCards();
      });
    });

    if (search) {
      search.addEventListener('input', syncCards);
    }

    root.querySelectorAll('[data-oha-brand-watch-form]').forEach(form => {
      form.addEventListener('submit', event => {
        event.preventDefault();
        const status = form.querySelector('.oha-brand-pro-watch__status');
        if (status) {
          status.textContent = datasetText('watchSuccessText', 'Köszönjük, rögzítettük a márkafigyelő igényt.');
        }
        ohaPushAnalytics('oha_brand_watch_submit', {
          selected_brands: Array.from(form.querySelectorAll('input[name="brand[]"]:checked')).map(input => input.value).join(','),
          selected_category: form.querySelector('input[name="category"]:checked')?.value || ''
        });
      });
    });

    syncCards();
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ohaInitBrandPro);
} else {
  ohaInitBrandPro();
}

function ohaInitContactPro(){
  document.querySelectorAll('.oha-contact-pro').forEach(root => {
    if (root.dataset.ohaContactReady === 'true') return;
    root.dataset.ohaContactReady = 'true';

    const datasetText = (key, fallback = '') => String(root.dataset[key] || fallback);
    const topic = root.querySelector('#OhaContactTopic');
    const routeBox = root.querySelector('[data-oha-contact-route-box]');
    const routeButtons = Array.from(root.querySelectorAll('[data-oha-contact-route]'));

    const renderRoute = (button) => {
      if (!button || !routeBox) return;
      routeButtons.forEach(item => {
        const isActive = item === button;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-selected', String(isActive));
      });

      const key = button.dataset.ohaContactRoute || '';
      if (topic && key && Array.from(topic.options).some(option => option.value === key)) {
        topic.value = key;
      }

      routeBox.replaceChildren();
      const title = document.createElement('strong');
      title.textContent = button.dataset.ohaContactRouteTitle || '';
      const text = document.createElement('p');
      text.textContent = button.dataset.ohaContactRouteText || '';
      const cta = document.createElement('a');
      cta.className = 'oha-btn oha-btn--dark';
      cta.href = button.dataset.ohaContactRouteUrl || '#contact-form';
      cta.textContent = button.dataset.ohaContactRouteCta || 'Üzenet írása';
      routeBox.append(title, text, cta);
    };

    routeButtons.forEach(button => {
      button.addEventListener('click', () => renderRoute(button));
    });

    root.querySelectorAll('[data-oha-contact-topic-link]').forEach(link => {
      link.addEventListener('click', event => {
        const key = link.dataset.ohaContactTopicLink;
        const button = routeButtons.find(item => item.dataset.ohaContactRoute === key);
        if (button) renderRoute(button);

        const href = link.getAttribute('href') || '';
        if (!href.startsWith('#')) return;
        const target = document.querySelector(href);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    root.querySelectorAll('[data-oha-contact-copy]').forEach(button => {
      button.addEventListener('click', async () => {
        const value = button.dataset.ohaContactCopy || '';
        const writeFallback = () => {
          const input = document.createElement('textarea');
          input.value = value;
          input.setAttribute('readonly', '');
          input.style.position = 'fixed';
          input.style.opacity = '0';
          document.body.append(input);
          input.select();
          document.execCommand('copy');
          input.remove();
        };

        try {
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(value);
          } else {
            writeFallback();
          }
        } catch (error) {
          writeFallback();
        }

        const hasRichContent = Boolean(button.querySelector('strong'));
        if (hasRichContent) {
          button.classList.add('is-copied');
          window.setTimeout(() => button.classList.remove('is-copied'), 1300);
          return;
        }

        const original = button.dataset.ohaContactCopyLabel || button.textContent;
        button.dataset.ohaContactCopyLabel = original;
        button.textContent = datasetText('copySuccessLabel', 'Másolva');
        window.setTimeout(() => {
          button.textContent = button.dataset.ohaContactCopyLabel || original;
        }, 1300);
      });
    });
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ohaInitContactPro);
} else {
  ohaInitContactPro();
}

function ohaInitAccountPro(){
  document.querySelectorAll('[data-oha-account-pro]').forEach(root => {
    if (root.dataset.ohaAccountReady === 'true') return;
    root.dataset.ohaAccountReady = 'true';

    const tabs = Array.from(root.querySelectorAll('[data-oha-account-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-oha-account-panel]'));
    const toast = root.querySelector('[data-oha-account-toastbox]');
    let toastTimer;

    const showToast = message => {
      if (!toast || !message) return;
      toast.textContent = message;
      toast.classList.add('is-visible');
      window.clearTimeout(toastTimer);
      toastTimer = window.setTimeout(() => {
        toast.classList.remove('is-visible');
      }, 2600);
    };

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.ohaAccountTab;
        tabs.forEach(item => item.classList.toggle('is-active', item === tab));
        panels.forEach(panel => {
          const active = panel.dataset.ohaAccountPanel === target;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
      });
    });

    root.querySelectorAll('.oha-account-pro-choice-row button').forEach(button => {
      button.addEventListener('click', () => {
        button.classList.toggle('is-active');
      });
    });

    root.querySelectorAll('.oha-account-pro-settings article>button').forEach(button => {
      button.addEventListener('click', () => {
        button.classList.toggle('is-active');
      });
    });

    root.querySelectorAll('[data-oha-account-toast]').forEach(trigger => {
      trigger.addEventListener('click', event => {
        if (trigger.tagName === 'BUTTON') event.preventDefault();
        showToast(trigger.dataset.ohaAccountToast);
      });
    });
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ohaInitAccountPro);
} else {
  ohaInitAccountPro();
}

function ohaInitCommerceCare(){
  document.querySelectorAll('[data-oha-commerce-care]').forEach(root => {
    if (root.dataset.ohaCommerceCareReady === 'true') return;
    root.dataset.ohaCommerceCareReady = 'true';

    const datasetText = (key, fallback = '') => {
      const value = root.dataset[key];
      return typeof value === 'string' && value.trim() ? value : fallback;
    };
    const attributeText = (name, fallback = '') => {
      const value = root.getAttribute(name);
      return typeof value === 'string' && value.trim() ? value : fallback;
    };
    const money = value => Number(value || 0) === 0
      ? datasetText('ohaMoneyZero', '0')
      : `${new Intl.NumberFormat('hu-HU').format(Number(value || 0))} ${datasetText('ohaMoneyCurrency')}`.trim();

    const estimator = root.querySelector('[data-oha-shipping-estimator]');
    if (estimator) {
      const zone = estimator.querySelector('[data-oha-quote-zone]');
      const type = estimator.querySelector('[data-oha-quote-type]');
      const value = estimator.querySelector('[data-oha-quote-value]');
      const voltage = estimator.querySelector('[data-oha-quote-voltage]');
      const extraPack = estimator.querySelector('[data-oha-extra-pack]');
      const transformer = estimator.querySelector('[data-oha-transformer-check]');
      const baseNode = estimator.querySelector('[data-oha-quote-base]');
      const packNode = estimator.querySelector('[data-oha-quote-pack]');
      const insuranceNode = estimator.querySelector('[data-oha-quote-insurance]');
      const voltageNode = estimator.querySelector('[data-oha-quote-voltage-note]');
      const totalNode = estimator.querySelector('[data-oha-quote-total]');
      const textNode = estimator.querySelector('[data-oha-quote-text]');
      const defaultText = estimator.dataset.defaultText || '';
      const pickupText = estimator.dataset.pickupText || defaultText;
      const customText = estimator.dataset.customText || defaultText;
      const voltageSuffix = estimator.dataset.voltageSuffix || '';
      const pickupValue = estimator.dataset.pickupValue || 'pickup';
      const voltage100vValue = estimator.dataset.voltageOneHundredValue || '100v';

      const selected = select => select ? select.options[select.selectedIndex] : null;
      const asNumber = option => Number(option?.dataset.fee || option?.dataset.pack || option?.dataset.insurance || 0);

      const sync = () => {
        const zoneOption = selected(zone);
        const typeOption = selected(type);
        const valueOption = selected(value);
        const voltageOption = selected(voltage);
        const custom = zoneOption?.dataset.custom === 'true' || typeOption?.dataset.custom === 'true';
        const base = Number(zoneOption?.dataset.fee || 0);
        const pack = extraPack && extraPack.checked ? Number(typeOption?.dataset.pack || 0) : 0;
        const insurance = asNumber(valueOption);
        const total = base + pack + insurance;
        const is100v = voltage && voltage.value === voltage100vValue;

        if (baseNode) baseNode.textContent = custom ? datasetText('ohaCustomBaseText', 'Egyedi') : money(base);
        if (packNode) packNode.textContent = custom ? datasetText('ohaCustomPackText', 'Egyedi') : money(pack);
        if (insuranceNode) insuranceNode.textContent = money(insurance);
        if (voltageNode) {
          voltageNode.textContent = is100v && transformer && !transformer.checked
            ? datasetText('ohaTransformerRequiredText', 'Ellenőrzés szükséges')
            : (voltageOption?.dataset.note || '');
        }
        if (totalNode) totalNode.textContent = custom ? datasetText('ohaCustomTotalText', 'Egyedi') : money(total);
        if (textNode) {
          let text = zone && zone.value === pickupValue ? pickupText : defaultText;
          if (custom) text = customText;
          if (is100v && voltageSuffix) text = `${text} ${voltageSuffix}`;
          textNode.textContent = text;
        }
      };

      [zone, type, value, voltage, extraPack, transformer].forEach(control => {
        if (control) control.addEventListener('change', sync);
      });
      sync();
    }

    const paymentTabs = Array.from(root.querySelectorAll('[data-oha-payment-tab]'));
    const paymentPanels = Array.from(root.querySelectorAll('[data-oha-payment-panel]'));
    paymentTabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.ohaPaymentTab;
        paymentTabs.forEach(item => item.classList.toggle('is-active', item === tab));
        paymentPanels.forEach(panel => {
          const active = panel.dataset.ohaPaymentPanel === target;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
      });
    });

    root.querySelectorAll('[data-oha-commerce-faq]').forEach(button => {
      button.addEventListener('click', () => {
        const item = button.closest('article');
        const answer = item ? item.querySelector('div') : null;
        const open = item ? !item.classList.contains('is-open') : false;
        if (item) item.classList.toggle('is-open', open);
        if (answer) answer.hidden = !open;
      });
    });

    root.querySelectorAll('a[href^="#"]').forEach(link => {
      link.addEventListener('click', () => {
        const toast = root.querySelector('[data-oha-commerce-toast]');
        if (!toast) return;
        toast.textContent = datasetText('ohaAnchorToast', 'Megnyitva.');
        toast.classList.add('is-visible');
        window.setTimeout(() => toast.classList.remove('is-visible'), 1800);
      });
    });
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ohaInitCommerceCare);
} else {
  ohaInitCommerceCare();
}

function ohaInitSearchPro(){
  document.querySelectorAll('[data-oha-search-pro]').forEach(root => {
    if (root.dataset.ohaSearchReady === 'true') return;
    root.dataset.ohaSearchReady = 'true';
    const datasetText = (key, fallback = '') => {
      const value = root.dataset[key];
      return typeof value === 'string' && value.trim() ? value : fallback;
    };

    const grid = root.querySelector('[data-oha-search-grid]');
    const input = root.querySelector('[data-oha-search-input]');
    const clear = root.querySelector('[data-oha-search-clear]');
    const count = root.querySelector('[data-oha-search-count]');
    const heading = root.querySelector('[data-oha-search-heading]');
    const empty = root.querySelector('[data-oha-search-empty]');
    const sort = root.querySelector('[data-oha-search-sort]');
    const cards = Array.from(root.querySelectorAll('[data-oha-search-card]'));
    const checks = Array.from(root.querySelectorAll('[data-oha-search-filter]'));
    const minPrice = root.querySelector('[data-oha-search-min-price]');
    const maxPrice = root.querySelector('[data-oha-search-max-price]');
    const form = root.querySelector('[data-oha-search-form]');
    const defaultHeading = datasetText('ohaSearchDefaultHeading', heading ? heading.textContent : 'Keresési találatok');
    const queryHeadingTemplate = datasetText('ohaSearchQueryHeadingTemplate', 'Találatok erre: „{query}”');
    const resultLabel = datasetText('ohaSearchResultLabel', count ? count.textContent.replace(/^\s*\d+\s*/, '').trim() || 'találat' : 'találat');

    if (!grid || !cards.length) return;

    const normalize = value => String(value || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

    const selected = key => checks
      .filter(check => check.dataset.ohaSearchFilter === key && check.checked)
      .map(check => normalize(check.value));

    const matchSet = (value, set) => !set.length || set.includes(normalize(value));

    const score = (card, query) => {
      if (!query) return 1;
      const text = normalize(card.dataset.name || card.textContent || '');
      return normalize(query).split(/\s+/).filter(Boolean).reduce((sum, word) => {
        return sum + (text.includes(word) ? 1 : 0);
      }, 0);
    };

    const syncUrl = () => {
      if (!input || !window.history || !window.URL) return;
      const url = new URL(window.location.href);
      const query = String(input.value || '').trim();
      if (query) {
        url.searchParams.set('q', query);
      } else {
        url.searchParams.delete('q');
      }
      window.history.replaceState({}, '', url.toString());
    };

    const sync = () => {
      const query = input ? String(input.value || '').trim() : '';
      const cats = selected('cat');
      const brands = selected('brand');
      const conds = selected('cond');
      const volts = selected('voltage');
      const availability = selected('availability');
      const min = Number(minPrice && minPrice.value ? minPrice.value : 0);
      const max = Number(maxPrice && maxPrice.value ? maxPrice.value : 999999999);
      const visible = [];

      cards.forEach(card => {
        const ok = score(card, query) > 0
          && matchSet(card.dataset.cat, cats)
          && matchSet(card.dataset.brand, brands)
          && matchSet(card.dataset.cond, conds)
          && matchSet(card.dataset.voltage, volts)
          && matchSet(card.dataset.availability, availability)
          && Number(card.dataset.price || 0) >= min
          && Number(card.dataset.price || 0) <= max;
        card.hidden = !ok;
        if (ok) visible.push(card);
      });

      visible.sort((a, b) => {
        const mode = sort ? sort.value : 'relevance';
        if (mode === 'priceAsc') return Number(a.dataset.price || 0) - Number(b.dataset.price || 0);
        if (mode === 'priceDesc') return Number(b.dataset.price || 0) - Number(a.dataset.price || 0);
        if (mode === 'nameAsc') return normalize(a.dataset.name).localeCompare(normalize(b.dataset.name), 'hu');
        return score(b, query) - score(a, query);
      }).forEach(card => grid.appendChild(card));

      if (count) count.textContent = `${visible.length} ${resultLabel}`;
      if (heading) heading.textContent = query ? queryHeadingTemplate.replaceAll('{query}', query) : defaultHeading;
      if (empty) empty.hidden = visible.length > 0;
    };

    root.querySelectorAll('[data-oha-search-query]').forEach(button => {
      button.addEventListener('click', () => {
        if (input) input.value = button.dataset.ohaSearchQuery || '';
        sync();
        syncUrl();
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    checks.forEach(check => check.addEventListener('change', sync));
    [minPrice, maxPrice].forEach(field => {
      if (field) field.addEventListener('input', sync);
    });
    if (sort) sort.addEventListener('change', sync);
    if (input) {
      input.addEventListener('input', () => {
        if (!input.value || input.value.length > 1) sync();
      });
    }
    if (form) {
      form.addEventListener('submit', event => {
        event.preventDefault();
        sync();
        syncUrl();
      });
    }
    if (clear) {
      clear.addEventListener('click', () => {
        checks.forEach(check => { check.checked = false; });
        if (minPrice) minPrice.value = '';
        if (maxPrice) maxPrice.value = '';
        if (input) input.value = '';
        sync();
        syncUrl();
      });
    }

    root.querySelectorAll('[data-oha-search-view]').forEach(button => {
      button.addEventListener('click', () => {
        const mode = button.dataset.ohaSearchView || 'grid';
        root.querySelectorAll('[data-oha-search-view]').forEach(item => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
        grid.classList.toggle('is-list', mode === 'list');
      });
    });

    root.querySelectorAll('[data-oha-search-favorite]').forEach(button => {
      button.addEventListener('click', () => {
        button.classList.toggle('is-active');
      });
    });

    sync();
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ohaInitSearchPro);
} else {
  ohaInitSearchPro();
}

function ohaInitCartPro(){
  document.querySelectorAll('[data-oha-cart-pro]').forEach(root => {
    if (root.dataset.ohaCartReady === 'true') return;
    root.dataset.ohaCartReady = 'true';

    const formatter = new Intl.NumberFormat('hu-HU');
    const baseTotal = Number(root.dataset.cartTotal || 0);
    const summaryTotal = root.querySelector('[data-oha-cart-estimated-total]');
    const shippingNode = root.querySelector('[data-oha-cart-shipping]');
    const couponInput = root.querySelector('[data-oha-cart-coupon-input]');
    const couponButton = root.querySelector('[data-oha-cart-coupon]');
    const checkoutButton = root.querySelector('[data-oha-cart-checkout]');
    const checks = Array.from(root.querySelectorAll('[data-oha-cart-check]'));
    let discount = 0;

    const datasetText = (key, fallback = '') => {
      const value = root.dataset[key];
      return typeof value === 'string' && value.trim() ? value : fallback;
    };
    const money = cents => `${formatter.format(Math.max(0, Math.round(Number(cents || 0) / 100)))} ${datasetText('ohaMoneyCurrency')}`.trim();
    const toast = text => {
      let node = document.querySelector('[data-oha-cart-toast]');
      if (!node) {
        node = document.createElement('div');
        node.className = 'oha-cart-pro__toast';
        node.dataset.ohaCartToast = 'true';
        document.body.appendChild(node);
      }
      node.textContent = text;
      node.classList.add('is-visible');
      window.clearTimeout(node._ohaTimer);
      node._ohaTimer = window.setTimeout(() => node.classList.remove('is-visible'), 1800);
    };

    const selectedAddonTotal = () => Array.from(root.querySelectorAll('[data-oha-cart-addon-card].is-selected'))
      .reduce((sum, card) => sum + Number(card.dataset.addonPrice || 0), 0);

    const selectedShipping = () => {
      const checked = root.querySelector('.oha-cart-pro__delivery-option input:checked');
      return checked ? Number(checked.dataset.shippingPrice || 0) : 0;
    };

    const syncChecks = () => {
      if (!checkoutButton || !checks.length) return;
      checkoutButton.disabled = !checks.every(check => check.checked);
    };

    const syncSummary = () => {
      const shipping = selectedShipping();
      const total = baseTotal + selectedAddonTotal() + shipping - discount;
      if (shippingNode) shippingNode.textContent = shipping ? money(shipping) : datasetText('ohaFreeShipping', '0');
      if (summaryTotal) summaryTotal.textContent = money(total);
      syncChecks();
    };

    root.querySelectorAll('[data-oha-cart-qty-minus], [data-oha-cart-qty-plus]').forEach(button => {
      button.addEventListener('click', () => {
        const wrap = button.closest('.oha-cart-pro__qty');
        const input = wrap ? wrap.querySelector('[data-oha-cart-qty]') : null;
        if (!input) return;
        const step = button.hasAttribute('data-oha-cart-qty-plus') ? 1 : -1;
        const min = Number(input.getAttribute('min') || 0);
        const maxAttr = input.getAttribute('max');
        const max = maxAttr ? Number(maxAttr) : Infinity;
        const next = Math.max(min, Math.min(max, Number(input.value || 0) + step));
        if (Number(input.value || 0) !== next) {
          input.value = String(next);
        } else if (step > 0 && Number.isFinite(max)) {
          toast(datasetText('ohaSoldOutToast', 'Készlethatár elérve.'));
        }
      });
    });

    root.querySelectorAll('[data-oha-cart-addon]').forEach(button => {
      button.addEventListener('click', async event => {
        event.preventDefault();
        const variantId = button.dataset.variantId;
        if (variantId) {
          button.disabled = true;
          const original = button.textContent;
          button.textContent = datasetText('ohaAddonLoadingText', original);
          try {
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: Number(variantId), quantity: 1 })
            });
            if (!response.ok) throw new Error('cart add failed');
            toast(datasetText('ohaAddonSuccessToast', 'Hozzáadva.'));
            window.setTimeout(() => window.location.reload(), 600);
            return;
          } catch (error) {
            button.disabled = false;
            button.textContent = original;
            toast(datasetText('ohaAddonErrorToast', 'Most nem adható hozzá.'));
            return;
          }
        }
        const card = button.closest('[data-oha-cart-addon-card]');
        if (!card) return;
        card.classList.toggle('is-selected');
        button.classList.toggle('is-selected', card.classList.contains('is-selected'));
        button.textContent = card.classList.contains('is-selected')
          ? datasetText('ohaAddonSelectedLabel', 'OK')
          : datasetText('ohaAddonDefaultLabel', '+');
        syncSummary();
      });
    });

    root.querySelectorAll('[data-oha-cart-bundle]').forEach(button => {
      button.addEventListener('click', () => {
        datasetText('ohaBundleAddonKeys', 'trafo,headshell,rca').split(/[\n,]+/).map(key => key.trim()).filter(Boolean).forEach(key => {
          const card = root.querySelector(`[data-oha-cart-addon-card][data-addon-key="${key}"]`);
          const addonButton = card ? card.querySelector('[data-oha-cart-addon]') : null;
          if (!card || addonButton?.dataset.variantId) return;
          card.classList.add('is-selected');
          addonButton.classList.add('is-selected');
          addonButton.textContent = datasetText('ohaAddonSelectedLabel', 'OK');
        });
        discount = Number(button.dataset.bundleDiscount || 0);
        toast(datasetText('ohaBundleSelectedToast', 'Csomag kijelölve.'));
        syncSummary();
      });
    });

    const quickTrafo = root.querySelector('[data-oha-cart-add-trafo]');
    if (quickTrafo) {
      quickTrafo.addEventListener('click', () => {
        const trafo = root.querySelector(`[data-oha-cart-addon-card][data-addon-key="${datasetText('ohaTransformerAddonKey', 'trafo')}"]`);
        const button = trafo ? trafo.querySelector('[data-oha-cart-addon]') : null;
        if (button && button.dataset.variantId) {
          button.click();
        } else if (button) {
          trafo.classList.add('is-selected');
          button.classList.add('is-selected');
          button.textContent = datasetText('ohaAddonSelectedLabel', 'OK');
          syncSummary();
          toast(datasetText('ohaTransformerSelectedToast', 'Kijelölve.'));
        } else if (trafo) {
          trafo.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }

    root.querySelectorAll('[data-oha-cart-delivery]').forEach(label => {
      label.addEventListener('click', () => {
        root.querySelectorAll('[data-oha-cart-delivery]').forEach(item => item.classList.remove('is-active'));
        label.classList.add('is-active');
        window.setTimeout(syncSummary, 0);
      });
    });

    if (couponButton && couponInput) {
      couponButton.addEventListener('click', () => {
        const code = String(couponInput.value || '').trim().toUpperCase();
        if (code && code === datasetText('ohaDemoCouponCode').toUpperCase()) {
          discount = Number(root.dataset.ohaDemoCouponDiscount || 0);
          toast(datasetText('ohaDemoCouponToast', 'Kedvezmény alkalmazva.'));
        } else if (code) {
          toast(datasetText('ohaCouponCheckoutToast', 'Fizetési ellenőrzés folyamatban.'));
        }
        syncSummary();
      });
    }

    checks.forEach(check => check.addEventListener('change', syncChecks));
    syncSummary();
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ohaInitCartPro);
} else {
  ohaInitCartPro();
}

function ohaInitPolicyPro(){
  document.querySelectorAll('[data-oha-policy-pro]').forEach(root => {
    if (root.dataset.ohaPolicyReady === 'true') return;
    root.dataset.ohaPolicyReady = 'true';

    const datasetText = (key, fallback = '') => String(root.dataset[key] || fallback);
    const toastNode = root.querySelector('[data-oha-policy-toast]');
    const toast = message => {
      if (!toastNode) return;
      toastNode.textContent = message || datasetText('copyFallbackToast', 'Művelet rögzítve.');
      toastNode.classList.add('is-visible');
      window.setTimeout(() => toastNode.classList.remove('is-visible'), 2200);
    };

    const docs = Array.from(root.querySelectorAll('[data-oha-policy-doc]'));
    const search = root.querySelector('[data-oha-policy-search]');
    const filters = Array.from(root.querySelectorAll('[data-oha-policy-filter]'));
    let activeFilter = 'all';
    const applyDocs = () => {
      const query = String(search ? search.value : '').trim().toLowerCase();
      docs.forEach(card => {
        const category = String(card.dataset.ohaPolicyCategory || '').toLowerCase();
        const tags = String(card.dataset.ohaPolicyTags || '').toLowerCase();
        const text = String(card.textContent || '').toLowerCase();
        const filterOk = activeFilter === 'all' || category === activeFilter || tags.includes(activeFilter);
        const searchOk = !query || text.includes(query) || tags.includes(query);
        card.hidden = !(filterOk && searchOk);
      });
    };
    if (search) search.addEventListener('input', applyDocs);
    filters.forEach(button => {
      button.addEventListener('click', () => {
        activeFilter = button.dataset.ohaPolicyFilter || 'all';
        filters.forEach(item => item.classList.toggle('is-active', item === button));
        applyDocs();
      });
    });

    const panelLinks = Array.from(root.querySelectorAll('[data-oha-policy-panel-link]'));
    const panels = Array.from(root.querySelectorAll('[data-oha-policy-panel]'));
    const activatePanel = handle => {
      if (!handle) return false;
      let found = false;
      panels.forEach(panel => {
        const active = panel.dataset.ohaPolicyPanel === handle;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
        if (active) found = true;
      });
      panelLinks.forEach(link => link.classList.toggle('is-active', link.dataset.ohaPolicyPanelLink === handle));
      return found;
    };
    panelLinks.forEach(link => {
      link.addEventListener('click', event => {
        event.preventDefault();
        const handle = link.dataset.ohaPolicyPanelLink || '';
        if (!activatePanel(handle)) return;
        history.replaceState(null, '', `#${handle}`);
        const details = root.querySelector('#policy-reszletek');
        if (details) details.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
    const hashHandle = window.location.hash.replace('#', '');
    if (hashHandle) activatePanel(hashHandle);

    root.querySelectorAll('[data-oha-policy-faq]').forEach(button => {
      button.addEventListener('click', () => {
        const details = button.closest('details');
        if (details) {
          requestAnimationFrame(() => details.classList.toggle('is-open', details.open));
          return;
        }
        const item = button.closest('article');
        const answer = item ? item.querySelector('div') : null;
        const open = item ? !item.classList.contains('is-open') : false;
        if (item) item.classList.toggle('is-open', open);
        if (answer) answer.hidden = !open;
      });
    });

    root.querySelectorAll('[data-oha-policy-copy]').forEach(button => {
      button.addEventListener('click', () => {
        toast(button.dataset.ohaPolicyCopy || datasetText('copyFallbackToast', 'Művelet rögzítve.'));
      });
    });

    const helpForm = root.querySelector('[data-oha-policy-help-form]');
    if (helpForm) {
      helpForm.addEventListener('submit', event => {
        event.preventDefault();
        const topic = helpForm.querySelector('[data-oha-policy-topic]');
        const email = helpForm.querySelector('[data-oha-policy-email]');
        const message = helpForm.querySelector('[data-oha-policy-message]');
        const ok = topic && topic.value && email && email.value && message && String(message.value || '').trim().length >= 8;
        if (!ok) {
          toast(datasetText('helpMissingToast', 'Kérlek, töltsd ki a témát, az e-mail-címet és a rövid kérdést.'));
          return;
        }
        toast(datasetText('helpSuccessToast', 'Kérdésedet rögzítettük; hamarosan jelentkezünk.'));
        helpForm.reset();
      });
    }

    root.querySelectorAll('a[href^="#"]').forEach(link => {
      link.addEventListener('click', () => {
        const handle = link.getAttribute('href').replace('#', '');
        activatePanel(handle);
      });
    });

    applyDocs();
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ohaInitPolicyPro);
} else {
  ohaInitPolicyPro();
}

function ohaInitClosedAuctions(){
  document.querySelectorAll('[data-oha-closed-auctions]').forEach(root => {
    if (root.dataset.ohaClosedReady === 'true') return;
    root.dataset.ohaClosedReady = 'true';

    const cards = Array.from(root.querySelectorAll('[data-oha-closed-item]'));
    const rows = Array.from(root.querySelectorAll('[data-oha-closed-row]'));
    const grid = root.querySelector('[data-oha-closed-grid]');
    const table = root.querySelector('[data-oha-closed-table]');
    const tbody = root.querySelector('[data-oha-closed-tbody]');
    const countNode = root.querySelector('[data-oha-closed-count]');
    const empty = root.querySelector('[data-oha-closed-empty]');
    const search = root.querySelector('[data-oha-closed-search]');
    const category = root.querySelector('[data-oha-closed-category]');
    const brand = root.querySelector('[data-oha-closed-brand]');
    const voltage = root.querySelector('[data-oha-closed-voltage]');
    const sort = root.querySelector('[data-oha-closed-sort]');
    const drawer = root.querySelector('[data-oha-closed-drawer]');
    const toastNode = root.querySelector('[data-oha-closed-toast]');

    const datasetText = (key, fallback = '') => {
      const value = root.dataset[key];
      return typeof value === 'string' && value.trim() ? value : fallback;
    };
    const normalize = value => String(value || '').toLocaleLowerCase('hu-HU').trim();
    const toast = message => {
      if (!toastNode) return;
      toastNode.textContent = message || datasetText('ohaToastDefault', 'Művelet rögzítve.');
      toastNode.classList.add('is-visible');
      window.clearTimeout(root.ohaClosedToastTimer);
      root.ohaClosedToastTimer = window.setTimeout(() => toastNode.classList.remove('is-visible'), 2200);
    };

    const readFilters = () => ({
      query: normalize(search ? search.value : ''),
      category: category ? category.value : 'all',
      brand: brand ? brand.value : 'all',
      voltage: voltage ? voltage.value : 'all'
    });

    const matches = (item, filters) => {
      const haystack = normalize([
        item.dataset.title,
        item.dataset.brand,
        item.dataset.category,
        item.dataset.voltage
      ].join(' '));
      const queryOk = !filters.query || haystack.includes(filters.query);
      const categoryOk = filters.category === 'all' || item.dataset.category === filters.category;
      const brandOk = filters.brand === 'all' || item.dataset.brand === filters.brand;
      const voltageOk = filters.voltage === 'all' || item.dataset.voltage === filters.voltage;
      return queryOk && categoryOk && brandOk && voltageOk;
    };

    const compareItems = (a, b) => {
      const mode = sort ? sort.value : 'date';
      if (mode === 'price-desc') return Number(b.dataset.price || 0) - Number(a.dataset.price || 0);
      if (mode === 'price-asc') return Number(a.dataset.price || 0) - Number(b.dataset.price || 0);
      if (mode === 'bids-desc') return Number(b.dataset.bids || 0) - Number(a.dataset.bids || 0);
      return Number(a.dataset.index || 0) - Number(b.dataset.index || 0);
    };

    const reorder = () => {
      if (grid) cards.slice().sort(compareItems).forEach(card => grid.appendChild(card));
      if (tbody) rows.slice().sort(compareItems).forEach(row => tbody.appendChild(row));
    };

    const applyFilters = () => {
      reorder();
      const filters = readFilters();
      let visible = 0;
      cards.forEach(card => {
        const ok = matches(card, filters);
        card.hidden = !ok;
        if (ok) visible += 1;
      });
      rows.forEach(row => {
        row.hidden = !matches(row, filters);
      });
      if (countNode) {
        const template = countNode.dataset.countTemplate || datasetText('ohaResultTemplateFallback', '{count} archív tétel');
        countNode.textContent = template.replace('{count}', String(visible));
      }
      if (empty) empty.hidden = visible !== 0;
    };

    const setView = mode => {
      if (grid) grid.hidden = mode !== 'grid';
      if (table) table.hidden = mode !== 'table';
      root.querySelectorAll('[data-oha-closed-view]').forEach(button => {
        const active = button.dataset.ohaClosedView === mode;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
    };

    const resetQuickState = activeButton => {
      root.querySelectorAll('[data-oha-closed-quick]').forEach(button => {
        button.classList.toggle('is-active', button === activeButton);
      });
    };

    [search, category, brand, voltage, sort].forEach(control => {
      if (!control) return;
      control.addEventListener(control === search ? 'input' : 'change', applyFilters);
    });

    root.querySelectorAll('[data-oha-closed-view]').forEach(button => {
      button.addEventListener('click', () => setView(button.dataset.ohaClosedView || 'grid'));
    });

    root.querySelectorAll('[data-oha-closed-quick]').forEach(button => {
      button.addEventListener('click', () => {
        const value = button.dataset.ohaClosedQuick || 'all';
        const field = button.dataset.ohaClosedQuickField || (value === 'all' ? 'all' : 'category');
        if (search) search.value = '';
        if (brand) brand.value = 'all';
        if (category) category.value = 'all';
        if (voltage) voltage.value = 'all';
        if (field === 'brand' && brand) {
          brand.value = value;
        } else if (field === 'voltage' && voltage) {
          voltage.value = value;
        } else if (field === 'category' && category) {
          category.value = value;
        }
        resetQuickState(button);
        applyFilters();
      });
    });

    const fill = (selector, value) => {
      const node = drawer ? drawer.querySelector(selector) : null;
      if (node) node.textContent = value || '';
    };

    const openDrawer = source => {
      if (!drawer || !source) return;
      const titleNode = source.querySelector('h3, td strong');
      fill('[data-oha-closed-drawer-title]', titleNode ? titleNode.textContent : '');
      fill('[data-oha-closed-drawer-subtitle]', source.dataset.subtitle);
      fill('[data-oha-closed-drawer-price]', source.dataset.displayPrice);
      fill('[data-oha-closed-drawer-bids]', `${source.dataset.bids || '0'} ${datasetText('ohaBidSuffix', 'licit')}`);
      fill('[data-oha-closed-drawer-close-date]', source.dataset.close);
      fill('[data-oha-closed-drawer-condition]', source.dataset.condition);
      fill('[data-oha-closed-drawer-voltage]', source.dataset.voltage);
      fill('[data-oha-closed-drawer-winner]', source.dataset.winner);
      fill('[data-oha-closed-drawer-duration]', source.dataset.duration);
      drawer.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      const close = drawer.querySelector('[data-oha-closed-drawer-close]');
      if (close) close.focus();
    };

    const closeDrawer = () => {
      if (!drawer) return;
      drawer.hidden = true;
      drawer.setAttribute('aria-hidden', 'true');
    };

    root.querySelectorAll('[data-oha-closed-detail]').forEach(button => {
      button.addEventListener('click', () => {
        openDrawer(button.closest('[data-oha-closed-item], [data-oha-closed-row]'));
      });
    });

    root.querySelectorAll('[data-oha-closed-drawer-close]').forEach(button => {
      button.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && drawer && !drawer.hidden) closeDrawer();
    });

    root.querySelectorAll('[data-oha-closed-favorite]').forEach(button => {
      button.addEventListener('click', () => {
        const active = !button.classList.contains('is-active');
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
        toast(active ? datasetText('ohaFavoriteAddToast', 'Figyelés frissítve.') : datasetText('ohaFavoriteRemoveToast', 'Figyelés frissítve.'));
      });
    });

    root.querySelectorAll('[data-oha-closed-faq]').forEach(button => {
      button.addEventListener('click', () => {
        const item = button.closest('article');
        const answer = item ? item.querySelector('div') : null;
        const open = item ? !item.classList.contains('is-open') : false;
        if (item) item.classList.toggle('is-open', open);
        if (answer) answer.hidden = !open;
        button.setAttribute('aria-expanded', String(open));
      });
    });

    const watchForm = root.querySelector('[data-oha-closed-watch-form]');
    if (watchForm) {
      watchForm.addEventListener('submit', event => {
        event.preventDefault();
        const name = watchForm.querySelector('[name="name"]');
        const email = watchForm.querySelector('[name="email"]');
        const nameOk = Boolean(name && String(name.value || '').trim());
        const emailOk = Boolean(email && email.checkValidity());
        if (!nameOk || !emailOk) {
          toast(datasetText('ohaWatchInvalid', 'Hiányzó kötelező adat.'));
          const focusTarget = !nameOk ? name : email;
          if (focusTarget) {
            focusTarget.focus();
            window.setTimeout(() => focusTarget.focus(), 30);
          }
          return;
        }
        const message = root.querySelector('[data-oha-closed-message]');
        if (message) message.hidden = false;
        toast(datasetText('ohaWatchSubmitToast', 'Kérés rögzítve.'));
        watchForm.reset();
      });
    }

    setView('grid');
    applyFilters();
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ohaInitClosedAuctions);
} else {
  ohaInitClosedAuctions();
}

function ohaInitTestingPro(){
  document.querySelectorAll('[data-oha-test-pro]').forEach(root => {
    if (root.dataset.ohaTestReady === 'true') return;
    root.dataset.ohaTestReady = 'true';

    const stepLinks = Array.from(root.querySelectorAll('[data-oha-test-step-link]'));
    const steps = Array.from(root.querySelectorAll('[data-oha-test-step]'));
    let manualStepLock = false;

    const setActiveStep = handle => {
      if (!handle) return;
      stepLinks.forEach(link => {
        const active = link.dataset.ohaTestStepLink === handle;
        link.classList.toggle('is-active', active);
        link.setAttribute('aria-pressed', String(active));
      });
      steps.forEach(step => {
        step.classList.toggle('is-active', step.dataset.ohaTestStep === handle);
      });
    };
    const visibleHashStep = () => {
      const handle = window.location.hash.replace('#', '');
      if (!handle) return '';
      const target = steps.find(step => step.dataset.ohaTestStep === handle);
      if (!target) return '';
      const rect = target.getBoundingClientRect();
      const visible = rect.bottom > 120 && rect.top < window.innerHeight - 120;
      return visible ? handle : '';
    };

    stepLinks.forEach(link => {
      link.addEventListener('click', () => {
        const handle = link.dataset.ohaTestStepLink || '';
        const target = steps.find(step => step.dataset.ohaTestStep === handle);
        if (!target) return;
        manualStepLock = true;
        setActiveStep(handle);
        if (handle) history.replaceState(null, '', `#${handle}`);
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        window.setTimeout(() => setActiveStep(handle), 80);
        window.setTimeout(() => setActiveStep(handle), 620);
        window.setTimeout(() => {
          setActiveStep(handle);
          manualStepLock = false;
        }, 1400);
      });
    });

    if ('IntersectionObserver' in window && steps.length) {
      const observer = new IntersectionObserver(entries => {
        if (manualStepLock) return;
        const hashHandle = visibleHashStep();
        if (hashHandle) {
          setActiveStep(hashHandle);
          return;
        }
        const visible = entries
          .filter(entry => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (visible && visible.target) {
          setActiveStep(visible.target.dataset.ohaTestStep || '');
        }
      }, { rootMargin: '-28% 0px -55% 0px', threshold: [0.2, 0.45, 0.7] });
      steps.forEach(step => observer.observe(step));
    }

    const hashHandle = window.location.hash.replace('#', '');
    if (hashHandle && steps.some(step => step.dataset.ohaTestStep === hashHandle)) {
      setActiveStep(hashHandle);
    } else if (stepLinks[0]) {
      setActiveStep(stepLinks[0].dataset.ohaTestStepLink || '');
    }

    const tabs = Array.from(root.querySelectorAll('[data-oha-test-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-oha-test-panel]'));
    const setActivePanel = handle => {
      if (!handle) return;
      tabs.forEach(tab => {
        const active = tab.dataset.ohaTestTab === handle;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
      });
      panels.forEach(panel => {
        panel.hidden = panel.dataset.ohaTestPanel !== handle;
      });
    };

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        setActivePanel(tab.dataset.ohaTestTab || '');
      });
    });
    const initialTab = tabs.find(tab => tab.classList.contains('is-active')) || tabs[0];
    if (initialTab) setActivePanel(initialTab.dataset.ohaTestTab || '');

    const device = root.querySelector('[data-oha-test-device]');
    const reset = root.querySelector('[data-oha-test-reset]');
    const tasks = Array.from(root.querySelectorAll('[data-oha-test-task]'));
    const meter = root.querySelector('[data-oha-test-meter]');
    const progress = root.querySelector('[data-oha-test-progress]');
    const percentNode = root.querySelector('[data-oha-test-percent]');
    const titleNode = root.querySelector('[data-oha-test-meter-title]');
    const textNode = root.querySelector('[data-oha-test-meter-text]');

    const progressText = state => {
      const key = state === 'full' ? 'full' : state === 'partial' ? 'partial' : 'empty';
      return {
        title: progress ? progress.dataset[`${key}Title`] : '',
        text: progress ? progress.dataset[`${key}Text`] : ''
      };
    };
    const progressLabelText = percent => {
      const template = progress ? progress.dataset.progressLabelTemplate : '';
      return String(template || '{percent}%').replaceAll('{percent}', String(percent));
    };

    const updateProgress = () => {
      const visibleTasks = tasks.filter(task => !task.hidden);
      const checked = visibleTasks.filter(task => {
        const input = task.querySelector('input[type="checkbox"]');
        return input && input.checked;
      }).length;
      const percent = visibleTasks.length ? Math.round((checked / visibleTasks.length) * 100) : 0;
      if (meter) meter.style.setProperty('--oha-test-progress', `${percent}%`);
      if (percentNode) percentNode.textContent = progressLabelText(percent);
      const state = percent === 100 ? 'full' : percent > 0 ? 'partial' : 'empty';
      const copy = progressText(state);
      if (titleNode && copy.title) titleNode.textContent = copy.title;
      if (textNode && copy.text) textNode.textContent = copy.text;
    };

    const syncTasks = resetChecked => {
      const selected = device ? device.value : 'turntable';
      tasks.forEach(task => {
        const input = task.querySelector('input[type="checkbox"]');
        task.hidden = task.dataset.category !== selected;
        if (resetChecked && input) input.checked = false;
      });
      updateProgress();
    };

    if (device) {
      device.addEventListener('change', () => syncTasks(true));
    }
    if (reset) {
      reset.addEventListener('click', () => syncTasks(true));
    }
    tasks.forEach(task => {
      const input = task.querySelector('input[type="checkbox"]');
      if (input) input.addEventListener('change', updateProgress);
    });
    syncTasks(true);

    root.querySelectorAll('[data-oha-test-faq]').forEach(button => {
      button.addEventListener('click', () => {
        const item = button.closest('article');
        const answer = item ? item.querySelector('div') : null;
        const open = item ? !item.classList.contains('is-open') : false;
        if (item) item.classList.toggle('is-open', open);
        if (answer) answer.hidden = !open;
        button.setAttribute('aria-expanded', String(open));
      });
    });
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ohaInitTestingPro);
} else {
  ohaInitTestingPro();
}

function ohaInitConditionPro(){
  document.querySelectorAll('[data-oha-condition-pro]').forEach(root => {
    if (root.dataset.ohaConditionReady === 'true') return;
    root.dataset.ohaConditionReady = 'true';

    const datasetText = (key, fallback = '') => String(root.dataset[key] || fallback);
    const stateCards = Array.from(root.querySelectorAll('[data-oha-cond-state]'));
    const conditionSelect = root.querySelector('[data-oha-cond-select]');
    const deviceSelect = root.querySelector('[data-oha-cond-device]');
    const chips = Array.from(root.querySelectorAll('[data-oha-cond-flag]'));
    const note = root.querySelector('[data-oha-cond-note]');
    const previewTitle = root.querySelector('[data-oha-cond-preview-title]');
    const previewText = root.querySelector('[data-oha-cond-preview-text]');
    const buyerMessage = root.querySelector('[data-oha-cond-buyer]');
    const badges = root.querySelector('[data-oha-cond-badges]');
    const riskBox = root.querySelector('[data-oha-cond-risk]');
    const feedback = root.querySelector('[data-oha-cond-feedback]');
    const previewMedia = root.querySelector('.oha-cond-preview__media [role="img"]');
    const deviceMeta = Array.from(root.querySelectorAll('[data-oha-cond-device-meta]'));

    const readState = card => ({
      key: card ? card.dataset.ohaCondState || '' : '',
      label: card ? card.dataset.label || card.textContent.trim() : '',
      tone: card ? card.dataset.tone || 'gold' : 'gold',
      message: card ? card.dataset.message || '' : '',
      risk: card ? card.dataset.risk || 'ok' : 'ok'
    });

    const addBadge = (label, tone) => {
      if (!badges || !label) return;
      const badge = document.createElement('span');
      badge.className = `oha-cond-pill oha-cond-pill--${tone || 'gold'}`;
      badge.textContent = label;
      badges.appendChild(badge);
    };

    const currentStateCard = () => {
      const selected = conditionSelect ? conditionSelect.value : '';
      return stateCards.find(card => card.dataset.ohaCondState === selected) || stateCards.find(card => card.classList.contains('is-active')) || stateCards[0] || null;
    };

    const currentDeviceMeta = () => {
      const selected = deviceSelect ? deviceSelect.value : '';
      return deviceMeta.find(item => item.dataset.ohaCondDeviceMeta === selected) || deviceMeta[0] || null;
    };

    const activeChips = () => chips.filter(chip => chip.classList.contains('is-active'));

    const updatePreview = () => {
      const state = readState(currentStateCard());
      const meta = currentDeviceMeta();
      if (conditionSelect && state.key && conditionSelect.value !== state.key) {
        conditionSelect.value = state.key;
      }
      if (previewTitle && meta) {
        previewTitle.textContent = meta.dataset.title || previewTitle.textContent;
      }
      if (previewMedia && meta) {
        const image = meta.dataset.image || '';
        const alt = meta.dataset.alt || '';
        if (image) root.style.setProperty('--oha-cond-preview', `url("${image.replace(/"/g, '\\"')}")`);
        if (alt) previewMedia.setAttribute('aria-label', alt);
      }
      if (previewText) {
        previewText.textContent = note && note.value ? note.value : 'Rövid állapotmegjegyzés hiányzik.';
      }
      if (buyerMessage && state.message) {
        buyerMessage.textContent = state.message;
      }
      if (badges) {
        badges.innerHTML = '';
        addBadge(state.label, state.tone);
        activeChips().forEach(chip => addBadge(chip.dataset.label || chip.textContent.trim(), chip.dataset.tone || 'gold'));
      }
      if (riskBox) {
        const flagRisk = activeChips().map(chip => chip.dataset.riskText || '').filter(Boolean);
        const warn = state.risk === 'warn' || activeChips().some(chip => (chip.dataset.tone || '') === 'red');
        riskBox.textContent = flagRisk.length ? flagRisk.join(' ') : 'Nincs külön kockázati jelzés, de az állapotlap továbbra is szükséges.';
        riskBox.classList.toggle('oha-cond-risk--warn', warn);
        riskBox.classList.toggle('oha-cond-risk--ok', !warn);
      }
    };

    const setCondition = key => {
      if (!key) return;
      stateCards.forEach(card => {
        const active = card.dataset.ohaCondState === key;
        card.classList.toggle('is-active', active);
        card.setAttribute('aria-pressed', String(active));
      });
      if (conditionSelect && conditionSelect.value !== key) {
        conditionSelect.value = key;
      }
      updatePreview();
    };

    stateCards.forEach(card => {
      card.setAttribute('aria-pressed', String(card.classList.contains('is-active')));
      card.addEventListener('click', () => {
        setCondition(card.dataset.ohaCondState || '');
        const generator = root.querySelector('#generator');
        if (generator) generator.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    if (conditionSelect) {
      conditionSelect.addEventListener('change', () => setCondition(conditionSelect.value));
    }
    if (deviceSelect) {
      deviceSelect.addEventListener('change', updatePreview);
    }
    if (note) {
      note.addEventListener('input', updatePreview);
    }

    chips.forEach(chip => {
      chip.setAttribute('aria-pressed', String(chip.classList.contains('is-active')));
      chip.addEventListener('click', () => {
        const active = !chip.classList.contains('is-active');
        chip.classList.toggle('is-active', active);
        chip.setAttribute('aria-pressed', String(active));
        updatePreview();
      });
    });

    const tabs = Array.from(root.querySelectorAll('[data-oha-cond-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-oha-cond-panel]'));
    const setPanel = handle => {
      if (!handle) return;
      tabs.forEach(tab => {
        const active = tab.dataset.ohaCondTab === handle;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
      });
      panels.forEach(panel => {
        panel.hidden = panel.dataset.ohaCondPanel !== handle;
      });
    };
    tabs.forEach(tab => {
      tab.addEventListener('click', () => setPanel(tab.dataset.ohaCondTab || ''));
    });
    const firstTab = tabs.find(tab => tab.classList.contains('is-active')) || tabs[0];
    if (firstTab) setPanel(firstTab.dataset.ohaCondTab || '');

    if (feedback) {
      feedback.setAttribute('aria-live', 'polite');
    }
    const copyButton = root.querySelector('[data-oha-cond-copy]');
    if (copyButton && feedback) {
      copyButton.addEventListener('click', () => {
        feedback.textContent = datasetText('copyFeedbackText', 'Állapotkártya-szöveg előkészítve a termékadatlaphoz.');
        feedback.classList.add('is-success');
      });
    }

    root.querySelectorAll('[data-oha-cond-faq]').forEach(button => {
      button.addEventListener('click', () => {
        const item = button.closest('article');
        const answer = item ? item.querySelector('div') : null;
        const open = item ? !item.classList.contains('is-open') : false;
        if (item) item.classList.toggle('is-open', open);
        if (answer) answer.hidden = !open;
        button.setAttribute('aria-expanded', String(open));
      });
    });

    setCondition(conditionSelect && conditionSelect.value ? conditionSelect.value : (stateCards[0] ? stateCards[0].dataset.ohaCondState || '' : ''));
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ohaInitConditionPro);
} else {
  ohaInitConditionPro();
}

function ohaInitTurntableGuide(){
  document.querySelectorAll('[data-oha-turntable-guide]').forEach(root => {
    if (root.dataset.ohaTurntableReady === 'true') return;
    root.dataset.ohaTurntableReady = 'true';

    const makePill = label => {
      const pill = document.createElement('span');
      pill.textContent = label;
      return pill;
    };

    const profileButtons = Array.from(root.querySelectorAll('[data-oha-tt-profile]'));
    const profileTags = root.querySelector('[data-oha-tt-profile-tags]');
    const profileTitle = root.querySelector('[data-oha-tt-profile-title]');
    const profileText = root.querySelector('[data-oha-tt-profile-text]');
    const setProfile = button => {
      if (!button) return;
      profileButtons.forEach(item => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      if (profileTags) {
        profileTags.innerHTML = '';
        profileTags.appendChild(makePill('Ajánlott irány'));
        (button.dataset.tags || '').split('|').map(tag => tag.trim()).filter(Boolean).forEach(tag => {
          profileTags.appendChild(makePill(tag));
        });
      }
      if (profileTitle && button.dataset.title) profileTitle.textContent = button.dataset.title;
      if (profileText && button.dataset.text) profileText.textContent = button.dataset.text;
    };
    profileButtons.forEach(button => button.addEventListener('click', () => setProfile(button)));
    setProfile(profileButtons.find(button => button.classList.contains('is-active')) || profileButtons[0]);

    const partButtons = Array.from(root.querySelectorAll('[data-oha-tt-part]'));
    const partTitle = root.querySelector('[data-oha-tt-part-title]');
    const partText = root.querySelector('[data-oha-tt-part-text]');
    const setPart = button => {
      if (!button) return;
      partButtons.forEach(item => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      if (partTitle && button.dataset.title) partTitle.textContent = button.dataset.title;
      if (partText && button.dataset.text) partText.textContent = button.dataset.text;
    };
    partButtons.forEach(button => button.addEventListener('click', () => setPart(button)));
    setPart(partButtons.find(button => button.classList.contains('is-active')) || partButtons[0]);

    const tabs = Array.from(root.querySelectorAll('[data-oha-tt-check-tab]'));
    const tasks = Array.from(root.querySelectorAll('[data-oha-tt-task]'));
    const checkTitle = root.querySelector('[data-oha-tt-check-title]');
    const progressPanel = root.querySelector('.oha-tt-check-panel');
    const progressLabel = root.querySelector('[data-oha-tt-progress-label]');
    const progressBar = root.querySelector('[data-oha-tt-progress-bar]');
    const progressResult = root.querySelector('[data-oha-tt-progress-result]');

    const progressLabelText = percent => {
      const template = progressPanel ? progressPanel.dataset.progressLabelTemplate : '';
      return (template || '{percent}% kész').replace(/\{percent\}/g, String(percent));
    };

    const progressCopy = percent => {
      if (!progressPanel) return { title: 'Állapot:', text: '' };
      if (percent === 0) {
        return { title: progressPanel.dataset.emptyTitle || 'Állapot:', text: progressPanel.dataset.emptyText || '' };
      }
      if (percent < 40) {
        return { title: progressPanel.dataset.lowTitle || 'Állapot:', text: progressPanel.dataset.lowText || progressPanel.dataset.partialText || '' };
      }
      if (percent < 80) {
        return { title: progressPanel.dataset.partialTitle || 'Állapot:', text: progressPanel.dataset.partialText || '' };
      }
      return { title: progressPanel.dataset.fullTitle || 'Állapot:', text: progressPanel.dataset.fullText || '' };
    };

    const updateProgress = () => {
      const visibleTasks = tasks.filter(task => !task.hidden);
      const done = visibleTasks.filter(task => {
        const input = task.querySelector('input[type="checkbox"]');
        return input && input.checked;
      }).length;
      const percent = visibleTasks.length ? Math.round((done / visibleTasks.length) * 100) : 0;
      if (progressBar) progressBar.style.width = `${percent}%`;
      if (progressLabel) progressLabel.textContent = progressLabelText(percent);
      if (progressResult) {
        const copy = progressCopy(percent);
        progressResult.innerHTML = '';
        const strong = document.createElement('strong');
        const span = document.createElement('span');
        strong.textContent = copy.title;
        span.textContent = copy.text;
        progressResult.append(strong, span);
      }
    };

    const setTab = tab => {
      if (!tab) return;
      const key = tab.dataset.ohaTtCheckTab || '';
      tabs.forEach(item => {
        const active = item === tab;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', String(active));
      });
      if (checkTitle && tab.dataset.title) checkTitle.textContent = tab.dataset.title;
      tasks.forEach(task => {
        const input = task.querySelector('input[type="checkbox"]');
        task.hidden = task.dataset.category !== key;
        if (input) input.checked = false;
      });
      updateProgress();
    };
    tabs.forEach(tab => tab.addEventListener('click', () => setTab(tab)));
    tasks.forEach(task => {
      const input = task.querySelector('input[type="checkbox"]');
      if (input) input.addEventListener('change', updateProgress);
    });
    setTab(tabs.find(tab => tab.classList.contains('is-active')) || tabs[0]);

    root.querySelectorAll('[data-oha-tt-faq]').forEach(button => {
      button.addEventListener('click', () => {
        const item = button.closest('article');
        const answer = item ? item.querySelector('div') : null;
        const open = item ? !item.classList.contains('is-open') : false;
        if (item) item.classList.toggle('is-open', open);
        if (answer) answer.hidden = !open;
        button.setAttribute('aria-expanded', String(open));
      });
    });
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ohaInitTurntableGuide);
} else {
  ohaInitTurntableGuide();
}

function ohaInitAmplifierChecklist(){
  document.querySelectorAll('[data-oha-amplifier-checklist]').forEach(root => {
    if (root.dataset.ohaAmpReady === 'true') return;
    root.dataset.ohaAmpReady = 'true';

    const decisionButtons = Array.from(root.querySelectorAll('[data-oha-amp-decision]'));
    const decisionNote = root.querySelector('[data-oha-amp-decision-note]');
    const setDecision = button => {
      if (!button) return;
      decisionButtons.forEach(item => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      if (decisionNote && button.dataset.note) decisionNote.textContent = button.dataset.note;
    };
    decisionButtons.forEach(button => button.addEventListener('click', () => setDecision(button)));
    setDecision(decisionButtons.find(button => button.classList.contains('is-active')) || decisionButtons[0]);

    const checks = Array.from(root.querySelectorAll('.oha-amp-check-item input[type="checkbox"]'));
    const meter = root.querySelector('[data-oha-amp-score]');
    const bar = root.querySelector('[data-oha-amp-progress-bar]');
    const progressText = root.querySelector('[data-oha-amp-progress-text]');
    const progressPanel = root.querySelector('.oha-amp-meter');
    const scoreText = percent => String(progressPanel?.dataset.scoreTemplate || '{percent}%').replaceAll('{percent}', String(percent));
    const updateChecklist = () => {
      const done = checks.filter(input => input.checked).length;
      const percent = checks.length ? Math.round((done / checks.length) * 100) : 0;
      if (meter) meter.textContent = scoreText(percent);
      if (bar) bar.style.width = `${percent}%`;
      if (progressText && progressPanel) {
        let copy = progressPanel.dataset.empty || '';
        if (percent > 0 && percent < 50) copy = progressPanel.dataset.low || copy;
        if (percent >= 50 && percent < 100) copy = progressPanel.dataset.mid || copy;
        if (percent === 100) copy = progressPanel.dataset.full || copy;
        progressText.textContent = copy;
      }
    };
    checks.forEach(input => input.addEventListener('change', updateChecklist));
    updateChecklist();

    const powerSelect = root.querySelector('[data-oha-amp-power]');
    const marginSelect = root.querySelector('[data-oha-amp-margin]');
    const calcButton = root.querySelector('[data-oha-amp-calc]');
    const calcResult = root.querySelector('[data-oha-amp-calc-result]');
    if (calcButton && calcResult) {
      calcButton.addEventListener('click', () => {
        const power = Number(powerSelect && powerSelect.value ? powerSelect.value : 0);
        const margin = Number(marginSelect && marginSelect.value ? marginSelect.value : 1.5);
        const need = Math.ceil(power * margin);
        let recommendation = calcResult.dataset.tierLow || '500W';
        if (need > 500 && need <= 1000) recommendation = calcResult.dataset.tierMid || recommendation;
        if (need > 1000) recommendation = calcResult.dataset.tierHigh || recommendation;
        const template = calcResult.dataset.resultTemplate || '{need}W · {recommendation}';
        calcResult.innerHTML = template
          .replaceAll('{need}', String(need))
          .replaceAll('{recommendation}', recommendation);
      });
    }

    const tabs = Array.from(root.querySelectorAll('[data-oha-amp-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-oha-amp-panel]'));
    const setTab = tab => {
      if (!tab) return;
      const key = tab.dataset.ohaAmpTab || '';
      tabs.forEach(item => {
        const active = item === tab;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', String(active));
      });
      panels.forEach(panel => {
        panel.hidden = panel.dataset.ohaAmpPanel !== key;
      });
    };
    tabs.forEach(tab => tab.addEventListener('click', () => setTab(tab)));
    setTab(tabs.find(tab => tab.classList.contains('is-active')) || tabs[0]);

    root.querySelectorAll('[data-oha-amp-faq]').forEach(button => {
      button.addEventListener('click', () => {
        const item = button.closest('article');
        const answer = item ? item.querySelector('div') : null;
        const open = item ? !item.classList.contains('is-open') : false;
        if (item) item.classList.toggle('is-open', open);
        if (answer) answer.hidden = !open;
        button.setAttribute('aria-expanded', String(open));
      });
    });
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ohaInitAmplifierChecklist);
} else {
  ohaInitAmplifierChecklist();
}

function ohaInitPackingGuide(){
  document.querySelectorAll('[data-oha-packing-guide]').forEach(root => {
    if (root.dataset.ohaPackReady === 'true') return;
    root.dataset.ohaPackReady = 'true';

    const stepButtons = Array.from(root.querySelectorAll('[data-oha-pack-step-nav]'));
    const steps = Array.from(root.querySelectorAll('[data-oha-pack-step]'));
    const setStep = button => {
      if (!button) return;
      const key = button.dataset.ohaPackStepNav || '';
      stepButtons.forEach(item => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      steps.forEach(step => step.classList.toggle('is-active', step.dataset.ohaPackStep === key));
    };
    stepButtons.forEach(button => {
      button.addEventListener('click', () => {
        setStep(button);
        const target = root.querySelector(`[data-oha-pack-step="${button.dataset.ohaPackStepNav || ''}"]`);
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
    setStep(stepButtons.find(button => button.classList.contains('is-active')) || stepButtons[0]);

    const tabs = Array.from(root.querySelectorAll('[data-oha-pack-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-oha-pack-panel]'));
    const setTab = tab => {
      if (!tab) return;
      const key = tab.dataset.ohaPackTab || '';
      tabs.forEach(item => {
        const active = item === tab;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', String(active));
      });
      panels.forEach(panel => {
        panel.hidden = panel.dataset.ohaPackPanel !== key;
      });
    };
    tabs.forEach(tab => tab.addEventListener('click', () => setTab(tab)));
    setTab(tabs.find(tab => tab.classList.contains('is-active')) || tabs[0]);

    const device = root.querySelector('[data-oha-pack-device]');
    const value = root.querySelector('[data-oha-pack-value]');
    const country = root.querySelector('[data-oha-pack-country]');
    const mode = root.querySelector('[data-oha-pack-mode]');
    const is100v = root.querySelector('[data-oha-pack-100v]');
    const fragilePart = root.querySelector('[data-oha-pack-fragile]');
    const hasCartridge = root.querySelector('[data-oha-pack-cartridge]');
    const grade = root.querySelector('[data-oha-pack-grade]');
    const bar = root.querySelector('[data-oha-pack-bar]');
    const text = root.querySelector('[data-oha-pack-text]');
    const price = root.querySelector('[data-oha-pack-price]');
    const upsell = root.querySelector('[data-oha-pack-upsell]');
    const datasetText = (key, fallback = '') => {
      const value = root.dataset[key];
      return typeof value === 'string' && value.trim() ? value : fallback;
    };
    const attributeText = (name, fallback = '') => {
      const value = root.getAttribute(name);
      return typeof value === 'string' && value.trim() ? value : fallback;
    };
    const updateCalc = () => {
      let score = 38;
      if (device && ['turntable', 'reel', 'tube', 'speaker'].includes(device.value)) score += 16;
      if (value && value.value === 'high') score += 14;
      if (value && value.value === 'premium') score += 24;
      if (country && country.value === 'near') score += 8;
      if (country && country.value === 'eu') score += 16;
      if (mode && mode.value === 'pickup') score -= 22;
      if (is100v && is100v.checked) score += 6;
      if (fragilePart && fragilePart.checked) score += 14;
      if (hasCartridge && hasCartridge.checked) score += 8;
      score = Math.max(20, Math.min(100, score));

      let label = datasetText('ohaPackStandardLabel');
      let priceCopy = datasetText('ohaPackStandardPrice');
      let message = datasetText('ohaPackStandardText');
      if (score >= 55) {
        label = datasetText('ohaPackPremiumLabel');
        priceCopy = datasetText('ohaPackPremiumPrice');
        message = datasetText('ohaPackPremiumText');
      }
      if (score >= 78) {
        label = datasetText('ohaPackEliteLabel');
        priceCopy = datasetText('ohaPackElitePrice');
        message = datasetText('ohaPackEliteText');
      }
      if (mode && mode.value === 'pickup') {
        label = datasetText('ohaPackPickupLabel');
        priceCopy = datasetText('ohaPackPickupPrice');
        message = datasetText('ohaPackPickupText');
      }

      const tips = [];
      if (is100v && is100v.checked) {
        tips.push(datasetText('ohaPackTipOneHundredV', attributeText('data-oha-pack-tip-100v')));
      }
      if (hasCartridge && hasCartridge.checked) tips.push(datasetText('ohaPackTipCartridge'));
      if (fragilePart && fragilePart.checked) tips.push(datasetText('ohaPackTipFragile'));
      if (!tips.filter(Boolean).length) tips.push(datasetText('ohaPackTipDefault'));

      if (bar) bar.style.width = `${score}%`;
      if (grade) grade.textContent = label;
      if (price) price.textContent = priceCopy;
      if (text) text.textContent = message;
      if (upsell) upsell.textContent = tips.filter(Boolean).join(' ');
    };
    [device, value, country, mode, is100v, fragilePart, hasCartridge].filter(Boolean).forEach(input => {
      input.addEventListener('change', updateCalc);
    });
    updateCalc();

    root.querySelectorAll('[data-oha-pack-faq]').forEach(button => {
      button.addEventListener('click', () => {
        const item = button.closest('article');
        const answer = item ? item.querySelector('div') : null;
        const open = item ? !item.classList.contains('is-open') : false;
        if (item) item.classList.toggle('is-open', open);
        if (answer) answer.hidden = !open;
        button.setAttribute('aria-expanded', String(open));
      });
    });
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ohaInitPackingGuide);
} else {
  ohaInitPackingGuide();
}

function ohaInitShowroomFirstVisit(){
  document.querySelectorAll('[data-oha-showroom-first-visit]').forEach(root => {
    if (root.dataset.ohaVisitReady === 'true') return;
    root.dataset.ohaVisitReady = 'true';

    const datasetText = (key, fallback = '') => {
      const value = root.dataset[key];
      return typeof value === 'string' && value.trim() ? value : fallback;
    };
    const toastNode = root.querySelector('[data-oha-visit-toast]');
    const toast = message => {
      if (!toastNode) return;
      toastNode.textContent = message || datasetText('toastDefaultText', 'Művelet rögzítve.');
      toastNode.classList.add('is-visible');
      window.setTimeout(() => toastNode.classList.remove('is-visible'), 2200);
    };

    const prepChecks = Array.from(root.querySelectorAll('[data-oha-visit-prep]'));
    const prepBar = root.querySelector('[data-oha-visit-progress]');
    const prepScore = root.querySelector('[data-oha-visit-score]');
    const prepText = root.querySelector('[data-oha-visit-prep-text]');
    const prepScoreText = percent => String(root.dataset.prepScoreTemplate || '{percent}%').replaceAll('{percent}', String(percent));
    const updatePrep = () => {
      const done = prepChecks.filter(input => input.checked).length;
      const percent = prepChecks.length ? Math.round((done / prepChecks.length) * 100) : 0;
      if (prepBar) prepBar.style.width = `${percent}%`;
      if (prepScore) prepScore.textContent = prepScoreText(percent);
      if (prepText) {
        let copy = root.dataset.prepPartialText || 'Már van alapinfónk. Ha a zenéket és a rendszeradatokat is hozod, sokkal pontosabb lesz a meghallgatás.';
        if (percent >= 60 && percent < 100) copy = root.dataset.prepStrongText || 'Erős felkészülés. Már látszik a rendszer, a zenei irány és a fő kérdés.';
        if (percent === 100) copy = root.dataset.prepFullText || 'Kiváló. Így célzott, gyors és nyugodt showroom-meghallgatást tudunk adni.';
        if (percent === 0) copy = root.dataset.prepEmptyText || 'Kezdésnek elég néhány alapadat. Pipáld ki, amit már tudsz.';
        prepText.textContent = copy;
      }
    };
    prepChecks.forEach(input => input.addEventListener('change', updatePrep));
    updatePrep();

    const stepButtons = Array.from(root.querySelectorAll('[data-oha-visit-step-nav]'));
    const steps = Array.from(root.querySelectorAll('[data-oha-visit-step]'));
    const setStep = button => {
      if (!button) return;
      const key = button.dataset.ohaVisitStepNav || '';
      stepButtons.forEach(item => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      steps.forEach(step => step.classList.toggle('is-active', step.dataset.ohaVisitStep === key));
    };
    stepButtons.forEach(button => {
      button.addEventListener('click', () => {
        setStep(button);
        const target = root.querySelector(`[data-oha-visit-step="${button.dataset.ohaVisitStepNav || ''}"]`);
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
    setStep(stepButtons.find(button => button.classList.contains('is-active')) || stepButtons[0]);

    const tabs = Array.from(root.querySelectorAll('[data-oha-visit-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-oha-visit-panel]'));
    const setTab = tab => {
      if (!tab) return;
      const key = tab.dataset.ohaVisitTab || '';
      tabs.forEach(item => {
        const active = item === tab;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', String(active));
      });
      panels.forEach(panel => {
        panel.hidden = panel.dataset.ohaVisitPanel !== key;
      });
    };
    tabs.forEach(tab => tab.addEventListener('click', () => setTab(tab)));
    setTab(tabs.find(tab => tab.classList.contains('is-active')) || tabs[0]);

    root.querySelectorAll('[data-oha-visit-chip]').forEach(chip => {
      chip.addEventListener('click', () => chip.classList.toggle('is-active'));
    });

    const saveNote = root.querySelector('[data-oha-visit-save-note]');
    const preview = root.querySelector('[data-oha-visit-preview]');
    if (saveNote && preview) {
      saveNote.addEventListener('click', () => {
        const device = root.querySelector('[data-oha-visit-note-device]');
        const note = root.querySelector('[data-oha-visit-note-text]');
        const deviceText = device && device.value.trim() ? device.value.trim() : datasetText('noteDeviceEmptyText', 'Nincs megadott készülék');
        const noteText = note && note.value.trim() ? note.value.trim() : datasetText('noteTextEmptyText', 'Nincs külön kérdés megadva.');
        const chips = Array.from(root.querySelectorAll('[data-oha-visit-chip].is-active')).map(chip => chip.textContent.trim()).filter(Boolean);
        const strong = document.createElement('strong');
        const small = document.createElement('small');
        strong.textContent = deviceText;
        small.textContent = chips.length ? chips.join(', ') : datasetText('noteChipEmptyText', 'nincs címke');
        preview.replaceChildren(
          strong,
          document.createElement('br'),
          document.createTextNode(noteText),
          document.createElement('br'),
          small
        );
        toast(datasetText('noteSaveToast', 'Showroom jegyzet mentve.'));
      });
    }

    root.querySelectorAll('[data-oha-visit-faq]').forEach(button => {
      button.addEventListener('click', () => {
        const item = button.closest('article');
        const answer = item ? item.querySelector('div') : null;
        const open = item ? !item.classList.contains('is-open') : false;
        if (item) item.classList.toggle('is-open', open);
        if (answer) answer.hidden = !open;
        button.setAttribute('aria-expanded', String(open));
      });
    });
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ohaInitShowroomFirstVisit);
} else {
  ohaInitShowroomFirstVisit();
}

function ohaInitAboutPro(){
  document.querySelectorAll('[data-oha-about-pro]').forEach(root => {
    if (root.dataset.ohaAboutReady === 'true') return;
    root.dataset.ohaAboutReady = 'true';

    const datasetText = (key, fallback = '') => {
      const value = root.dataset[key];
      return typeof value === 'string' && value.trim() ? value : fallback;
    };
    const toastNode = root.querySelector('[data-oha-about-toast]');
    const toast = message => {
      if (!toastNode) return;
      toastNode.textContent = message || datasetText('toastDefaultText', 'Művelet rögzítve.');
      toastNode.classList.add('is-visible');
      window.setTimeout(() => toastNode.classList.remove('is-visible'), 2200);
    };

    const links = Array.from(root.querySelectorAll('[data-oha-about-step-link]'));
    const steps = Array.from(root.querySelectorAll('[data-oha-about-step]'));
    let manualStepLock = false;
    const setActiveStep = handle => {
      if (!handle) return;
      links.forEach(link => link.classList.toggle('is-active', link.dataset.ohaAboutStepLink === handle));
    };
    const visibleHashStep = () => {
      const handle = window.location.hash.replace('#', '');
      if (!handle) return '';
      const target = steps.find(step => step.dataset.ohaAboutStep === handle);
      if (!target) return '';
      const rect = target.getBoundingClientRect();
      const visible = rect.bottom > 120 && rect.top < window.innerHeight - 120;
      return visible ? handle : '';
    };

    links.forEach(link => {
      link.addEventListener('click', () => {
        const handle = link.dataset.ohaAboutStepLink || '';
        const target = root.querySelector(`[data-oha-about-step="${handle}"]`);
        if (!target) return;
        manualStepLock = true;
        setActiveStep(handle);
        history.replaceState(null, '', `#${handle}`);
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        window.setTimeout(() => setActiveStep(handle), 80);
        window.setTimeout(() => setActiveStep(handle), 620);
        window.setTimeout(() => {
          setActiveStep(handle);
          manualStepLock = false;
        }, 1400);
      });
    });

    if ('IntersectionObserver' in window && steps.length) {
      const observer = new IntersectionObserver(entries => {
        if (manualStepLock) return;
        const hashHandle = visibleHashStep();
        if (hashHandle) {
          setActiveStep(hashHandle);
          return;
        }
        const visible = entries
          .filter(entry => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (visible && visible.target) {
          setActiveStep(visible.target.dataset.ohaAboutStep || '');
        }
      }, { rootMargin: '-28% 0px -55% 0px', threshold: [0.2, 0.45, 0.7] });
      steps.forEach(step => observer.observe(step));
    }

    const hashHandle = window.location.hash.replace('#', '');
    if (hashHandle) setActiveStep(hashHandle);

    root.querySelectorAll('[data-oha-about-faq]').forEach(button => {
      button.addEventListener('click', () => {
        const item = button.closest('article');
        const answer = item ? item.querySelector('div') : null;
        const open = item ? !item.classList.contains('is-open') : false;
        if (item) item.classList.toggle('is-open', open);
        if (answer) answer.hidden = !open;
      });
    });

    const newsletter = root.querySelector('[data-oha-about-newsletter]');
    if (newsletter) {
      newsletter.addEventListener('submit', event => {
        event.preventDefault();
        const input = newsletter.querySelector('input[type="email"]');
        if (!input || !input.checkValidity()) {
          toast(datasetText('newsletterInvalidText', 'Kérlek, adj meg egy érvényes e-mail-címet.'));
          if (input) input.focus();
          return;
        }
        toast(datasetText('newsletterSuccessText', 'Klub feliratkozás rögzítve.'));
        newsletter.reset();
      });
    }
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ohaInitAboutPro);
} else {
  ohaInitAboutPro();
}

function ohaInitStepdownCalculator(){
  document.querySelectorAll('[data-oha-stepdown-calculator]').forEach(root => {
    if (root.dataset.ohaStepdownReady === 'true') return;
    root.dataset.ohaStepdownReady = 'true';

    const datasetText = (key, fallback = '') => {
      const value = root.dataset[key];
      return typeof value === 'string' && value.trim() ? value : fallback;
    };
    const toastNode = root.querySelector('[data-oha-stepdown-toast]');
    const toast = message => {
      if (!toastNode) return;
      toastNode.textContent = message || datasetText('toastDefaultText', 'Művelet rögzítve.');
      toastNode.classList.add('is-visible');
      window.setTimeout(() => toastNode.classList.remove('is-visible'), 2200);
    };
    const huf = value => `${String(Math.round(Number(value) || 0)).replace(/\B(?=(\d{3})+(?!\d))/g, '.')} Ft`;
    const numberValue = node => Math.max(1, Number(node ? node.value : 1) || 1);

    const tiers = Array.from(root.querySelectorAll('[data-oha-stepdown-tier]')).map(card => ({
      watts: Number(card.dataset.ohaTierWatts || 0),
      name: card.dataset.ohaTierName || '',
      price: Number(card.dataset.ohaTierPrice || 0),
      text: card.dataset.ohaTierText || ''
    })).filter(tier => tier.watts > 0).sort((a, b) => a.watts - b.watts);

    const deviceName = root.querySelector('[data-oha-stepdown-device-name]');
    const deviceType = root.querySelector('[data-oha-stepdown-device-type]');
    const wattsInput = root.querySelector('[data-oha-stepdown-watts]');
    const valueInput = root.querySelector('[data-oha-stepdown-value]');
    const motorInput = root.querySelector('[data-oha-stepdown-motor]');
    const tubeInput = root.querySelector('[data-oha-stepdown-tube]');
    const showroomInput = root.querySelector('[data-oha-stepdown-showroom]');
    const recW = root.querySelector('[data-oha-stepdown-rec-w]');
    const recText = root.querySelector('[data-oha-stepdown-rec-text]');
    const minW = root.querySelector('[data-oha-stepdown-min-w]');
    const reserveLabel = root.querySelector('[data-oha-stepdown-reserve-label]');
    const productName = root.querySelector('[data-oha-stepdown-product-name]');
    const productPrice = root.querySelector('[data-oha-stepdown-product-price]');
    const reserveButtons = Array.from(root.querySelectorAll('[data-oha-stepdown-reserve]'));
    let reserve = Number((reserveButtons.find(button => button.classList.contains('is-active')) || reserveButtons[0])?.dataset.ohaStepdownReserve || 1.5);

    const setCheckbox = (input, value) => {
      if (input) input.checked = String(value) === 'true';
    };

    const syncCalculation = () => {
      if (!tiers.length || !wattsInput || !deviceType) return;
      const watts = numberValue(wattsInput);
      const type = deviceType.value || 'turntable';
      let extra = 1;
      if (motorInput && motorInput.checked) extra += 0.18;
      if ((tubeInput && tubeInput.checked) || type === 'tube') extra += 0.35;
      if (showroomInput && showroomInput.checked) extra += 0.12;
      if (type === 'amp') extra += 0.2;
      if (type === 'reel') extra += 0.16;

      const minimum = watts * reserve * extra;
      let tier = tiers.find(item => item.watts >= minimum) || tiers[tiers.length - 1];
      if ((type === 'amp' || type === 'tube') && tier.watts < 2000) {
        tier = tiers.find(item => item.watts >= 2000) || tier;
      }
      if (type === 'reel' && tier.watts < 1000) {
        tier = tiers.find(item => item.watts >= 1000) || tier;
      }

      const model = deviceName && deviceName.value.trim() ? deviceName.value.trim() : datasetText('deviceFallbackLabel', 'A készülék');
      const reservePercent = Math.round((reserve - 1) * 100);
      if (recW) recW.textContent = `${tier.watts}W`;
      if (minW) minW.textContent = `${Math.ceil(minimum)} W`;
      if (reserveLabel) reserveLabel.textContent = `+${reservePercent}%`;
      if (productName) productName.textContent = tier.name;
      if (productPrice) productPrice.textContent = huf(tier.price);
      if (recText) {
        recText.textContent = datasetText('resultTextTemplate', '{model} esetén a kalkulált minimum {minimum} W. {tier_text} Ha a készülék hátlapján magasabb fogyasztás szerepel, azt kell figyelembe venni.')
          .replaceAll('{model}', model)
          .replaceAll('{minimum}', String(Math.ceil(minimum)))
          .replaceAll('{tier_text}', tier.text)
          .replaceAll('{tierText}', tier.text);
      }
    };

    root.querySelectorAll('[data-oha-stepdown-preset]').forEach(button => {
      button.addEventListener('click', () => {
        root.querySelectorAll('[data-oha-stepdown-preset]').forEach(item => item.classList.toggle('is-active', item === button));
        if (deviceName) deviceName.value = button.dataset.ohaPresetName || '';
        if (wattsInput) wattsInput.value = button.dataset.ohaPresetWatts || '1';
        if (valueInput) valueInput.value = button.dataset.ohaPresetValue || '0';
        if (deviceType) deviceType.value = button.dataset.ohaPresetType || 'turntable';
        setCheckbox(motorInput, button.dataset.ohaPresetMotor);
        setCheckbox(tubeInput, button.dataset.ohaPresetTube);
        setCheckbox(showroomInput, button.dataset.ohaPresetShowroom);
        syncCalculation();
      });
    });

    reserveButtons.forEach(button => {
      button.addEventListener('click', () => {
        reserveButtons.forEach(item => item.classList.toggle('is-active', item === button));
        reserve = Number(button.dataset.ohaStepdownReserve || 1.5);
        syncCalculation();
      });
    });

    [deviceName, deviceType, wattsInput, valueInput, motorInput, tubeInput, showroomInput].filter(Boolean).forEach(input => {
      input.addEventListener(input.type === 'checkbox' ? 'change' : 'input', syncCalculation);
    });

    const copyButton = root.querySelector('[data-oha-stepdown-copy]');
    if (copyButton) {
      copyButton.addEventListener('click', () => {
        const text = [
          deviceName ? deviceName.value : '',
          minW ? minW.textContent : '',
          productName ? productName.textContent : '',
          productPrice ? productPrice.textContent : ''
        ].filter(Boolean).join(' | ');
        if (navigator.clipboard && text) {
          navigator.clipboard.writeText(text).catch(() => {});
        }
        toast(datasetText('copySuccessToast', 'Ajánlás kimásolva.'));
      });
    }

    root.querySelectorAll('[data-oha-stepdown-add]').forEach(button => {
      button.addEventListener('click', () => {
        const productLabel = button.dataset.ohaStepdownAdd || datasetText('productAddFallbackLabel', 'Termék');
        toast(datasetText('productAddToastTemplate', '{product} hozzáadva a kosárhoz.').replaceAll('{product}', productLabel));
      });
    });

    const syncBundle = () => {
      const base = Number(root.dataset.ohaBundleBase || 0);
      const threshold = Number(root.dataset.ohaBundleDiscountThreshold || 0);
      const discountValue = Number(root.dataset.ohaBundleDiscount || 0);
      const extra = Array.from(root.querySelectorAll('[data-oha-bundle-check]')).reduce((sum, check) => {
        return sum + (check.checked ? Number(check.dataset.ohaBundlePrice || 0) : 0);
      }, 0);
      const discount = extra >= threshold ? discountValue : 0;
      const total = base + extra - discount;
      const extraNode = root.querySelector('[data-oha-bundle-extra]');
      const discountNode = root.querySelector('[data-oha-bundle-discount]');
      const totalNode = root.querySelector('[data-oha-bundle-total]');
      if (extraNode) extraNode.textContent = huf(extra);
      if (discountNode) discountNode.textContent = `-${huf(discount)}`;
      if (totalNode) totalNode.textContent = huf(total);
    };
    root.querySelectorAll('[data-oha-bundle-check]').forEach(check => check.addEventListener('change', syncBundle));
    const bundleSubmit = root.querySelector('[data-oha-bundle-submit]');
    if (bundleSubmit) bundleSubmit.addEventListener('click', () => toast(datasetText('bundleSuccessToast', 'Csomag hozzáadva a kosárhoz.')));

    root.querySelectorAll('[data-oha-stepdown-faq]').forEach(button => {
      button.addEventListener('click', () => {
        const item = button.closest('article');
        const answer = item ? item.querySelector('div') : null;
        const open = item ? !item.classList.contains('is-open') : false;
        if (item) item.classList.toggle('is-open', open);
        if (answer) answer.hidden = !open;
        button.setAttribute('aria-expanded', String(open));
      });
    });

    syncCalculation();
    syncBundle();
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ohaInitStepdownCalculator);
} else {
  ohaInitStepdownCalculator();
}

function ohaInitWishlistComparePro(){
  document.querySelectorAll('[data-oha-wishlist-compare]').forEach(root => {
    if (root.dataset.ohaWishlistReady === 'true') return;
    root.dataset.ohaWishlistReady = 'true';

    const toastNode = root.querySelector('[data-oha-wish-toast]');
    const cards = Array.from(root.querySelectorAll('[data-oha-wish-card]'));
    const grid = root.querySelector('[data-oha-wish-product-grid]');
    const searchInput = root.querySelector('[data-oha-wish-search]');
    const categorySelect = root.querySelector('[data-oha-wish-category]');
    const sortSelect = root.querySelector('[data-oha-wish-sort]');
    const compareChecks = Array.from(root.querySelectorAll('[data-oha-wish-compare-check]'));
    const favCount = root.querySelector('[data-oha-wish-fav-count]');
    const compareCount = root.querySelector('[data-oha-wish-compare-count]');
    const selectedList = root.querySelector('[data-oha-wish-selected-list]');
    const compareTable = root.querySelector('[data-oha-wish-compare-table]');
    const shortlistItems = root.querySelector('[data-oha-wish-shortlist-items]');
    const scoreValue = root.querySelector('[data-oha-wish-score-value]');
    const scoreTitle = root.querySelector('[data-oha-wish-score-title]');
    const scoreText = root.querySelector('[data-oha-wish-score-text]');
    const scoreCircle = root.querySelector('[data-oha-wish-score-circle]');
    const label = (key, fallback) => root.dataset[key] || fallback;
    const numericSetting = (key, fallback) => {
      const value = Number(root.dataset[key]);
      return Number.isFinite(value) ? value : fallback;
    };
    const escapeHtml = value => String(value || '').replace(/[&<>"']/g, char => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    }[char]));
    const formatPrice = value => {
      const number = Number(value || 0);
      if (!Number.isFinite(number)) return '';
      return `${String(Math.round(number)).replace(/\B(?=(\d{3})+(?!\d))/g, '.')} Ft`;
    };
    const productFromCard = card => ({
      id: card.dataset.ohaProductId || '',
      name: card.dataset.ohaProductName || '',
      sub: card.dataset.ohaProductSub || '',
      category: card.dataset.ohaProductCategory || '',
      brand: card.dataset.ohaProductBrand || '',
      price: Number(card.dataset.ohaProductPrice || 0),
      priceDisplay: card.dataset.ohaProductPriceDisplay || formatPrice(card.dataset.ohaProductPrice),
      condition: card.dataset.ohaProductCondition || '',
      voltage: card.dataset.ohaProductVoltage || '',
      status: card.dataset.ohaProductStatus || '',
      link: card.dataset.ohaProductLink || '#',
      note: card.dataset.ohaProductNote || '',
      need: card.dataset.ohaProductNeed || '',
      why: card.dataset.ohaProductWhy || ''
    });
    const productById = id => {
      const card = cards.find(item => item.dataset.ohaProductId === id);
      return card ? productFromCard(card) : null;
    };
    const selectedProducts = () => compareChecks
      .filter(input => input.checked)
      .slice(0, 3)
      .map(input => productById(input.dataset.id))
      .filter(Boolean);
    const toast = message => {
      if (!toastNode) return;
      toastNode.textContent = message || label('ohaToastDefault', 'Művelet rögzítve.');
      toastNode.classList.add('is-visible');
      window.setTimeout(() => toastNode.classList.remove('is-visible'), 2200);
    };

    const syncCounts = () => {
      if (favCount) favCount.textContent = String(root.querySelectorAll('[data-oha-wish-heart].is-active').length);
      if (compareCount) compareCount.textContent = String(selectedProducts().length);
    };

    const renderCompare = () => {
      const selected = selectedProducts();
      if (selectedList) {
        selectedList.innerHTML = selected.map(product => `
          <div class="oha-wish-side-item">
            <i aria-hidden="true"></i>
            <span><strong>${escapeHtml(product.name)}</strong><span>${escapeHtml(product.priceDisplay)} / ${escapeHtml(product.voltage)}</span></span>
          </div>
        `).join('') || `<p>${escapeHtml(label('ohaEmptyCompare', 'Válassz ki legalább két terméket a kártyákon.'))}</p>`;
      }
      if (!compareTable) return;
      if (!selected.length) {
        compareTable.innerHTML = `<tr><th>${escapeHtml(label('ohaTableLabelAspect', 'Szempont'))}</th><td>${escapeHtml(label('ohaEmptyCompare', 'Válassz ki legalább két terméket a kártyákon.'))}</td></tr>`;
        return;
      }
      const rows = [
        [label('ohaTableLabelPrice', 'Ár'), product => product.priceDisplay],
        [label('ohaTableLabelCategory', 'Kategória'), product => product.sub],
        [label('ohaTableLabelCondition', 'Állapot'), product => product.condition],
        [label('ohaTableLabelVoltage', 'Feszültség'), product => `${product.voltage} ${label('ohaTableVoltageSuffix', '— 100 V-os trafólogika szükséges')}`],
        [label('ohaTableLabelStatus', 'Elérhetőség'), product => product.status],
        [label('ohaTableLabelWhy', 'Miért jó választás?'), product => product.why],
        [label('ohaTableLabelNeed', 'Szükséges / ajánlott kiegészítő'), product => product.need],
        [label('ohaTableLabelShowroom', 'Showroom megjegyzés'), product => product.id === 'denon' ? label('ohaTableDenonNote', 'Teljes profi adatlap, videó és kapcsolt ajánlás kidolgozva.') : label('ohaTableListNote', 'Listás kártya, személyes meghallgatásnál döntéstámogató tétel.')]
      ];
      const head = `<tr><th>${escapeHtml(label('ohaTableLabelAspect', 'Szempont'))}</th>${selected.map(product => `<th>${escapeHtml(product.name)}${product.id === 'denon' ? ` <span class="oha-wish-winner">${escapeHtml(label('ohaTableDenonBadge', 'Mintatermék'))}</span>` : ''}</th>`).join('')}</tr>`;
      const body = rows.map(row => `<tr><td>${escapeHtml(row[0])}</td>${selected.map(product => `<td>${escapeHtml(row[1](product))}</td>`).join('')}</tr>`).join('');
      compareTable.innerHTML = head + body;
    };

    const renderShortlist = () => {
      const selected = selectedProducts();
      if (!shortlistItems) return;
      shortlistItems.innerHTML = selected.map(product => `
        <div class="oha-wish-shortlist-row">
          <div class="oha-wish-shortlist-thumb">${escapeHtml(product.brand || product.name.split(' ')[0])}</div>
          <div><strong>${escapeHtml(product.name)}</strong><span>${escapeHtml(product.note)}</span></div>
          <a class="oha-btn oha-btn--light" href="${escapeHtml(product.link)}">${escapeHtml(label('ohaShortlistLinkLabel', 'Megnézem'))}</a>
        </div>
      `).join('') || `<p>${escapeHtml(label('ohaEmptyCompare', 'Válassz ki legalább két terméket a kártyákon.'))}</p>`;
    };

    const enforceCompareLimit = changed => {
      const checked = compareChecks.filter(input => input.checked);
      if (checked.length > 3 && changed) {
        changed.checked = false;
        toast(label('ohaToastMaxCompare', 'Egyszerre maximum 3 terméket hasonlíts össze.'));
      }
      syncCounts();
      renderCompare();
      renderShortlist();
    };

    const filterProducts = () => {
      if (!grid) return;
      const query = (searchInput ? searchInput.value : '').trim().toLocaleLowerCase('hu');
      const category = categorySelect ? categorySelect.value : 'all';
      const sort = sortSelect ? sortSelect.value : 'default';
      cards.forEach(card => {
        const product = productFromCard(card);
        const haystack = [product.name, product.sub, product.brand, product.category, product.condition, product.voltage, product.status, product.note].join(' ').toLocaleLowerCase('hu');
        const visible = (!query || haystack.includes(query)) && (category === 'all' || product.category === category);
        card.hidden = !visible;
      });
      const sorted = cards.slice().sort((a, b) => {
        const left = productFromCard(a);
        const right = productFromCard(b);
        if (sort === 'priceAsc') return left.price - right.price;
        if (sort === 'priceDesc') return right.price - left.price;
        if (sort === 'name') return left.name.localeCompare(right.name, 'hu');
        return cards.indexOf(a) - cards.indexOf(b);
      });
      sorted.forEach(card => grid.appendChild(card));
    };

    root.querySelectorAll('[data-oha-wish-tab]').forEach(button => {
      button.addEventListener('click', () => {
        const id = button.dataset.ohaWishTab || 'favs';
        root.querySelectorAll('[data-oha-wish-tab]').forEach(tab => {
          const active = tab === button;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
        });
        root.querySelectorAll('[data-oha-wish-panel]').forEach(panel => panel.classList.toggle('is-active', panel.dataset.ohaWishPanel === id));
        if (id === 'compare') renderCompare();
        if (id === 'showroom') renderShortlist();
      });
    });

    root.querySelectorAll('[data-oha-wish-heart]').forEach(button => {
      button.addEventListener('click', () => {
        const card = button.closest('[data-oha-wish-card]');
        if (!card) return;
        const active = !button.classList.contains('is-active');
        button.classList.toggle('is-active', active);
        card.classList.toggle('is-muted', !active);
        const product = productFromCard(card);
        toast(`${active ? label('ohaToastAddedPrefix', 'Visszatéve a kedvencek közé:') : label('ohaToastRemovedPrefix', 'Kedvencből kivéve:')} ${product.name}`);
        syncCounts();
      });
    });

    compareChecks.forEach(input => input.addEventListener('change', () => enforceCompareLimit(input)));
    if (searchInput) searchInput.addEventListener('input', filterProducts);
    if (categorySelect) categorySelect.addEventListener('change', filterProducts);
    if (sortSelect) sortSelect.addEventListener('change', filterProducts);
    const resetButton = root.querySelector('[data-oha-wish-reset]');
    if (resetButton) {
      resetButton.addEventListener('click', () => {
        if (searchInput) searchInput.value = '';
        if (categorySelect) categorySelect.value = 'all';
        if (sortSelect) sortSelect.value = 'default';
        filterProducts();
      });
    }

    const sendCompare = root.querySelector('[data-oha-wish-send-compare]');
    if (sendCompare) sendCompare.addEventListener('click', () => toast(label('ohaToastSendCompare', 'Az összehasonlító lista showroom üzenetté alakult.')));
    const copyShortlist = root.querySelector('[data-oha-wish-copy-shortlist]');
    if (copyShortlist) {
      copyShortlist.addEventListener('click', () => {
        const note = root.querySelector('[data-oha-wish-note]');
        const selected = selectedProducts().map(product => `${product.name}: ${product.note}`).join('\n');
        const text = [selected, note ? note.value : ''].filter(Boolean).join('\n\n');
        if (navigator.clipboard && text) navigator.clipboard.writeText(text).catch(() => {});
        toast(label('ohaToastCopyShortlist', 'A showroom rövidlista szövege másolva.'));
      });
    }

    const calcScore = () => {
      let score = numericSetting('ohaScoreBaseValue', 30);
      const highThreshold = numericSetting('ohaScoreHighThreshold', 72);
      const midThreshold = numericSetting('ohaScoreMidThreshold', 48);
      const messages = [];
      root.querySelectorAll('[data-oha-wish-decision-checks] input').forEach(input => {
        if (!input.checked) return;
        score += Number(input.dataset.score || 0);
        if (input.dataset.message) messages.push(input.dataset.message);
      });
      score = Math.min(100, score);
      if (scoreValue) scoreValue.textContent = `${score}%`;
      if (scoreCircle) scoreCircle.style.setProperty('--score-deg', `${score * 3.6}deg`);
      if (scoreTitle) {
        scoreTitle.textContent = score > highThreshold
          ? label('ohaScoreHighTitle', 'Erős, célzott rövidlista')
          : score > midThreshold
            ? label('ohaScoreMidTitle', 'Jó rövidlista alap')
            : label('ohaScoreLowTitle', 'Még érdemes szűkíteni');
      }
      if (scoreText) scoreText.textContent = messages.slice(0, 3).join(' / ') || label('ohaScoreEmptyText', 'Válassz néhány szempontot, és a döntési segéd frissül.');
    };
    root.querySelectorAll('[data-oha-wish-decision-checks] input').forEach(input => input.addEventListener('change', calcScore));

    filterProducts();
    enforceCompareLimit(null);
    calcScore();
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ohaInitWishlistComparePro);
} else {
  ohaInitWishlistComparePro();
}

function ohaInitValuationPro(){
  document.querySelectorAll('[data-oha-valuation-pro]').forEach(root => {
    if (root.dataset.ohaValReady === 'true') return;
    root.dataset.ohaValReady = 'true';

    const datasetText = (key, fallback = '') => String(root.dataset[key] || fallback);
    const currencySuffix = datasetText('currencySuffix', 'Ft');
    const formatPrice = value => `${Math.round(Number(value || 0)).toLocaleString('hu-HU')} ${currencySuffix}`.trim();
    const toastNode = root.querySelector('[data-oha-val-toast]');
    const defaultToastText = toastNode ? String(toastNode.textContent || '').trim() : datasetText('toastDefault', '');
    const toast = message => {
      if (!toastNode) return;
      toastNode.textContent = message || defaultToastText;
      toastNode.classList.add('is-visible');
      window.setTimeout(() => toastNode.classList.remove('is-visible'), 2200);
    };
    const calcInputs = {
      brand: root.querySelector('[data-oha-val-brand]'),
      category: root.querySelector('[data-oha-val-category]'),
      condition: root.querySelector('[data-oha-val-condition]'),
      docs: root.querySelector('[data-oha-val-docs]'),
      voltage: root.querySelector('[data-oha-val-voltage]'),
      goal: root.querySelector('[data-oha-val-goal]')
    };
    const rangeText = root.querySelector('[data-oha-val-range]');
    const strategyText = root.querySelector('[data-oha-val-strategy]');
    const confidenceBar = root.querySelector('[data-oha-val-confidence]');
    const buyIn = root.querySelector('[data-oha-val-buyin]');
    const consign = root.querySelector('[data-oha-val-consign]');
    const prep = root.querySelector('[data-oha-val-prep]');
    const route = root.querySelector('[data-oha-val-route]');
    const chips = root.querySelector('[data-oha-val-chips]');

    const calc = () => {
      if (!calcInputs.brand || !calcInputs.category || !rangeText) return;
      const brand = Number(calcInputs.brand.value || 1);
      const base = Number(calcInputs.category.value || 0);
      const condition = Number(calcInputs.condition ? calcInputs.condition.value : 1);
      const docs = Number(calcInputs.docs ? calcInputs.docs.value : 1);
      const voltage = Number(calcInputs.voltage ? calcInputs.voltage.value : 1);
      const goal = calcInputs.goal ? calcInputs.goal.value : 'ertekbecsles';
      let boost = 1;
      if (chips) {
        chips.querySelectorAll('[data-oha-val-chip].is-active').forEach(chip => {
          boost *= Number(chip.dataset.boost || 1);
        });
      }
      const center = base * brand * condition * docs * voltage * boost;
      const low = center * 0.84;
      const high = center * 1.16;
      rangeText.textContent = `${formatPrice(low)} – ${formatPrice(high)}`;
      if (buyIn) buyIn.textContent = formatPrice(center * 0.68);
      if (consign) consign.textContent = formatPrice(center * 1.02);
      if (prep) prep.textContent = condition < 0.7 ? datasetText('prepHigh') : (voltage < 0.95 ? datasetText('prepMedium') : datasetText('prepLow'));
      const goalNames = {
        ertekbecsles: datasetText('goalValuation'),
        beszamitas: datasetText('goalTradein'),
        bizomany: datasetText('goalConsignment'),
        aukcio: datasetText('goalAuction')
      };
      if (route) route.textContent = goalNames[goal] || datasetText('goalValuation');
      if (confidenceBar) {
        const confidence = Math.max(36, Math.min(94, 58 + (docs - 1) * 90 + (condition - 1) * 45 + (boost - 1) * 24));
        confidenceBar.style.width = `${confidence}%`;
      }
      if (strategyText) {
        let strategy = datasetText('strategyDefault');
        if (goal === 'bizomany') strategy = datasetText('strategyConsignment');
        if (goal === 'aukcio') strategy = datasetText('strategyAuction');
        if (goal === 'ertekbecsles') strategy = datasetText('strategyValuation');
        strategyText.textContent = strategy;
      }
    };
    Object.values(calcInputs).forEach(input => {
      if (input) input.addEventListener('change', calc);
    });
    if (chips) {
      chips.addEventListener('click', event => {
        const chip = event.target.closest('[data-oha-val-chip]');
        if (!chip) return;
        chip.classList.toggle('is-active');
        calc();
      });
    }
    calc();

    const form = root.querySelector('[data-oha-val-form]');
    const progressBar = root.querySelector('[data-oha-val-form-progress]');
    const progressText = root.querySelector('[data-oha-val-progress-text]');
    const statusText = root.querySelector('[data-oha-val-form-status]');
    if (form) {
      const progressFields = Array.from(form.querySelectorAll('input:not([type="hidden"]), select, textarea'));
      const requiredFields = Array.from(form.querySelectorAll('[required]'));
      const syncProgress = () => {
        const filled = progressFields.filter(field => String(field.value || '').trim()).length;
        const pct = Math.round((filled / Math.max(progressFields.length, 1)) * 100);
        if (progressBar) progressBar.style.width = `${pct}%`;
        if (progressText) {
          let text = `${pct}%${datasetText('progressSeparator')}`;
          if (pct < 35) text += datasetText('progressLow');
          else if (pct < 70) text += datasetText('progressMid');
          else text += datasetText('progressHigh');
          progressText.textContent = text;
        }
      };
      progressFields.forEach(field => {
        field.addEventListener('input', syncProgress);
        field.addEventListener('change', syncProgress);
      });
      form.addEventListener('submit', event => {
        const missing = requiredFields.filter(field => !String(field.value || '').trim());
        if (missing.length) {
          event.preventDefault();
          if (statusText) statusText.textContent = datasetText('formMissing');
          toast(datasetText('formMissingToast'));
          return;
        }
        if (statusText) statusText.textContent = datasetText('formSubmitting');
      });
      syncProgress();
    }

    let photoCount = 0;
    const photoButton = root.querySelector('[data-oha-val-photo-action]');
    const photoDrop = root.querySelector('[data-oha-val-drop]');
    if (photoButton && photoDrop) {
      photoButton.addEventListener('click', () => {
        photoCount += 1;
        photoDrop.classList.add('is-active');
        const title = photoDrop.querySelector('strong');
        const text = photoDrop.querySelector('p');
        if (title) title.textContent = datasetText('photoTitleTemplate').replace('{count}', String(photoCount));
        if (text) text.textContent = photoCount < 4
          ? datasetText('photoMore')
          : datasetText('photoDone');
        toast(datasetText('photoToast'));
      });
    }

    root.querySelectorAll('[data-oha-val-faq]').forEach(button => {
      button.addEventListener('click', () => {
        const item = button.closest('.oha-val-faq');
        if (item) item.classList.toggle('is-open');
      });
    });
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ohaInitValuationPro);
} else {
  ohaInitValuationPro();
}

function ohaInitConsignmentPro(){
  document.querySelectorAll('[data-oha-consignment-pro]').forEach(root => {
    if (root.dataset.ohaConsignReady === 'true') return;
    root.dataset.ohaConsignReady = 'true';

    const datasetText = (key, fallback = '') => String(root.dataset[key] || fallback);
    const currencySuffix = datasetText('currencySuffix', 'Ft');
    const formatPrice = value => `${Math.round(Number(value || 0)).toLocaleString('hu-HU')} ${currencySuffix}`.trim();
    const roundToTen = value => Math.round(Number(value || 0) / 10000) * 10000;
    const toastNode = root.querySelector('[data-oha-consign-toast]');
    const defaultToastText = toastNode ? String(toastNode.textContent || '').trim() : datasetText('toastDefault', '');
    const toast = message => {
      if (!toastNode) return;
      toastNode.textContent = message || defaultToastText;
      toastNode.classList.add('is-visible');
      window.setTimeout(() => toastNode.classList.remove('is-visible'), 2200);
    };

    const calcForm = root.querySelector('[data-oha-consign-calc-form]');
    if (calcForm) {
      calcForm.addEventListener('submit', event => event.preventDefault());
      const fields = {
        category: root.querySelector('[data-oha-consign-cat]'),
        condition: root.querySelector('[data-oha-consign-condition]'),
        value: root.querySelector('[data-oha-consign-value]'),
        urgency: root.querySelector('[data-oha-consign-urgency]')
      };
      const prefWrap = root.querySelector('[data-oha-consign-pref-chips]');
      const result = {
        title: root.querySelector('[data-oha-consign-result-title]'),
        text: root.querySelector('[data-oha-consign-result-text]'),
        gross: root.querySelector('[data-oha-consign-gross]'),
        net: root.querySelector('[data-oha-consign-net]'),
        commission: root.querySelector('[data-oha-consign-commission]'),
        timeframe: root.querySelector('[data-oha-consign-timeframe]'),
        fitbar: root.querySelector('[data-oha-consign-fitbar]'),
        fittext: root.querySelector('[data-oha-consign-fittext]')
      };
      const categoryMul = {turntable:1.05, amp:1.12, reel:1.18, speaker:.96, cd:.9};
      const conditionMul = {excellent:1.18, good:1, fair:.86, service:.62};
      const urgencyMul = {fast:.92, balanced:1, max:1.12};
      const prefMul = {fixed:1, auction:1.08, vip:1.14, tradein:.78};
      const prefCopy = {
        fixed: {
          title: datasetText('prefFixedTitle'),
          text: datasetText('prefFixedText'),
          commission: Number(datasetText('prefFixedCommission', '.15'))
        },
        auction: {
          title: datasetText('prefAuctionTitle'),
          text: datasetText('prefAuctionText'),
          commission: Number(datasetText('prefAuctionCommission', '.18'))
        },
        vip: {
          title: datasetText('prefVipTitle'),
          text: datasetText('prefVipText'),
          commission: Number(datasetText('prefVipCommission', '.16'))
        },
        tradein: {
          title: datasetText('prefTradeinTitle'),
          text: datasetText('prefTradeinText'),
          commission: Number(datasetText('prefTradeinCommission', '.08'))
        }
      };
      const activePref = () => {
        const active = prefWrap ? prefWrap.querySelector('button.is-active') : null;
        return active ? active.dataset.pref || 'fixed' : 'fixed';
      };
      const calc = () => {
        const base = Number(fields.value ? fields.value.value : 300000);
        const category = fields.category ? fields.category.value : 'turntable';
        const condition = fields.condition ? fields.condition.value : 'good';
        const urgency = fields.urgency ? fields.urgency.value : 'balanced';
        const pref = activePref();
        const copy = prefCopy[pref] || prefCopy.fixed;
        const gross = roundToTen(base * (categoryMul[category] || 1) * (conditionMul[condition] || 1) * (urgencyMul[urgency] || 1) * (prefMul[pref] || 1));
        const commissionPct = copy.commission;
        const net = roundToTen(gross * (pref === 'tradein' ? .72 : (1 - commissionPct)));
        const timeframeBase = {
          fixed: {fast:datasetText('timeframeFixedFast'), balanced:datasetText('timeframeFixedBalanced'), max:datasetText('timeframeFixedMax')},
          auction: {fast:datasetText('timeframeAuctionFast'), balanced:datasetText('timeframeAuctionBalanced'), max:datasetText('timeframeAuctionMax')},
          vip: {fast:datasetText('timeframeVipFast'), balanced:datasetText('timeframeVipBalanced'), max:datasetText('timeframeVipMax')},
          tradein: {fast:datasetText('timeframeTradeinFast'), balanced:datasetText('timeframeTradeinBalanced'), max:datasetText('timeframeTradeinMax')}
        };
        let fit = 58;
        fit += ({excellent:14, good:8, fair:0, service:-14}[condition] || 0);
        fit += base >= 1000000 ? 12 : base >= 600000 ? 8 : base >= 300000 ? 4 : 0;
        fit += ({fast:-4, balanced:4, max:2}[urgency] || 0);
        fit += ({turntable:0, amp:3, reel:4, speaker:-2, cd:-4}[category] || 0);
        fit += ({fixed:0, auction:4, vip:6, tradein:-8}[pref] || 0);
        fit = Math.max(24, Math.min(96, fit));
        if (result.title) result.title.textContent = copy.title;
        if (result.text) result.text.textContent = copy.text;
        if (result.gross) result.gross.textContent = formatPrice(gross);
        if (result.net) result.net.textContent = formatPrice(net);
        if (result.commission) result.commission.textContent = `${Math.round(commissionPct * 100)}%`;
        if (result.timeframe) result.timeframe.textContent = (timeframeBase[pref] || timeframeBase.fixed)[urgency] || datasetText('timeframeFixedBalanced');
        if (result.fitbar) result.fitbar.style.width = `${fit}%`;
        if (result.fittext) {
          result.fittext.textContent = `${datasetText('fitPrefix')}: ${fit}%. ${fit >= 74 ? datasetText('fitHigh') : fit >= 55 ? datasetText('fitMid') : datasetText('fitLow')}`;
        }
      };
      Object.values(fields).forEach(field => {
        if (field) field.addEventListener('change', calc);
      });
      if (prefWrap) {
        prefWrap.addEventListener('click', event => {
          const button = event.target.closest('button[data-pref]');
          if (!button) return;
          prefWrap.querySelectorAll('button[data-pref]').forEach(item => item.classList.toggle('is-active', item === button));
          calc();
        });
      }
      calc();
    }

    root.querySelectorAll('[data-oha-consign-tab]').forEach(button => {
      button.addEventListener('click', () => {
        const id = button.dataset.ohaConsignTab || 'fixed';
        root.querySelectorAll('[data-oha-consign-tab]').forEach(tab => {
          const active = tab === button;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
        });
        root.querySelectorAll('[data-oha-consign-panel]').forEach(panel => {
          panel.classList.toggle('is-active', panel.dataset.ohaConsignPanel === id);
        });
      });
    });

    const tagWrap = root.querySelector('[data-oha-consign-tags]');
    if (tagWrap) {
      tagWrap.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        button.classList.toggle('is-active');
        toast(button.classList.contains('is-active') ? datasetText('tagAdded') : datasetText('tagRemoved'));
      });
    }

    const form = root.querySelector('[data-oha-consign-form]');
    if (form) {
      const status = root.querySelector('[data-oha-consign-form-status]');
      const required = Array.from(form.querySelectorAll('[required]'));
      form.addEventListener('submit', event => {
        const missing = required.filter(field => !String(field.value || '').trim());
        if (missing.length) {
          event.preventDefault();
          if (status) status.textContent = datasetText('formMissing');
          toast(datasetText('formMissingToast'));
          missing[0].focus();
          return;
        }
        if (status) status.textContent = datasetText('formSubmitting');
      });
    }

    root.querySelectorAll('[data-oha-consign-faq]').forEach(button => {
      button.addEventListener('click', () => {
        const item = button.closest('.oha-consign-faq');
        if (!item) return;
        item.classList.toggle('is-open');
        const marker = button.querySelector('span');
        if (marker) marker.textContent = item.classList.contains('is-open') ? datasetText('faqOpenSymbol') : datasetText('faqClosedSymbol');
      });
    });
    root.querySelectorAll('.oha-consign-faq.is-open [data-oha-consign-faq] span').forEach(marker => {
      marker.textContent = datasetText('faqOpenSymbol');
    });
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ohaInitConsignmentPro);
} else {
  ohaInitConsignmentPro();
}

function ohaInitServicePro(){
  document.querySelectorAll('[data-oha-service-pro]').forEach(root => {
    if (root.dataset.ohaServiceReady === 'true') return;
    root.dataset.ohaServiceReady = 'true';
    const toastNode = root.querySelector('[data-oha-service-toast]');
    const defaultToastText = toastNode ? String(toastNode.textContent || '').trim() : '';
    const toast = message => {
      if (!toastNode) return;
      toastNode.textContent = message || defaultToastText;
      toastNode.classList.add('is-visible');
      window.setTimeout(() => toastNode.classList.remove('is-visible'), 2200);
    };
    const serviceFaqOpenSymbol = root.dataset.ohaServiceFaqOpenSymbol || '−';
    const serviceFaqClosedSymbol = root.dataset.ohaServiceFaqClosedSymbol || '+';

    const calcForm = root.querySelector('[data-oha-service-calc-form]');
    if (calcForm) {
      calcForm.addEventListener('submit', event => event.preventDefault());
      const fields = {
        device: root.querySelector('[data-oha-service-device]'),
        goal: root.querySelector('[data-oha-service-goal]'),
        symptom: root.querySelector('[data-oha-service-symptom]'),
        voltage: root.querySelector('[data-oha-service-voltage]'),
        depth: root.querySelector('[data-oha-service-depth]'),
        urgency: root.querySelector('[data-oha-service-urgency]')
      };
      const nodes = {
        title: root.querySelector('[data-oha-service-result-title]'),
        text: root.querySelector('[data-oha-service-result-text]'),
        time: root.querySelector('[data-oha-service-time]'),
        depth: root.querySelector('[data-oha-service-depth-result]'),
        voltage: root.querySelector('[data-oha-service-voltage-result]'),
        handover: root.querySelector('[data-oha-service-handover]'),
        bar: root.querySelector('[data-oha-service-fitbar]'),
        fit: root.querySelector('[data-oha-service-fittext]')
      };
      const calcChips = root.querySelector('[data-oha-service-calc-chips]');
      const deviceCopy = {
        turntable: [root.dataset.ohaServiceCopyTurntableTitle, root.dataset.ohaServiceCopyTurntableText],
        amp: [root.dataset.ohaServiceCopyAmpTitle, root.dataset.ohaServiceCopyAmpText],
        reel: [root.dataset.ohaServiceCopyReelTitle, root.dataset.ohaServiceCopyReelText],
        source: [root.dataset.ohaServiceCopySourceTitle, root.dataset.ohaServiceCopySourceText],
        speaker: [root.dataset.ohaServiceCopySpeakerTitle, root.dataset.ohaServiceCopySpeakerText]
      };
      const voltageCopy = {
        '100v': root.getAttribute('data-oha-service-voltage-100v') || root.dataset.ohaServiceVoltage100v || '',
        unknown: root.dataset.ohaServiceVoltageUnknown || '',
        '230v': root.getAttribute('data-oha-service-voltage-230v') || root.dataset.ohaServiceVoltage230v || ''
      };
      const sync = () => {
        const device = fields.device ? fields.device.value : 'turntable';
        const goal = fields.goal ? fields.goal.value : 'use';
        const symptom = fields.symptom ? fields.symptom.value : 'unknown';
        const voltage = fields.voltage ? fields.voltage.value : '100v';
        const depth = fields.depth ? fields.depth.value : 'basic';
        const urgency = fields.urgency ? fields.urgency.value : 'normal';
        let score = 58;
        score += ({buy:5, sell:7, auction:9, use:2}[goal] || 0);
        score += ({noise:6, mechanic:7, channel:6, docs:5, unknown:2}[symptom] || 0);
        score += voltage === '100v' ? 8 : voltage === 'unknown' ? 4 : 0;
        score += ({report:7, video:10, sales:12, basic:2}[depth] || 0);
        score += ({fast:3, vip:8, normal:0}[urgency] || 0);
        if (calcChips) {
          calcChips.querySelectorAll('button.is-active').forEach(button => {
            score += Number(button.dataset.boost || 0);
          });
        }
        score = Math.max(32, Math.min(96, score));
        const copy = deviceCopy[device] || deviceCopy.turntable;
        if (nodes.title) nodes.title.textContent = copy[0];
        if (nodes.text) nodes.text.textContent = copy[1];
        if (nodes.time) nodes.time.textContent = urgency === 'fast' ? root.dataset.ohaServiceTimeFast : urgency === 'vip' ? root.dataset.ohaServiceTimeVip : root.dataset.ohaServiceTimeNormal;
        if (nodes.depth) nodes.depth.textContent = depth === 'sales' ? root.dataset.ohaServiceDepthSales : depth === 'video' ? root.dataset.ohaServiceDepthVideo : depth === 'report' ? root.dataset.ohaServiceDepthReport : root.dataset.ohaServiceDepthBasic;
        if (nodes.voltage) nodes.voltage.textContent = voltageCopy[voltage] || voltageCopy['100v'];
        if (nodes.handover) nodes.handover.textContent = goal === 'auction' || goal === 'sell' ? root.dataset.ohaServiceHandoverSales : root.dataset.ohaServiceHandoverDefault;
        if (nodes.bar) nodes.bar.style.width = `${score}%`;
        if (nodes.fit) nodes.fit.textContent = `${root.dataset.ohaServiceFitPrefix} ${score}%. ${score >= 76 ? root.dataset.ohaServiceFitHigh : score >= 58 ? root.dataset.ohaServiceFitMedium : root.dataset.ohaServiceFitLow}`;
      };
      Object.values(fields).forEach(field => {
        if (field) field.addEventListener('change', sync);
      });
      if (calcChips) {
        calcChips.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button) return;
          button.classList.toggle('is-active');
          sync();
        });
      }
      sync();
    }

    root.querySelectorAll('[data-oha-service-tab]').forEach(button => {
      button.addEventListener('click', () => {
        const id = button.dataset.ohaServiceTab || 'turntable';
        root.querySelectorAll('[data-oha-service-tab]').forEach(tab => {
          const active = tab === button;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
        });
        root.querySelectorAll('[data-oha-service-panel]').forEach(panel => panel.classList.toggle('is-active', panel.dataset.ohaServicePanel === id));
      });
    });

    const formTags = root.querySelector('[data-oha-service-form-tags]');
    if (formTags) {
      formTags.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        button.classList.toggle('is-active');
        toast(button.classList.contains('is-active') ? root.dataset.ohaServiceTagAdded : root.dataset.ohaServiceTagRemoved);
      });
    }

    const form = root.querySelector('[data-oha-service-form]');
    if (form) {
      const status = root.querySelector('[data-oha-service-form-status]');
      const required = Array.from(form.querySelectorAll('[required]'));
      form.addEventListener('submit', event => {
        const missing = required.filter(field => !String(field.value || '').trim());
        if (missing.length) {
          event.preventDefault();
          if (status) status.textContent = root.dataset.ohaServiceRequiredStatus || status.textContent;
          toast(root.dataset.ohaServiceRequiredToast);
          missing[0].focus();
          return;
        }
        if (status) status.textContent = root.dataset.ohaServiceSubmittingStatus || status.textContent;
      });
    }

    root.querySelectorAll('[data-oha-service-faq]').forEach(button => {
      button.addEventListener('click', () => {
        const item = button.closest('.oha-service-faq');
        if (!item) return;
        item.classList.toggle('is-open');
        const marker = button.querySelector('span');
        if (marker) marker.textContent = item.classList.contains('is-open') ? serviceFaqOpenSymbol : serviceFaqClosedSymbol;
      });
    });
    root.querySelectorAll('.oha-service-faq.is-open [data-oha-service-faq] span').forEach(marker => {
      marker.textContent = serviceFaqOpenSymbol;
    });
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ohaInitServicePro);
} else {
  ohaInitServicePro();
}

function ohaInitAuctionProductPro(){
  const formatForint = value => `${Math.round(value).toLocaleString('hu-HU')} Ft`;
  document.querySelectorAll('[data-oha-auction-product-pro]').forEach(root => {
    const datasetText = (key, fallback = '') => {
      const value = root.dataset[key];
      return typeof value === 'string' && value.trim() ? value : fallback;
    };
    const toastNode = root.querySelector('[data-oha-ap-toast]');
    const toast = message => {
      if (!toastNode) return;
      toastNode.textContent = message || datasetText('toastDefault', 'Rögzítve.');
      toastNode.classList.add('is-visible');
      window.clearTimeout(toastNode.dataset.ohaTimer);
      toastNode.dataset.ohaTimer = window.setTimeout(() => toastNode.classList.remove('is-visible'), 2200);
    };

    const mainLabel = root.querySelector('[data-oha-ap-main-label]');
    const mainNote = root.querySelector('[data-oha-ap-main-note]');
    const mainBadge = root.querySelector('[data-oha-ap-main-badge]');
    root.querySelectorAll('[data-oha-ap-thumb]').forEach(button => {
      button.addEventListener('click', () => {
        root.querySelectorAll('[data-oha-ap-thumb]').forEach(item => item.classList.toggle('is-active', item === button));
        if (mainLabel) mainLabel.textContent = button.dataset.label || mainLabel.textContent;
        if (mainNote) mainNote.textContent = button.dataset.note || mainNote.textContent;
        if (mainBadge) mainBadge.textContent = button.dataset.badge || mainBadge.textContent;
      });
    });

    const input = root.querySelector('[data-oha-ap-bid-input]');
    const currentPrice = root.querySelector('[data-oha-ap-current-price]');
    const minBid = root.querySelector('[data-oha-ap-min-bid]');
    const bidderCount = root.querySelector('[data-oha-ap-bidder-count]');
    const feedback = root.querySelector('[data-oha-ap-feedback]');
    const placeBid = root.querySelector('[data-oha-ap-place-bid]');
    const step = Number(root.dataset.bidStep || 10000);
    let current = Number(root.dataset.currentBid || 250000);
    let bidders = Number(String(bidderCount ? bidderCount.textContent : '7').replace(/[^0-9]/g, '')) || 7;
    const bidderSuffix = datasetText('bidderSuffix', 'fő');
    const quickBidToast = datasetText('quickBidToast', 'Gyors licitösszeg kiválasztva.');
    const bidLowFeedbackTemplate = datasetText('bidLowFeedbackTemplate', 'A minimum következő licit {amount}.');
    const bidLowToast = datasetText('bidLowToast', 'A licitösszeg túl alacsony.');
    const bidSuccessFeedback = datasetText('bidSuccessFeedback', 'Licit rögzítve az aukciós előnézetben.');
    const bidSuccessToast = datasetText('bidSuccessToast', 'Licit rögzítve.');
    const autoBidOnToast = datasetText('autoBidOnToast', 'Automata max licit bekapcsolva.');
    const autoBidOffToast = datasetText('autoBidOffToast', 'Automata max licit kikapcsolva.');
    const watchActiveLabel = datasetText('watchActiveLabel', '♥ Figyelem alatt');
    const watchInactiveLabel = datasetText('watchInactiveLabel', '♡ Figyelem');
    const watchActiveToast = datasetText('watchActiveToast', 'Aukció figyelőlistára téve.');
    const watchInactiveToast = datasetText('watchInactiveToast', 'Figyelés levéve.');
    const bundleWatchOnToast = datasetText('bundleWatchOnToast', 'Csomag figyelése bekapcsolva.');
    const bundleWatchOffToast = datasetText('bundleWatchOffToast', 'Csomag figyelése kikapcsolva.');
    const faqOpenSymbol = datasetText('faqOpenSymbol', '-');
    const faqClosedSymbol = datasetText('faqClosedSymbol', '+');

    const syncBid = () => {
      if (currentPrice) currentPrice.textContent = formatForint(current);
      if (minBid) minBid.textContent = formatForint(current + step);
      if (input) input.value = String(current + step);
      if (bidderCount) bidderCount.textContent = `${bidders} ${bidderSuffix}`;
    };

    root.querySelectorAll('[data-oha-ap-quick-bid]').forEach(button => {
      button.addEventListener('click', () => {
        if (input) input.value = String(button.dataset.ohaApQuickBid || '');
        toast(quickBidToast);
      });
    });

    if (placeBid && input) {
      placeBid.addEventListener('click', () => {
        const value = Number(String(input.value || '').replace(/[^0-9]/g, ''));
        const required = current + step;
        if (!value || value < required) {
          if (feedback) feedback.textContent = bidLowFeedbackTemplate.replaceAll('{amount}', formatForint(required));
          toast(bidLowToast);
          input.focus();
          return;
        }
        current = value;
        bidders += 1;
        syncBid();
        if (feedback) feedback.textContent = bidSuccessFeedback;
        toast(bidSuccessToast);
      });
    }

    const autoBid = root.querySelector('[data-oha-ap-auto-bid]');
    if (autoBid) {
      autoBid.addEventListener('change', () => {
        toast(autoBid.checked ? autoBidOnToast : autoBidOffToast);
      });
    }

    const watch = root.querySelector('[data-oha-ap-watch]');
    if (watch) {
      watch.addEventListener('click', () => {
        const active = watch.classList.toggle('is-active');
        watch.textContent = active ? watchActiveLabel : watchInactiveLabel;
        toast(active ? watchActiveToast : watchInactiveToast);
      });
    }

    root.querySelectorAll('[data-oha-ap-tab]').forEach(tab => {
      tab.addEventListener('click', () => {
        const id = tab.dataset.ohaApTab || 'state';
        root.querySelectorAll('[data-oha-ap-tab]').forEach(item => {
          const active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', String(active));
        });
        root.querySelectorAll('[data-oha-ap-panel]').forEach(panel => {
          panel.classList.toggle('is-hidden', panel.dataset.ohaApPanel !== id);
        });
      });
    });

    const bundle = root.querySelector('[data-oha-ap-bundle]');
    if (bundle) {
      bundle.addEventListener('click', () => {
        bundle.classList.toggle('is-active');
        toast(bundle.classList.contains('is-active') ? bundleWatchOnToast : bundleWatchOffToast);
      });
    }

    root.querySelectorAll('[data-oha-ap-faq]').forEach(button => {
      button.addEventListener('click', () => {
        const item = button.closest('.oha-ap-faq');
        if (!item) return;
        item.classList.toggle('is-open');
        const marker = button.querySelector('span');
        if (marker) marker.textContent = item.classList.contains('is-open') ? faqOpenSymbol : faqClosedSymbol;
      });
    });
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ohaInitAuctionProductPro);
} else {
  ohaInitAuctionProductPro();
}

function ohaInitOrderConfirmationPro(){
  document.querySelectorAll('[data-oha-order-confirmation]').forEach(root => {
    const toastNode = root.querySelector('[data-oha-order-toast]');
    const datasetText = (key, fallback) => {
      const value = root.dataset[key];
      return typeof value === 'string' && value.trim() ? value : fallback;
    };
    const copySuccessText = datasetText('copySuccessText', 'Rendelési azonosító másolva.');
    const docFallbackToast = datasetText('docFallbackToast', 'Dokumentum státusz megnyitva.');
    const faqOpenSymbol = datasetText('faqOpenSymbol', '-');
    const faqClosedSymbol = datasetText('faqClosedSymbol', '+');
    const defaultDeliveryKey = datasetText('defaultDeliveryKey', 'pickup');
    const toast = message => {
      if (!toastNode || !message) return;
      toastNode.textContent = message;
      toastNode.classList.add('is-visible');
      window.clearTimeout(toastNode.dataset.ohaTimer);
      toastNode.dataset.ohaTimer = window.setTimeout(() => toastNode.classList.remove('is-visible'), 2200);
    };

    root.querySelectorAll('[data-oha-order-copy]').forEach(button => {
      button.addEventListener('click', () => {
        const codeNode = button.closest('[data-oha-order-code]');
        const code = codeNode ? String(codeNode.dataset.ohaOrderCode || '').trim() : '';
        if (!code) return;
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code)
            .then(() => toast(copySuccessText))
            .catch(() => toast(code));
        } else {
          toast(code);
        }
      });
    });

    root.querySelectorAll('[data-oha-order-doc]').forEach(button => {
      button.addEventListener('click', () => {
        toast(button.dataset.ohaOrderDoc || docFallbackToast);
      });
    });

    root.querySelectorAll('[data-oha-order-tab]').forEach(tab => {
      tab.addEventListener('click', () => {
        const key = tab.dataset.ohaOrderTab || defaultDeliveryKey;
        root.querySelectorAll('[data-oha-order-tab]').forEach(item => {
          const active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', String(active));
        });
        root.querySelectorAll('[data-oha-order-panel]').forEach(panel => {
          const active = panel.dataset.ohaOrderPanel === key;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
        root.querySelectorAll('[data-oha-order-shipping-summary]').forEach(summary => {
          summary.textContent = tab.dataset.summary || tab.textContent.trim();
        });
      });
    });

    root.querySelectorAll('[data-oha-order-faq]').forEach(button => {
      button.addEventListener('click', () => {
        const item = button.closest('article');
        if (!item) return;
        item.classList.toggle('is-open');
        const marker = button.querySelector('b');
        if (marker) marker.textContent = item.classList.contains('is-open') ? faqOpenSymbol : faqClosedSymbol;
      });
    });
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ohaInitOrderConfirmationPro);
} else {
  ohaInitOrderConfirmationPro();
}

function ohaInit404Pro(){
  document.querySelectorAll('[data-oha-404-pro]').forEach(root => {
    if (root.dataset.oha404Ready === 'true') return;
    root.dataset.oha404Ready = 'true';

    const toastNode = root.querySelector('[data-oha-404-toast]');
    const datasetText = (key, fallback) => {
      const value = root.dataset[key];
      return typeof value === 'string' && value.trim() ? value : fallback;
    };
    const quickSearchToastTemplate = datasetText('quickSearchToastTemplate', '{query} keresés előkészítve.');
    const quickSearchEmptyToast = datasetText('quickSearchEmptyToast', 'Gyors keresés előkészítve.');
    const emptySearchToast = datasetText('emptySearchToast', 'Írj be egy márkát vagy modellt a kereséshez.');
    const rescueMissingStatus = datasetText('rescueMissingStatus', 'A csillaggal jelölt mezők szükségesek a keresési kéréshez.');
    const rescueMissingToast = datasetText('rescueMissingToast', 'Hiányzik néhány kötelező adat.');
    const rescueSuccessStatus = datasetText('rescueSuccessStatus', 'Keresési kérés rögzítve. A csapat VIP-figyeléssel vagy concierge válasszal folytatja.');
    const rescueSuccessToast = datasetText('rescueSuccessToast', 'Keresési kérés rögzítve.');
    const faqOpenSymbol = datasetText('faqOpenSymbol', '-');
    const faqClosedSymbol = datasetText('faqClosedSymbol', '+');
    let toastTimer;
    const toast = message => {
      if (!toastNode || !message) return;
      toastNode.textContent = message;
      toastNode.classList.add('is-visible');
      window.clearTimeout(toastTimer);
      toastTimer = window.setTimeout(() => toastNode.classList.remove('is-visible'), 2400);
    };

    const searchForm = root.querySelector('[data-oha-404-search]');
    const searchInput = root.querySelector('[data-oha-404-search-input]');
    const chips = Array.from(root.querySelectorAll('[data-oha-404-query]'));

    chips.forEach(chip => {
      chip.addEventListener('click', () => {
        const query = String(chip.getAttribute('data-oha-404-query') || '').trim();
        if (searchInput) {
          searchInput.value = query;
          searchInput.focus();
        }
        chips.forEach(item => item.classList.toggle('is-active', item === chip));
        toast(query ? quickSearchToastTemplate.replace('{query}', query) : quickSearchEmptyToast);
        ohaPushAnalytics('oha_404_quick_search', { query });
      });
    });

    if (searchForm && searchInput) {
      searchForm.addEventListener('submit', event => {
        const query = String(searchInput.value || '').trim();
        if (!query) {
          event.preventDefault();
          searchInput.focus();
          toast(emptySearchToast);
          return;
        }
        searchInput.value = query;
        ohaPushAnalytics('oha_404_search_submit', { query });
      });
    }

    root.querySelectorAll('[data-oha-404-rescue-form]').forEach(form => {
      form.setAttribute('novalidate', 'novalidate');
      const status = form.querySelector('[data-oha-404-rescue-status]');
      const required = Array.from(form.querySelectorAll('[required]'));

      const fieldOk = field => {
        const value = String(field.value || '').trim();
        if (!value) return false;
        if (field.type === 'email') return value.includes('@') && value.includes('.');
        return value.length > 1;
      };

      const syncInvalid = show => {
        const invalid = [];
        required.forEach(field => {
          const ok = fieldOk(field);
          const label = field.closest('label');
          if (label) label.classList.toggle('is-invalid', show && !ok);
          if (!ok) invalid.push(field);
        });
        return invalid;
      };

      required.forEach(field => {
        field.addEventListener('input', () => {
          syncInvalid(true);
          if (status) status.textContent = '';
        });
      });

      form.addEventListener('submit', event => {
        event.preventDefault();
        const invalid = syncInvalid(true);
        if (invalid.length) {
          if (status) status.textContent = rescueMissingStatus;
          invalid[0].focus();
          toast(rescueMissingToast);
          return;
        }
        const model = String(form.elements.model?.value || '').trim();
        const type = String(form.elements.type?.value || '').trim();
        if (status) status.textContent = rescueSuccessStatus;
        toast(rescueSuccessToast);
        ohaPushAnalytics('oha_404_rescue_submit', { model, type });
      });
    });

    root.querySelectorAll('[data-oha-404-faq]').forEach(button => {
      button.addEventListener('click', () => {
        const item = button.closest('article');
        if (!item) return;
        item.classList.toggle('is-open');
        const marker = button.querySelector('b');
        if (marker) marker.textContent = item.classList.contains('is-open') ? faqOpenSymbol : faqClosedSymbol;
      });
    });
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ohaInit404Pro);
} else {
  ohaInit404Pro();
}

function ohaInitSitemapHub(){
  document.querySelectorAll('[data-oha-sitemap-hub]').forEach(root => {
    if (root.dataset.ohaSitemapReady === 'true') return;
    root.dataset.ohaSitemapReady = 'true';

    const cards = Array.from(root.querySelectorAll('[data-oha-sitemap-card]'));
    const filters = Array.from(root.querySelectorAll('[data-oha-sitemap-filter]'));
    const search = root.querySelector('[data-oha-sitemap-search]');
    const visible = root.querySelector('[data-oha-sitemap-visible]');
    const toastNode = root.querySelector('[data-oha-sitemap-toast]');
    const datasetText = (key, fallback = '') => {
      const value = root.dataset[key];
      return typeof value === 'string' && value.trim() ? value : fallback;
    };
    const copyFallbackLabel = datasetText('copyFallbackLabel', 'Másolva');
    const copyErrorLabel = datasetText('copyErrorLabel', 'Másolás kijelölhető szövegből');
    let activeFilter = datasetText('defaultFilter', 'all');
    let toastTimer;

    const toast = message => {
      if (!toastNode || !message) return;
      toastNode.textContent = message;
      toastNode.classList.add('is-visible');
      window.clearTimeout(toastTimer);
      toastTimer = window.setTimeout(() => toastNode.classList.remove('is-visible'), 2200);
    };

    const applyFilter = () => {
      const query = String(search ? search.value : '').trim().toLowerCase();
      let count = 0;
      cards.forEach(card => {
        const category = String(card.dataset.category || '');
        const haystack = String(card.dataset.search || '').toLowerCase();
        const categoryOk = activeFilter === 'all' || category === activeFilter;
        const searchOk = !query || haystack.includes(query);
        const show = categoryOk && searchOk;
        card.hidden = !show;
        if (show) count += 1;
      });
      if (visible) visible.textContent = String(count);
    };

    filters.forEach(filter => {
      filter.addEventListener('click', () => {
        activeFilter = filter.getAttribute('data-oha-sitemap-filter') || 'all';
        filters.forEach(item => item.classList.toggle('is-active', item === filter));
        applyFilter();
        ohaPushAnalytics('oha_sitemap_filter', { category: activeFilter });
      });
    });

    if (search) {
      search.addEventListener('input', applyFilter);
    }

    root.querySelectorAll('[data-oha-sitemap-copy]').forEach(button => {
      button.addEventListener('click', async () => {
        const value = String(button.getAttribute('data-oha-sitemap-copy') || '').trim();
        const doneLabel = button.getAttribute('data-copy-label') || copyFallbackLabel;
        if (!value) return;
        const fallback = () => {
          const input = document.createElement('textarea');
          input.value = value;
          input.setAttribute('readonly', '');
          input.style.position = 'fixed';
          input.style.opacity = '0';
          document.body.append(input);
          input.select();
          document.execCommand('copy');
          input.remove();
        };
        try {
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(value);
          } else {
            fallback();
          }
          toast(`${doneLabel}: ${value}`);
        } catch (error) {
          fallback();
          toast(`${copyErrorLabel}: ${value}`);
        }
        ohaPushAnalytics('oha_sitemap_copy_source', { source_file: value });
      });
    });

    applyFilter();
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ohaInitSitemapHub);
} else {
  ohaInitSitemapHub();
}

function ohaInitDesignSystem(){
  document.querySelectorAll('[data-oha-design-system]').forEach((root) => {
    if (root.dataset.ohaDesignSystemInit === 'true') return;
    root.dataset.ohaDesignSystemInit = 'true';

    const toastNode = root.querySelector('[data-oha-ds-toast]');
    const datasetText = (key, fallback = '') => {
      const value = root.dataset[key];
      return typeof value === 'string' && value.trim() ? value : fallback;
    };
    const bidMinimum = Number(datasetText('bidMinimum', '700000')) || 700000;
    const toast = (message) => {
      if (!toastNode) return;
      toastNode.textContent = message;
      toastNode.classList.add('is-visible');
      clearTimeout(toastNode._ohaTimer);
      toastNode._ohaTimer = setTimeout(() => toastNode.classList.remove('is-visible'), 1700);
    };

    const activateTab = (id) => {
      root.querySelectorAll('[data-oha-ds-tab]').forEach((button) => {
        const active = button.getAttribute('data-oha-ds-tab') === id;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', String(active));
      });
      root.querySelectorAll('[data-oha-ds-panel]').forEach((panel) => {
        panel.classList.toggle('is-active', panel.getAttribute('data-oha-ds-panel') === id);
      });
      ohaPushAnalytics('oha_design_system_tab', { tab: id });
    };

    root.querySelectorAll('[data-oha-ds-tab]').forEach((button) => {
      button.addEventListener('click', () => activateTab(button.getAttribute('data-oha-ds-tab') || ''));
    });

    root.querySelectorAll('[data-oha-ds-copy]').forEach((button) => {
      button.addEventListener('click', async () => {
        const target = root.querySelector('#' + CSS.escape(button.getAttribute('data-oha-ds-copy') || ''));
        const text = target ? target.textContent || '' : '';
        const fallback = () => {
          const input = document.createElement('textarea');
          input.value = text;
          input.setAttribute('readonly', '');
          input.style.position = 'fixed';
          input.style.opacity = '0';
          document.body.append(input);
          input.select();
          document.execCommand('copy');
          input.remove();
        };
        try {
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(text);
          } else {
            fallback();
          }
          toast(datasetText('copySuccessText', 'Kódrészlet másolva'));
        } catch (error) {
          fallback();
          toast(datasetText('copyErrorText', 'Másolás kijelölhető szövegből'));
        }
        ohaPushAnalytics('oha_design_system_copy', { target: button.getAttribute('data-oha-ds-copy') || '' });
      });
    });

    const controls = root.querySelector('[data-oha-ds-preview-controls]');
    const previewBadges = root.querySelector('[data-oha-ds-preview-badges]');
    const previewName = root.querySelector('[data-oha-ds-preview-name]');
    const previewDesc = root.querySelector('[data-oha-ds-preview-desc]');
    const previewPrice = root.querySelector('[data-oha-ds-preview-price]');
    const renderPreview = () => {
      if (!controls || !previewBadges || !previewName || !previewDesc || !previewPrice) return;
      const name = controls.querySelector('[data-oha-ds-prev-name]')?.value || datasetText('previewNameFallback', 'Denon DP-60M');
      const category = controls.querySelector('[data-oha-ds-prev-cat]')?.value || datasetText('previewCategoryFallback', 'Lemezjátszó');
      const condition = controls.querySelector('[data-oha-ds-prev-condition]')?.value || datasetText('previewConditionFallback', 'Kiváló állapot');
      const voltage = controls.querySelector('[data-oha-ds-prev-voltage]')?.value || datasetText('previewVoltageFallback', '100V');
      const price = controls.querySelector('[data-oha-ds-prev-price]')?.value || datasetText('previewPriceFallback', 'Ár egyeztetés után');
      const extra = controls.querySelector('[data-oha-ds-prev-extra]')?.value || datasetText('previewExtraFallback', 'Tesztvideó');
      const conditionClass = condition.includes('Szerviz') ? 'is-red' : (condition.includes('Jó') ? 'is-gold' : 'is-green');
      const voltageClass = voltage === '100V' ? 'is-brown' : (voltage === 'Nem ismert' ? 'is-red' : 'is-green');
      const extraClass = extra.includes('korlát') ? 'is-red' : (extra.includes('VIP') ? '' : 'is-blue');
      previewName.textContent = name;
      previewDesc.textContent = datasetText('previewDescTemplate', '{category} · dokumentált állapot, személyes meghallgatási lehetőséggel.').replace('{category}', category);
      previewPrice.textContent = price;
      previewBadges.innerHTML = [
        `<span class="${conditionClass}">${condition}</span>`,
        `<span class="${voltageClass}">${voltage}</span>`,
        `<span class="${extraClass}">${extra}</span>`
      ].join('');
    };
    renderPreview();
    root.querySelector('[data-oha-ds-update]')?.addEventListener('click', () => {
      renderPreview();
      toast(datasetText('previewUpdateToast', 'Előnézet frissítve'));
      ohaPushAnalytics('oha_design_system_preview_update', {});
    });

    root.querySelector('[data-oha-ds-sample-form]')?.addEventListener('submit', (event) => {
      event.preventDefault();
      toast(datasetText('formSubmitToast', 'Űrlap előnézet elküldve'));
    });

    root.querySelector('[data-oha-ds-bid-demo]')?.addEventListener('click', () => {
      const value = Number(root.querySelector('[data-oha-ds-bid]')?.value || 0);
      const minimumText = new Intl.NumberFormat('hu-HU').format(bidMinimum);
      const minimumToast = datasetText('bidMinimumToastTemplate', 'Minimum licit: {amount} Ft').replace('{amount}', minimumText);
      toast(value >= bidMinimum ? datasetText('bidAcceptedToast', 'Előnézeti licit elfogadva') : minimumToast);
    });

    const secondsNode = root.querySelector('[data-oha-ds-seconds]');
    if (secondsNode) {
      let seconds = Number(secondsNode.childNodes[0]?.textContent || 58);
      setInterval(() => {
        seconds = (seconds + 59) % 60;
        if (secondsNode.firstChild) secondsNode.firstChild.textContent = String(seconds).padStart(2, '0');
      }, 1000);
    }

    const updateProgress = () => {
      const boxes = Array.from(root.querySelectorAll('[data-oha-ds-qa]'));
      const checked = boxes.filter((box) => box.checked).length;
      const percent = boxes.length ? Math.round((checked / boxes.length) * 100) : 0;
      const percentNode = root.querySelector('[data-oha-ds-qa-percent]');
      const barNode = root.querySelector('[data-oha-ds-qa-bar]');
      const progressLabel = datasetText('qaProgressTemplate', '{percent}%').replaceAll('{percent}', String(percent));
      if (percentNode) percentNode.textContent = progressLabel;
      if (barNode) barNode.style.width = `${percent}%`;
    };
    root.querySelectorAll('[data-oha-ds-qa]').forEach((box) => box.addEventListener('change', updateProgress));
    updateProgress();
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ohaInitDesignSystem);
} else {
  ohaInitDesignSystem();
}

function ohaInitShopifyHandoff(){
  document.querySelectorAll('[data-oha-handoff]').forEach((root) => {
    if (root.dataset.ohaHandoffInit === 'true') return;
    root.dataset.ohaHandoffInit = 'true';

    const toastNode = root.querySelector('[data-oha-handoff-toast]');
    const datasetText = (key, fallback = '') => {
      const value = root.dataset[key];
      return typeof value === 'string' && value.trim() ? value : fallback;
    };
    const toast = (message) => {
      if (!toastNode) return;
      toastNode.textContent = message;
      toastNode.classList.add('is-visible');
      clearTimeout(toastNode._ohaTimer);
      toastNode._ohaTimer = setTimeout(() => toastNode.classList.remove('is-visible'), 1800);
    };

    const activateTab = (id) => {
      root.querySelectorAll('[data-oha-handoff-tab]').forEach((button) => {
        const active = button.getAttribute('data-oha-handoff-tab') === id;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', String(active));
      });
      root.querySelectorAll('[data-oha-handoff-panel]').forEach((panel) => {
        panel.classList.toggle('is-active', panel.getAttribute('data-oha-handoff-panel') === id);
      });
      ohaPushAnalytics('oha_shopify_handoff_tab', { tab: id });
    };

    root.querySelectorAll('[data-oha-handoff-tab]').forEach((button) => {
      button.addEventListener('click', () => activateTab(button.getAttribute('data-oha-handoff-tab') || 'templates'));
    });

    let activeFilter = datasetText('defaultFilter', 'all');
    const search = root.querySelector('[data-oha-handoff-search]');
    const components = Array.from(root.querySelectorAll('[data-oha-handoff-component]'));
    const applyFilter = () => {
      const query = String(search?.value || '').trim().toLowerCase();
      let count = 0;
      components.forEach((card) => {
        const group = String(card.dataset.group || '');
        const haystack = String(card.dataset.search || '').toLowerCase();
        const filterOk = activeFilter === 'all' || group === activeFilter;
        const searchOk = !query || haystack.includes(query);
        const visible = filterOk && searchOk;
        card.hidden = !visible;
        if (visible) count += 1;
      });
      root.dataset.ohaHandoffVisibleComponents = String(count);
    };

    root.querySelectorAll('[data-oha-handoff-filter]').forEach((button) => {
      button.addEventListener('click', () => {
        activeFilter = button.getAttribute('data-oha-handoff-filter') || 'all';
        root.querySelectorAll('[data-oha-handoff-filter]').forEach((item) => item.classList.toggle('is-active', item === button));
        applyFilter();
        ohaPushAnalytics('oha_shopify_handoff_filter', { group: activeFilter });
      });
    });
    search?.addEventListener('input', applyFilter);
    applyFilter();

    root.querySelectorAll('[data-oha-handoff-copy]').forEach((button) => {
      button.addEventListener('click', async () => {
        const targetId = button.getAttribute('data-oha-handoff-copy') || '';
        const target = targetId ? document.getElementById(targetId) : null;
        const text = target ? target.textContent || '' : '';
        if (!text.trim()) return;
        const fallback = () => {
          const input = document.createElement('textarea');
          input.value = text;
          input.setAttribute('readonly', '');
          input.style.position = 'fixed';
          input.style.opacity = '0';
          document.body.append(input);
          input.select();
          document.execCommand('copy');
          input.remove();
        };
        try {
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(text);
          } else {
            fallback();
          }
          toast(datasetText('copySuccessText', 'Kódrészlet másolva'));
        } catch (error) {
          fallback();
          toast(datasetText('copyErrorText', 'Másolás kijelölhető szövegből'));
        }
        ohaPushAnalytics('oha_shopify_handoff_copy', { target: targetId });
      });
    });

    const updateProgress = () => {
      const boxes = Array.from(root.querySelectorAll('[data-oha-handoff-check]'));
      const checked = boxes.filter((box) => box.checked).length;
      const percent = boxes.length ? Math.round((checked / boxes.length) * 100) : 0;
      const label = root.querySelector('[data-oha-handoff-progress-label]');
      const bar = root.querySelector('[data-oha-handoff-progress]');
      const progressLabel = datasetText('progressLabelTemplate', '{percent}%').replaceAll('{percent}', String(percent));
      if (label) label.textContent = progressLabel;
      if (bar) bar.style.width = `${percent}%`;
      root.dataset.ohaHandoffProgress = String(percent);
    };
    root.querySelectorAll('[data-oha-handoff-check]').forEach((box) => box.addEventListener('change', updateProgress));
    updateProgress();
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ohaInitShopifyHandoff);
} else {
  ohaInitShopifyHandoff();
}

function ohaInitReleaseQa(){
  document.querySelectorAll('[data-oha-release-qa]').forEach((root) => {
    if (root.dataset.ohaReleaseQaInit === 'true') return;
    root.dataset.ohaReleaseQaInit = 'true';

    const toastNode = root.querySelector('[data-oha-rqa-toast]');
    const datasetText = (key, fallback = '') => {
      const value = root.dataset[key];
      return typeof value === 'string' && value.trim() ? value : fallback;
    };
    const escapeHtml = (value) => String(value || '').replace(/[&<>"']/g, (character) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    }[character]));
    const formatText = (template, values = {}) => Object.entries(values).reduce(
      (result, [key, value]) => result.replaceAll(`{${key}}`, String(value)),
      String(template || '')
    );
    const toast = (message) => {
      if (!toastNode) return;
      toastNode.textContent = message;
      toastNode.classList.add('is-visible');
      clearTimeout(toastNode._ohaTimer);
      toastNode._ohaTimer = setTimeout(() => toastNode.classList.remove('is-visible'), 1800);
    };

    const checks = Array.from(root.querySelectorAll('[data-oha-rqa-check]'));
    const gauge = root.querySelector('[data-oha-rqa-gauge]');
    const percentNode = root.querySelector('[data-oha-rqa-percent]');
    const doneNode = root.querySelector('[data-oha-rqa-done]');
    const criticalNode = root.querySelector('[data-oha-rqa-critical]');
    const majorNode = root.querySelector('[data-oha-rqa-major]');
    const leftNode = root.querySelector('[data-oha-rqa-left]');
    const mainBar = root.querySelector('[data-oha-rqa-main-bar]');
    const gate = root.querySelector('[data-oha-rqa-gate]');
    const gateBadge = root.querySelector('[data-oha-rqa-gate-badge]');
    const consoleNode = root.querySelector('[data-oha-rqa-console]');

    const consoleLine = (tone, label, text) => `<div><span class="${tone}">${escapeHtml(label)}</span> · ${escapeHtml(text)}</div>`;
    const setGate = (mode, label, text, consoleHtml = '') => {
      if (gate) {
        gate.classList.toggle('is-blocked', mode === 'blocked');
        gate.classList.toggle('is-ok', mode === 'ok');
        gate.innerHTML = `<strong>${escapeHtml(datasetText('gateLabel', 'Élesítési döntés:'))}</strong> ${escapeHtml(text)}`;
      }
      if (gateBadge) {
        gateBadge.textContent = label;
        gateBadge.className = mode === 'ok' ? 'is-green' : (mode === 'blocked' ? 'is-red' : 'is-amber');
      }
      if (consoleNode && consoleHtml) consoleNode.innerHTML = consoleHtml;
    };

    const updateQa = () => {
      const done = checks.filter((box) => box.checked).length;
      const total = checks.length;
      const critical = checks.filter((box) => box.dataset.severity === 'critical');
      const criticalDone = critical.filter((box) => box.checked).length;
      const major = checks.filter((box) => box.dataset.severity === 'major');
      const majorDone = major.filter((box) => box.checked).length;
      const percent = total ? Math.round((done / total) * 100) : 0;
      const percentLabel = datasetText('meterPercentTemplate', '{percent}%').replaceAll('{percent}', String(percent));
      if (percentNode) percentNode.textContent = percentLabel;
      if (gauge) gauge.style.setProperty('--rqa-progress', `${percent * 3.6}deg`);
      if (doneNode) doneNode.textContent = String(done);
      if (criticalNode) criticalNode.textContent = `${criticalDone}/${critical.length}`;
      if (majorNode) majorNode.textContent = `${majorDone}/${major.length}`;
      if (leftNode) leftNode.textContent = String(Math.max(total - done, 0));
      if (mainBar) mainBar.style.width = `${percent}%`;
      root.querySelectorAll('[data-oha-rqa-card]').forEach((card) => {
        const box = card.querySelector('[data-oha-rqa-check]');
        card.classList.toggle('is-done', Boolean(box && box.checked));
      });
      if (criticalDone < critical.length) {
        setGate(
          'blocked',
          datasetText('gateBlockedBadge', 'Blokkolt'),
          datasetText('gateBlockedText', 'Blokkolt. A kritikus minőségellenőrzési pontok még nincsenek lezárva.'),
          consoleLine('is-bad', datasetText('consoleBlockedStatusLabel', 'Blokkolt'), datasetText('consoleBlockedStatusText', 'Kritikus pont hiányzik.')) +
            consoleLine('is-warn', datasetText('consoleBlockedActionLabel', 'TEENDŐ'), datasetText('consoleBlockedActionText', '100 V, fizetés, linkútvonal és állapotlap kontrollt ellenőrizni.'))
        );
      } else if (percent < 90) {
        setGate(
          'warn',
          datasetText('gateWarnBadge', 'Feltételes'),
          datasetText('gateWarnText', 'FELTÉTELES. Kritikus pontok kész, de még több fő/kisebb pont nyitott.'),
          consoleLine('is-warn', datasetText('consoleWarnStatusLabel', 'FELTÉTELES'), datasetText('consoleWarnStatusText', 'Kritikus pontok kész.')) +
            consoleLine('is-ok', datasetText('consoleWarnNextLabel', 'KÖVETKEZŐ'), datasetText('consoleWarnNextText', 'Fő pontok lezárása.'))
        );
      } else {
        setGate(
          'ok',
          datasetText('gateOkBadge', 'Élesítési javaslat'),
          datasetText('gateOkText', 'Élesítési javaslat. Az ellenőrzőlista alapján a rendszer élesítésre előkészíthető.'),
          consoleLine('is-ok', datasetText('consoleOkStatusLabel', 'Mehet'), datasetText('consoleOkStatusText', 'Kritikus és fő minőségellenőrzési pontok rendben.')) +
            consoleLine('is-ok', datasetText('consoleOkNextLabel', 'KÖVETKEZŐ'), datasetText('consoleOkNextText', 'Shopify admin végső gyors teszt.'))
        );
      }
      root.dataset.ohaReleaseQaProgress = String(percent);
    };

    checks.forEach((box) => box.addEventListener('change', updateQa));
    root.querySelector('[data-oha-rqa-check-critical]')?.addEventListener('click', () => {
      checks.filter((box) => box.dataset.severity === 'critical').forEach((box) => { box.checked = true; });
      updateQa();
      toast(datasetText('criticalDoneToast', 'Kritikus pontok kipipálva előnézeti módban.'));
    });
    root.querySelector('[data-oha-rqa-clear]')?.addEventListener('click', () => {
      root.querySelectorAll('[data-oha-rqa-check], [data-oha-rqa-flow], [data-oha-rqa-shop]').forEach((box) => { box.checked = false; });
      updateQa();
      updateShop();
      toast(datasetText('clearToast', 'Pipák törölve.'));
    });

    let activeFilter = datasetText('defaultFilter', 'all');
    const qaSearch = root.querySelector('[data-oha-rqa-search]');
    const applyQaFilter = () => {
      const query = String(qaSearch?.value || '').trim().toLowerCase();
      root.querySelectorAll('[data-oha-rqa-card]').forEach((card) => {
        const severity = String(card.dataset.severity || '');
        const haystack = String(card.dataset.search || '').toLowerCase();
        card.hidden = !((activeFilter === 'all' || severity === activeFilter) && (!query || haystack.includes(query)));
      });
    };
    root.querySelectorAll('[data-oha-rqa-filter]').forEach((button) => {
      button.addEventListener('click', () => {
        activeFilter = button.getAttribute('data-oha-rqa-filter') || 'all';
        root.querySelectorAll('[data-oha-rqa-filter]').forEach((item) => item.classList.toggle('is-active', item === button));
        applyQaFilter();
        ohaPushAnalytics('oha_release_qa_filter', { severity: activeFilter });
      });
    });
    qaSearch?.addEventListener('input', applyQaFilter);

    const updateShop = () => {
      const boxes = Array.from(root.querySelectorAll('[data-oha-rqa-shop]'));
      const percent = boxes.length ? Math.round((boxes.filter((box) => box.checked).length / boxes.length) * 100) : 0;
      const bar = root.querySelector('[data-oha-rqa-shop-bar]');
      if (bar) bar.style.width = `${percent}%`;
      root.dataset.ohaReleaseQaShopProgress = String(percent);
    };
    root.querySelectorAll('[data-oha-rqa-shop]').forEach((box) => box.addEventListener('change', updateShop));
    root.querySelectorAll('[data-oha-rqa-flow]').forEach((box) => box.addEventListener('change', () => toast(box.checked ? datasetText('flowDoneToast', 'Tesztútvonal ellenőrizve.') : datasetText('flowReopenToast', 'Tesztútvonal visszanyitva.'))));

    const pageSearch = root.querySelector('[data-oha-rqa-page-search]');
    pageSearch?.addEventListener('input', () => {
      const query = String(pageSearch.value || '').trim().toLowerCase();
      root.querySelectorAll('[data-oha-rqa-page]').forEach((row) => {
        row.hidden = Boolean(query && !String(row.dataset.search || '').toLowerCase().includes(query));
      });
    });

    root.querySelectorAll('[data-oha-rqa-copy]').forEach((button) => {
      button.addEventListener('click', async () => {
        const text = button.getAttribute('data-oha-rqa-copy') || '';
        const fallback = () => {
          const input = document.createElement('textarea');
          input.value = text;
          input.setAttribute('readonly', '');
          input.style.position = 'fixed';
          input.style.opacity = '0';
          document.body.append(input);
          input.select();
          document.execCommand('copy');
          input.remove();
        };
        try {
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(text);
          } else {
            fallback();
          }
          toast(datasetText('copySuccessText', 'Fájlnév másolva.'));
        } catch (error) {
          fallback();
          toast(formatText(datasetText('copyErrorText', '{file}'), { file: text }));
        }
      });
    });

    root.querySelector('[data-oha-rqa-decision]')?.addEventListener('click', () => {
      updateQa();
      toast(formatText(datasetText('decisionToastTemplate', '{decision} döntés előnézet generálva.'), { decision: gateBadge?.textContent || 'Élesítés' }));
    });

    root.querySelector('[data-oha-rqa-note]')?.addEventListener('click', () => {
      const done = checks.filter((box) => box.checked).length;
      const critical = checks.filter((box) => box.dataset.severity === 'critical');
      const criticalDone = critical.filter((box) => box.checked).length;
      const shop = Array.from(root.querySelectorAll('[data-oha-rqa-shop]'));
      const shopDone = shop.filter((box) => box.checked).length;
      const flows = Array.from(root.querySelectorAll('[data-oha-rqa-flow]'));
      const flowDone = flows.filter((box) => box.checked).length;
      const status = criticalDone === critical.length && done / Math.max(checks.length, 1) >= 0.9 ? datasetText('noteStatusGo', 'Élesítési javaslat') : (criticalDone === critical.length ? datasetText('noteStatusConditional', 'Feltételes élesítés') : datasetText('noteStatusNogo', 'Blokkolt'));
      const output = root.querySelector('[data-oha-rqa-note-output]');
      if (output) {
        output.textContent = [
          datasetText('noteGeneratedTitle', 'OldHifiAudio élesítési minőségellenőrzési jegyzet'),
          `${datasetText('noteStatusLabel', 'Státusz')}: ${status}`,
          `${datasetText('noteQaLabel', 'Minőségellenőrzési pontok')}: ${done}/${checks.length} lezárva`,
          `${datasetText('noteCriticalLabel', 'Kritikus pontok')}: ${criticalDone}/${critical.length} lezárva`,
          `${datasetText('noteShopifyLabel', 'Shopify admin pontok')}: ${shopDone}/${shop.length} lezárva`,
          `${datasetText('noteSmokeLabel', 'Gyors tesztútvonalak')}: ${flowDone}/${flows.length} tesztelve`,
          `${datasetText('noteNextLabel', 'Következő lépés')}: ${datasetText('noteNextText', 'kritikus hiány esetén javítás, egyébként Shopify előnézeti gyors teszt és tulajdonosi jóváhagyás.')}`
        ].join('\n');
      }
      toast(datasetText('noteToast', 'Élesítési jegyzet összeállítva.'));
      ohaPushAnalytics('oha_release_qa_note', { status });
    });

    updateQa();
    updateShop();
    applyQaFilter();
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ohaInitReleaseQa);
} else {
  ohaInitReleaseQa();
}

document.addEventListener('click', (event) => {
  const slot = event.target.closest('.oha-booking-calendar__slot-button');
  if (!slot) return;
  const form = slot.closest('form') || document.querySelector('.oha-appointment-form form');
  if (!form) return;
  const date = form.querySelector('#AppointmentForm-date');
  const time = form.querySelector('#AppointmentForm-time');
  const code = form.querySelector('#AppointmentForm-slot-code');
  if (date) date.value = slot.dataset.ohaBookingDate || '';
  if (time) time.value = slot.dataset.ohaBookingTime || '';
  if (code) code.value = slot.dataset.ohaBookingSlotCode || '';
  form.querySelectorAll('.oha-booking-calendar__slot-button').forEach(button => {
    button.setAttribute('aria-pressed', String(button === slot));
  });
});

function ohaInitStaleAppointmentBridge(){
  const forms = Array.from(document.querySelectorAll('.oha-appointment-form form')).filter((form) => {
    if (!(form instanceof HTMLFormElement)) return false;
    if (form.dataset.ohaAppointmentForm === 'true') return false;
    const action = form.getAttribute('action') || '';
    return action.includes('/apps/oldhifiaudio/appointments') || !form.hasAttribute('data-oha-appointment-form');
  });
  if (!forms.length) return;

  const text = (value) => String(value || '').trim();
  const assetUrl = (fileName) => {
    const assetNode = document.querySelector('script[src*="/assets/oha-interactions.js"], link[href*="/assets/"]');
    const source = assetNode ? (assetNode.getAttribute('src') || assetNode.getAttribute('href') || '') : '';
    const match = source.match(/^(.*\/assets\/)/);
    return match ? `${match[1]}${fileName}?oha_v=20260612-appointment-stale-r1` : `/cdn/shop/t/10/assets/${fileName}?oha_v=20260612-appointment-stale-r1`;
  };
  const ensureField = (form, id, name) => {
    let node = form.querySelector(`#${id}`);
    if (!node) {
      node = document.createElement('input');
      node.type = 'hidden';
      node.id = id;
      form.prepend(node);
    }
    node.name = name;
    return node;
  };
  const setField = (form, selector, value) => {
    const node = form.querySelector(selector);
    if (node) node.value = text(value);
  };
  const parseSlotTime = (slot) => {
    const start = text(slot.start_at);
    if (start.includes('T')) return start.split('T')[1].slice(0, 5);
    const label = text(slot.time_label);
    return label ? label.split('-')[0].trim() : text(slot.time);
  };
  const statusNode = (form) => {
    let node = form.querySelector('[data-oha-form-status]');
    if (!node) {
      node = document.createElement('div');
      node.className = 'oha-appointment-form-status';
      node.setAttribute('data-oha-form-status', '');
      node.setAttribute('role', 'status');
      node.setAttribute('aria-live', 'polite');
      node.hidden = true;
      const buttonRow = form.querySelector('.contact__button') || form.lastElementChild;
      if (buttonRow) buttonRow.before(node); else form.append(node);
    }
    return node;
  };
  const setStatus = (form, message, tone = 'neutral') => {
    const node = statusNode(form);
    node.hidden = !message;
    node.textContent = message || '';
    node.dataset.tone = tone;
  };
  const selectSlot = (form, day, slot, button) => {
    const dayKey = text(day.date || button.dataset.ohaBookingDate);
    const slotCode = text(slot.slot_code || button.dataset.ohaBookingSlotCode);
    const startAt = text(slot.start_at || button.dataset.ohaStartAt);
    const endAt = text(slot.end_at || button.dataset.ohaEndAt);
    const time = parseSlotTime(slot);
    setField(form, '#AppointmentForm-date', dayKey);
    setField(form, '#AppointmentForm-time', time);
    setField(form, '#AppointmentForm-slot-code', slotCode);
    setField(form, '#AppointmentForm-day-key', dayKey);
    setField(form, '#AppointmentForm-slot-canonical', slotCode);
    setField(form, '#AppointmentForm-start-at', startAt);
    setField(form, '#AppointmentForm-end-at', endAt);
    setField(form, '#AppointmentForm-source-page', window.location.href);
    form.querySelectorAll('.oha-booking-calendar__slot-button').forEach((item) => {
      const selected = item === button;
      item.classList.toggle('is-selected', selected);
      item.setAttribute('aria-pressed', String(selected));
    });
    setStatus(form, '', 'neutral');
  };
  const renderState = (form, state) => {
    const target = form.querySelector('.oha-booking-calendar');
    if (!target) return;
    const days = (Array.isArray(state && state.days) ? state.days : [])
      .filter((day) => Array.isArray(day.slots) && day.slots.some((slot) => text(slot.status) === 'free'))
      .slice(0, 10);
    if (!days.length) return;
    target.innerHTML = '';
    days.forEach((day) => {
      const card = document.createElement('div');
      card.className = 'oha-booking-calendar__day';
      card.setAttribute('data-booking-free', '');
      const head = document.createElement('div');
      head.className = 'oha-booking-calendar__day-head';
      const date = document.createElement('span');
      date.className = 'oha-booking-calendar__date';
      date.textContent = text(day.human_date) || text(day.date);
      head.append(date);
      const slots = document.createElement('div');
      slots.className = 'oha-booking-calendar__slots';
      day.slots.filter((slot) => text(slot.status) === 'free').forEach((slot) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'oha-booking-calendar__slot-button';
        button.textContent = text(slot.time_label) || parseSlotTime(slot);
        button.dataset.ohaBookingDate = text(day.date);
        button.dataset.ohaBookingTime = parseSlotTime(slot);
        button.dataset.ohaBookingSlotCode = text(slot.slot_code);
        button.dataset.ohaStartAt = text(slot.start_at);
        button.dataset.ohaEndAt = text(slot.end_at);
        button.setAttribute('aria-pressed', 'false');
        button.addEventListener('click', () => selectSlot(form, day, slot, button));
        slots.append(button);
      });
      card.append(head, slots);
      target.append(card);
    });
  };
  const submit = async (form, event) => {
    event.preventDefault();
    setField(form, '#AppointmentForm-source-page', window.location.href);
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }
    const payload = {
      kind: 'appointment',
      source: 'shopi_storefront_appointment_stale_guard',
      source_page: window.location.href,
      customer_name: text(form.querySelector('#AppointmentForm-name')?.value),
      customer_email: text(form.querySelector('#AppointmentForm-email')?.value),
      customer_phone: text(form.querySelector('#AppointmentForm-phone')?.value),
      product_title: text(form.querySelector('#AppointmentForm-product')?.value),
      note_text: text(form.querySelector('#AppointmentForm-body')?.value),
      slot_code: text(form.querySelector('#AppointmentForm-slot-canonical')?.value || form.querySelector('#AppointmentForm-slot-code')?.value),
      day_key: text(form.querySelector('#AppointmentForm-day-key')?.value || form.querySelector('#AppointmentForm-date')?.value),
      start_at: text(form.querySelector('#AppointmentForm-start-at')?.value),
      end_at: text(form.querySelector('#AppointmentForm-end-at')?.value),
      appointment_slot_code: text(form.querySelector('#AppointmentForm-slot-code')?.value),
      appointment_date: text(form.querySelector('#AppointmentForm-date')?.value),
      appointment_time: text(form.querySelector('#AppointmentForm-time')?.value),
      name: text(form.querySelector('#AppointmentForm-name')?.value),
      email: text(form.querySelector('#AppointmentForm-email')?.value),
      phone: text(form.querySelector('#AppointmentForm-phone')?.value),
      product: text(form.querySelector('#AppointmentForm-product')?.value),
      message: text(form.querySelector('#AppointmentForm-body')?.value)
    };
    if (!payload.slot_code || !payload.day_key) {
      setStatus(form, 'Válassz egy szabad showroom-idősávot a küldés előtt.', 'error');
      return;
    }
    const button = form.querySelector('button[type="submit"]');
    const label = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Küldés…';
    }
    try {
      const response = await fetch(form.action, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok || !result.ok) throw new Error(text(result.message) || 'A foglalási kérés elküldése most nem sikerült. Kérlek, próbáld újra.');
      setStatus(form, text(result.message) || 'A foglalási kérésedet rögzítettük. A végleges visszaigazolást e-mailben küldjük.', 'success');
    } catch (error) {
      setStatus(form, text(error.message) || 'A foglalási kérés elküldése most nem sikerült. Kérlek, próbáld újra.', 'error');
    } finally {
      if (button) {
        button.disabled = false;
        button.textContent = label || 'Időpont kérése';
      }
    }
  };

  forms.forEach((form) => {
    form.dataset.ohaAppointmentForm = 'true';
    form.dataset.ohaStaleBridgeGuard = '20260612-r1';
    form.setAttribute('data-oha-appointment-form', '');
    form.action = '/apps/oldhifi-bridge?kind=appointment';
    form.method = 'post';
    ensureField(form, 'AppointmentForm-source-page', 'source_page');
    ensureField(form, 'AppointmentForm-day-key', 'day_key');
    ensureField(form, 'AppointmentForm-slot-canonical', 'slot_code');
    ensureField(form, 'AppointmentForm-start-at', 'start_at');
    ensureField(form, 'AppointmentForm-end-at', 'end_at');
    setField(form, '#AppointmentForm-source-page', window.location.href);
    form.addEventListener('submit', (event) => submit(form, event));
    fetch(assetUrl('oha-booking-state.json'), { cache: 'no-store', credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then((response) => response.ok ? response.json() : null)
      .then((state) => { if (state) renderState(form, state); })
      .catch(() => null);
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ohaInitStaleAppointmentBridge);
} else {
  ohaInitStaleAppointmentBridge();
}
setTimeout(ohaInitStaleAppointmentBridge, 800);

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;
  const action = form.getAttribute('action') || '';
  if (!action.includes('/cart/add')) return;
  ohaTrackAddToCartForm(form);
}, true);

function ohaInitProjectHandoff(){
  document.querySelectorAll('[data-oha-project-handoff]').forEach((root) => {
    if (root.dataset.ohaProjectHandoffInit === 'true') return;
    root.dataset.ohaProjectHandoffInit = 'true';
    const toastNode = root.querySelector('[data-oha-ph-toast]');
    const datasetText = (key, fallback = '') => {
      const value = root.dataset[key];
      return typeof value === 'string' && value.trim() ? value : fallback;
    };
    const formatText = (template, values = {}) => Object.entries(values).reduce(
      (result, [key, value]) => result.replaceAll(`{${key}}`, String(value)),
      String(template || '')
    );
    const toast = (message) => {
      if (!toastNode) return;
      toastNode.textContent = message;
      toastNode.classList.add('is-visible');
      window.clearTimeout(toastNode._ohaTimer);
      toastNode._ohaTimer = window.setTimeout(() => toastNode.classList.remove('is-visible'), 1800);
    };
    const normalize = (value) => String(value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const cards = Array.from(root.querySelectorAll('[data-oha-ph-card]'));
    const search = root.querySelector('[data-oha-ph-search]');
    const filterbar = root.querySelector('[data-oha-ph-filterbar]');
    const result = root.querySelector('[data-oha-ph-result]');
    let activeCategory = datasetText('defaultCategory', 'all');

    const applyFilter = () => {
      const query = normalize(search?.value || '');
      let visible = 0;
      cards.forEach((card) => {
        const category = card.getAttribute('data-category') || '';
        const haystack = normalize(`${card.getAttribute('data-search') || ''} ${card.textContent || ''}`);
        const categoryOk = activeCategory === 'all' || category === activeCategory;
        const textOk = !query || haystack.includes(query);
        const show = categoryOk && textOk;
        card.hidden = !show;
        if (show) visible += 1;
      });
      if (result) result.textContent = formatText(datasetText('resultTemplate', '{visible} oldal látható a {total}-ból'), { visible, total: cards.length });
    };

    if (filterbar) {
      const counts = cards.reduce((map, card) => {
        const category = card.getAttribute('data-category') || 'Egyéb';
        map.set(category, (map.get(category) || 0) + 1);
        return map;
      }, new Map());
      const buttons = [
        ['all', formatText(datasetText('filterAllLabel', 'Összes {count}'), { count: cards.length, total: cards.length })],
        ...Array.from(counts.entries()).map(([category, count]) => [category, formatText(datasetText('filterLabelTemplate', '{category} {count}'), { category, count, total: cards.length })])
      ];
      if (!buttons.some(([category]) => category === activeCategory)) activeCategory = 'all';
      buttons.forEach(([category, label]) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = label;
        button.dataset.ohaPhFilter = category;
        button.classList.toggle('is-active', category === activeCategory);
        button.addEventListener('click', () => {
          activeCategory = category;
          filterbar.querySelectorAll('button').forEach((item) => item.classList.toggle('is-active', item === button));
          applyFilter();
        });
        filterbar.append(button);
      });
    }
    search?.addEventListener('input', applyFilter);

    root.querySelectorAll('[data-oha-ph-copy]').forEach((button) => {
      button.addEventListener('click', async () => {
        const text = button.getAttribute('data-oha-ph-copy') || '';
        const fallback = () => {
          const input = document.createElement('textarea');
          input.value = text;
          input.setAttribute('readonly', '');
          input.style.position = 'fixed';
          input.style.opacity = '0';
          document.body.append(input);
          input.select();
          document.execCommand('copy');
          input.remove();
        };
        try {
          if (navigator.clipboard && window.isSecureContext) await navigator.clipboard.writeText(text);
          else fallback();
          toast(datasetText('copySuccessText', 'Fájlnév másolva.'));
        } catch (error) {
          fallback();
          toast(formatText(datasetText('copyErrorText', '{file}'), { file: text }));
        }
      });
    });

    const ownerChecks = Array.from(root.querySelectorAll('[data-oha-ph-owner]'));
    const ownerBar = root.querySelector('[data-oha-ph-owner-bar]');
    const ownerText = root.querySelector('[data-oha-ph-owner-text]');
    const ownerBadge = root.querySelector('[data-oha-ph-owner-badge]');
    const updateOwner = () => {
      const done = ownerChecks.filter((box) => box.checked).length;
      const percent = ownerChecks.length ? Math.round((done / ownerChecks.length) * 100) : 0;
      if (ownerBar) ownerBar.style.width = `${percent}%`;
      if (ownerText) ownerText.textContent = formatText(datasetText('ownerProgressTemplate', '{percent}% kész · {done}/{total} döntési pont lezárva'), { percent, done, total: ownerChecks.length });
      if (ownerBadge) ownerBadge.textContent = formatText(datasetText('ownerBadgeTemplate', '{percent}%'), { percent, done, total: ownerChecks.length });
    };
    ownerChecks.forEach((box) => box.addEventListener('change', updateOwner));

    root.querySelector('[data-oha-ph-note-copy]')?.addEventListener('click', async () => {
      const note = root.querySelector('[data-oha-ph-note]');
      const text = note?.value || note?.textContent || '';
      try {
        if (navigator.clipboard && window.isSecureContext) await navigator.clipboard.writeText(text);
        else {
          note?.focus();
          note?.select?.();
          document.execCommand('copy');
        }
        toast(datasetText('noteCopySuccessText', 'Élesítési jegyzet másolva.'));
      } catch (error) {
        note?.focus();
        note?.select?.();
        toast(datasetText('noteCopyErrorText', 'Másolásra kijelölve.'));
      }
      ohaPushAnalytics('oha_project_handoff_note_copy', { cards: String(cards.length) });
    });

    applyFilter();
    updateOwner();
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ohaInitProjectHandoff);
} else {
  ohaInitProjectHandoff();
}

function ohaInitWantedDevice(){
  document.querySelectorAll('[data-oha-wanted-device]').forEach((root) => {
    if (root.dataset.ohaWantedDeviceInit === 'true') return;
    root.dataset.ohaWantedDeviceInit = 'true';

    const form = root.querySelector('[data-oha-wish-form]');
    const toastNode = root.querySelector('[data-oha-wish-toast]');
    const demoMode = root.dataset.demoMode !== 'false';
    const datasetText = (key, fallback = '') => String(root.dataset[key] || fallback);
    const summaryEmpty = datasetText('summaryEmptyValue', '-');
    const summaryVoltageDefault = datasetText('summaryVoltageDefault', summaryEmpty);
    const summaryUrgencyDefault = datasetText('summaryUrgencyDefault', summaryEmpty);
    const requestIdPrefix = datasetText('requestIdPrefix', 'OHA-WISH').replace(/-$/, '');
    const get = (selector) => root.querySelector(selector);
    const value = (selector) => get(selector)?.value?.trim() || '';
    const checked = (selector) => Boolean(get(selector)?.checked);
    const toast = (message) => {
      if (!toastNode) return;
      toastNode.textContent = message;
      toastNode.classList.add('is-visible');
      window.clearTimeout(toastNode._ohaTimer);
      toastNode._ohaTimer = window.setTimeout(() => toastNode.classList.remove('is-visible'), 1900);
    };
    const selectedText = (selector, fallback = summaryEmpty) => {
      const node = get(selector);
      if (!node) return fallback;
      const option = node.options ? node.options[node.selectedIndex] : null;
      const text = option ? option.textContent.trim() : node.value;
      return node.value ? text : fallback;
    };
    const setSelect = (selector, wanted) => {
      const node = get(selector);
      if (!node || !wanted) return;
      const normalized = String(wanted).toLowerCase();
      const option = Array.from(node.options).find((item) => item.value.toLowerCase() === normalized || item.textContent.trim().toLowerCase() === normalized || item.textContent.trim().toLowerCase().includes(normalized));
      if (option) node.value = option.value;
    };
    const write = (selector, text) => {
      const node = get(selector);
      if (node) node.textContent = text;
    };
    const buildPayload = (score) => ({
      brand: value('[data-oha-wish-brand]'),
      model: value('[data-oha-wish-model]'),
      category: value('[data-oha-wish-category]'),
      budget: value('[data-oha-wish-budget]'),
      condition: value('[data-oha-wish-condition]'),
      voltage: value('[data-oha-wish-voltage]'),
      urgency: value('[data-oha-wish-urgency]'),
      purpose: value('[data-oha-wish-purpose]'),
      name: value('[data-oha-wish-name]'),
      email: value('[data-oha-wish-email]'),
      phone: value('[data-oha-wish-phone]'),
      contactMode: value('[data-oha-wish-contact]'),
      notes: value('[data-oha-wish-notes]'),
      subscribe: checked('[data-oha-wish-subscribe]'),
      preorder: checked('[data-oha-wish-preorder]'),
      showroom: checked('[data-oha-wish-showroom]'),
      score
    });
    const updateSummary = () => {
      const brand = value('[data-oha-wish-brand]');
      const model = value('[data-oha-wish-model]');
      const category = value('[data-oha-wish-category]');
      const budget = value('[data-oha-wish-budget]');
      const email = value('[data-oha-wish-email]');
      const phone = value('[data-oha-wish-phone]');
      const notes = value('[data-oha-wish-notes]');
      let score = 20;
      if (model) score += 22;
      if (brand) score += 8;
      if (category) score += 14;
      if (budget) score += 10;
      if (email) score += 10;
      if (phone) score += 5;
      if (notes.length > 25) score += 8;
      if (checked('[data-oha-wish-preorder]')) score += 5;
      score = Math.min(score, 100);

      write('[data-oha-wish-summary-model]', brand || model ? `${brand}${brand && model ? ' ' : ''}${model}` : summaryEmpty);
      write('[data-oha-wish-summary-category]', selectedText('[data-oha-wish-category]'));
      write('[data-oha-wish-summary-budget]', selectedText('[data-oha-wish-budget]'));
      write('[data-oha-wish-summary-voltage]', selectedText('[data-oha-wish-voltage]', summaryVoltageDefault));
      write('[data-oha-wish-summary-urgency]', selectedText('[data-oha-wish-urgency]', summaryUrgencyDefault));
      write('[data-oha-wish-score-text]', `${score}%`);
      const bar = get('[data-oha-wish-score-bar]');
      if (bar) bar.style.width = `${score}%`;

      let statusTitle = datasetText('statusLowTitle');
      let statusText = datasetText('statusLowText');
      if (checked('[data-oha-wish-preorder]') && budget) {
        statusTitle = datasetText('statusPreorderTitle');
        statusText = datasetText('statusPreorderText');
      } else if (score >= 75) {
        statusTitle = datasetText('statusHighTitle');
        statusText = datasetText('statusHighText');
      } else if (score >= 55) {
        statusTitle = datasetText('statusMidTitle');
        statusText = datasetText('statusMidText');
      }
      write('[data-oha-wish-status-title]', statusTitle);
      write('[data-oha-wish-status-text]', statusText);

      const payload = get('[data-oha-wish-payload]');
      if (payload) payload.value = JSON.stringify(buildPayload(score));
      return score;
    };

    const validate = () => {
      const checks = [
        ['[data-oha-wish-model]', datasetText('validationModelLabel')],
        ['[data-oha-wish-category]', datasetText('validationCategoryLabel')],
        ['[data-oha-wish-name]', datasetText('validationNameLabel')],
        ['[data-oha-wish-email]', datasetText('validationEmailLabel')]
      ];
      for (const [selector, label] of checks) {
        const node = get(selector);
        if (!node || !node.value.trim()) {
          toast(`${datasetText('validationMissingPrefix')}: ${label}`);
          node?.focus();
          return false;
        }
      }
      if (!checked('[data-oha-wish-consent]')) {
        toast(datasetText('validationConsentMessage'));
        get('[data-oha-wish-consent]')?.focus();
        return false;
      }
      if (checked('[data-oha-wish-preorder]') && !value('[data-oha-wish-budget]')) {
        toast(datasetText('validationPreorderBudgetMessage'));
        get('[data-oha-wish-budget]')?.focus();
        return false;
      }
      return true;
    };

    root.querySelectorAll('[data-oha-wish-pick]').forEach((button) => {
      button.addEventListener('click', () => {
        root.querySelectorAll('[data-oha-wish-pick]').forEach((item) => item.classList.remove('is-selected'));
        button.classList.add('is-selected');
        const brand = get('[data-oha-wish-brand]');
        const model = get('[data-oha-wish-model]');
        if (brand) brand.value = button.dataset.brand || '';
        if (model) model.value = button.dataset.model || '';
        setSelect('[data-oha-wish-category]', button.dataset.category || '');
        setSelect('[data-oha-wish-budget]', button.dataset.budget || '');
        setSelect('[data-oha-wish-voltage]', button.dataset.voltage || '');
        updateSummary();
        get('[data-oha-wish-form]')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        toast(datasetText('toastPick'));
        if (typeof ohaPushAnalytics === 'function') ohaPushAnalytics('oha_wanted_device_pick', { model: button.dataset.model || '' });
      });
    });

    root.querySelectorAll('input, select, textarea').forEach((node) => {
      node.addEventListener('input', updateSummary);
      node.addEventListener('change', updateSummary);
    });
    get('[data-oha-wish-clear]')?.addEventListener('click', () => {
      form?.reset();
      root.querySelectorAll('[data-oha-wish-pick]').forEach((item) => item.classList.remove('is-selected'));
      get('[data-oha-wish-confirm]')?.classList.remove('is-visible');
      updateSummary();
      toast(datasetText('toastClear'));
    });
    form?.addEventListener('submit', (event) => {
      updateSummary();
      if (!validate()) {
        event.preventDefault();
        return;
      }
      if (demoMode) {
        event.preventDefault();
        const id = `${requestIdPrefix}-${Math.floor(1000 + Math.random() * 9000)}`;
        write('[data-oha-wish-request-id]', id);
        get('[data-oha-wish-confirm]')?.classList.add('is-visible');
        toast(datasetText('toastSubmit'));
        if (typeof ohaPushAnalytics === 'function') ohaPushAnalytics('oha_wanted_device_submit_demo', { id });
      }
    });

    root.querySelectorAll('[data-oha-wish-tab]').forEach((button) => {
      button.addEventListener('click', () => {
        const target = button.dataset.ohaWishTab;
        root.querySelectorAll('[data-oha-wish-tab]').forEach((item) => {
          item.classList.toggle('is-active', item === button);
          item.setAttribute('aria-selected', String(item === button));
        });
        root.querySelectorAll('[data-oha-wish-tab-panel]').forEach((panel) => panel.classList.toggle('is-active', panel.id === target));
      });
    });
    root.querySelectorAll('[data-oha-wish-faq]').forEach((button) => {
      button.addEventListener('click', () => button.closest('article')?.classList.toggle('is-open'));
    });
    updateSummary();
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ohaInitWantedDevice);
} else {
  ohaInitWantedDevice();
}

function ohaInitBlogSeoHub() {
  document.querySelectorAll('[data-oha-blog-seo]').forEach((root) => {
    if (root.dataset.ohaBlogReady === 'true') return;
    root.dataset.ohaBlogReady = 'true';
    const toastNode = root.querySelector('[data-oha-blog-toast]');
    let activeTopic = 'all';
    let toastTimer = null;
    const datasetText = (key, fallback = '') => String(root.dataset[key] || fallback);
    const cards = Array.from(root.querySelectorAll('[data-oha-blog-card]'));
    const visibleNode = root.querySelector('[data-oha-blog-visible]');
    const searchInput = root.querySelector('[data-oha-blog-search]');
    const scoreText = root.querySelector('[data-oha-blog-score-text]');
    const scoreBar = root.querySelector('[data-oha-blog-score-bar]');
    const briefSelect = root.querySelector('[data-oha-blog-brief-select]');

    const toast = (message) => {
      if (!toastNode || !message) return;
      toastNode.textContent = message;
      toastNode.classList.add('is-visible');
      window.clearTimeout(toastTimer);
      toastTimer = window.setTimeout(() => toastNode.classList.remove('is-visible'), 2400);
    };

    const updateCount = (count) => {
      if (visibleNode) visibleNode.textContent = String(count);
    };

    const filterCards = () => {
      const query = (searchInput?.value || '').trim().toLowerCase();
      let count = 0;
      cards.forEach((card) => {
        const topic = (card.dataset.topic || '').toLowerCase();
        const text = (card.dataset.search || card.textContent || '').toLowerCase();
        const topicMatch = activeTopic === 'all' || topic.includes(activeTopic);
        const textMatch = !query || text.includes(query);
        const show = topicMatch && textMatch;
        card.classList.toggle('is-hidden', !show);
        if (show) count += 1;
      });
      updateCount(count);
    };

    const updateBrief = () => {
      if (!briefSelect) return;
      const option = briefSelect.options[briefSelect.selectedIndex];
      const url = option?.dataset.url || '';
      const title = option?.dataset.title || '';
      const desc = option?.dataset.desc || '';
      const urlNode = root.querySelector('[data-oha-blog-brief-url]');
      const titleNode = root.querySelector('[data-oha-blog-brief-title]');
      const descNode = root.querySelector('[data-oha-blog-brief-desc]');
      if (urlNode) urlNode.textContent = url;
      if (titleNode) titleNode.textContent = title;
      if (descNode) descNode.textContent = desc;
      const score = Math.min(96, 70 + Math.round((title.length + desc.length) / 12));
      if (scoreText) scoreText.textContent = `${score}%`;
      if (scoreBar) scoreBar.style.width = `${score}%`;
    };

    root.querySelectorAll('[data-oha-blog-filter]').forEach((button) => {
      button.addEventListener('click', () => {
        activeTopic = button.dataset.ohaBlogFilter || 'all';
        root.querySelectorAll('[data-oha-blog-filter]').forEach((item) => item.classList.toggle('is-active', item === button));
        filterCards();
      });
    });

    searchInput?.addEventListener('input', filterCards);
    briefSelect?.addEventListener('change', updateBrief);
    root.querySelector('[data-oha-blog-copy-brief]')?.addEventListener('click', async () => {
      const text = [
        root.querySelector('[data-oha-blog-brief-url]')?.textContent || '',
        root.querySelector('[data-oha-blog-brief-title]')?.textContent || '',
        root.querySelector('[data-oha-blog-brief-desc]')?.textContent || '',
      ].filter(Boolean).join('\n');
      try {
        if (navigator.clipboard?.writeText) await navigator.clipboard.writeText(text);
        toast(datasetText('ohaToastCopySuccess'));
      } catch (error) {
        toast(datasetText('ohaToastCopyFallback'));
      }
    });

    root.querySelectorAll('[data-oha-blog-faq]').forEach((button) => {
      button.addEventListener('click', () => button.closest('article')?.classList.toggle('is-open'));
    });

    root.querySelector('[data-oha-blog-topic-form]')?.addEventListener('submit', (event) => {
      const demoMode = root.dataset.demoMode === 'true';
      const email = root.querySelector('[data-oha-blog-topic-form] input[type="email"]');
      if (!email?.value.trim()) {
        event.preventDefault();
        toast(datasetText('ohaToastEmailRequired'));
        email?.focus();
        return;
      }
      if (demoMode) {
        event.preventDefault();
        toast(datasetText('ohaToastSubmitSuccess'));
        event.currentTarget.reset();
      }
    });

    updateBrief();
    filterCards();
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ohaInitBlogSeoHub);
} else {
  ohaInitBlogSeoHub();
}

function ohaInitArticleSeoCore() {
  document.querySelectorAll('[data-oha-article-seo]').forEach((root) => {
    if (root.dataset.ohaArticleReady === 'true') return;
    root.dataset.ohaArticleReady = 'true';
    root.querySelectorAll('[data-oha-article-faq]').forEach((button) => {
      button.addEventListener('click', () => button.closest('section')?.classList.toggle('is-open'));
    });
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ohaInitArticleSeoCore);
} else {
  ohaInitArticleSeoCore();
}

function ohaInitMobileUx() {
  document.querySelectorAll('[data-oha-mobile-ux]').forEach((root) => {
    if (root.dataset.ohaMobileReady === 'true') return;
    root.dataset.ohaMobileReady = 'true';
    const toastNode = root.querySelector('[data-oha-mobile-toast]');
    let toastTimer = null;

    const toast = (message) => {
      if (!toastNode || !message) return;
      toastNode.textContent = message;
      toastNode.classList.add('is-visible');
      window.clearTimeout(toastTimer);
      toastTimer = window.setTimeout(() => toastNode.classList.remove('is-visible'), 2200);
    };
    const datasetText = (key, fallback = '') => {
      const value = root.dataset[key];
      return typeof value === 'string' && value.trim() ? value : fallback;
    };

    const activateState = (state) => {
      root.querySelectorAll('[data-oha-mobile-state]').forEach((button) => {
        const active = button.getAttribute('data-oha-mobile-state') === state;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', String(active));
      });
      root.querySelectorAll('[data-oha-mobile-screen]').forEach((panel) => {
        panel.classList.toggle('is-active', panel.getAttribute('data-oha-mobile-screen') === state);
      });
      root.querySelectorAll('[data-oha-mobile-bottom]').forEach((bar) => {
        bar.classList.toggle('is-active', bar.getAttribute('data-oha-mobile-bottom') === state);
      });
      if (typeof ohaPushAnalytics === 'function') ohaPushAnalytics('oha_mobile_ux_state', { state });
    };

    root.querySelectorAll('[data-oha-mobile-state]').forEach((button) => {
      button.addEventListener('click', () => activateState(button.getAttribute('data-oha-mobile-state') || 'menu'));
    });

    const activateTab = (tab) => {
      root.querySelectorAll('[data-oha-mobile-tab]').forEach((button) => {
        const active = button.getAttribute('data-oha-mobile-tab') === tab;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', String(active));
      });
      root.querySelectorAll('[data-oha-mobile-tab-panel]').forEach((panel) => {
        panel.classList.toggle('is-active', panel.getAttribute('data-oha-mobile-tab-panel') === tab);
      });
      if (typeof ohaPushAnalytics === 'function') ohaPushAnalytics('oha_mobile_ux_tab', { tab });
    };

    root.querySelectorAll('[data-oha-mobile-tab]').forEach((button) => {
      button.addEventListener('click', () => activateTab(button.getAttribute('data-oha-mobile-tab') || 'catalog'));
    });

    const updateProgress = () => {
      const boxes = Array.from(root.querySelectorAll('[data-oha-mobile-check]'));
      const done = boxes.filter((box) => box.checked).length;
      const percent = boxes.length ? Math.round(done / boxes.length * 100) : 0;
      const bar = root.querySelector('[data-oha-mobile-progress]');
      const label = root.querySelector('[data-oha-mobile-progress-text]');
      if (bar) bar.style.width = `${percent}%`;
      if (label) {
        label.textContent = datasetText('ohaMobileProgressTemplate')
          .replace('{percent}', String(percent))
          .replace('{done}', String(done))
          .replace('{total}', String(boxes.length));
      }
    };

    root.querySelectorAll('[data-oha-mobile-check]').forEach((box) => {
      box.addEventListener('change', () => {
        updateProgress();
        toast(box.checked ? datasetText('ohaMobileToastCheckOn') : datasetText('ohaMobileToastCheckOff'));
      });
    });
    updateProgress();

    root.querySelectorAll('[data-oha-mobile-copy]').forEach((button) => {
      button.addEventListener('click', async () => {
        const target = root.querySelector('#' + CSS.escape(button.getAttribute('data-oha-mobile-copy') || ''));
        const text = target ? target.textContent : '';
        if (!text) return;
        try {
          if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(text);
          } else {
            const input = document.createElement('textarea');
            input.value = text;
            input.setAttribute('readonly', '');
            input.style.position = 'fixed';
            input.style.opacity = '0';
            document.body.append(input);
            input.select();
            document.execCommand('copy');
            input.remove();
          }
          toast(datasetText('ohaMobileToastCopySuccess'));
        } catch (error) {
          toast(datasetText('ohaMobileToastCopyFallback'));
        }
      });
    });
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ohaInitMobileUx);
} else {
  ohaInitMobileUx();
}

function ohaPatchTranslationMissingText() {
  const translationPrefix = ['Translation', 'missing:'].join(' ') + ' hu.';
  const translationKey = (suffix) => translationPrefix + suffix;
  const replacements = {
    [translationKey('accessibility.close')]: 'Bezárás',
    [translationKey('accessibility.skip_to_product_info')]: 'Ugrás a termékinformációkhoz',
    [translationKey('general.share.close')]: 'Megosztás bezárása',
    [translationKey('general.share.copy_to_clipboard')]: 'Link másolása',
    [translationKey('general.share.share_url')]: 'Megosztási link',
    [translationKey('general.slider.next_slide')]: 'Következő dia',
    [translationKey('general.slider.of')]: '/',
    [translationKey('general.slider.previous_slide')]: 'Előző dia',
    [translationKey('products.modal.label')]: 'Termék média',
    [translationKey('products.product.media.gallery_viewer')]: 'Termékképgaléria',
    [translationKey('products.product.media.open_media')]: 'Média megnyitása',
    [translationKey('products.product.on_sale')]: 'Akciós',
    [translationKey('products.product.price.regular_price')]: 'Normál ár',
    [translationKey('products.product.price.sale_price')]: 'Akciós ár',
    [translationKey('products.product.sold_out')]: 'Elfogyott',
    [translationKey('products.product.taxes_included')]: 'Az ár tartalmazza az áfát.',
    [translationKey('products.product.view_full_details')]: 'Teljes termékadatlap megnyitása'
  };
  const pattern = new RegExp(translationPrefix.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '[A-Za-z0-9_.-]+', 'g');
  const patch = (value) => value.replace(pattern, (match) => replacements[match] || '');
  const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
  const nodes = [];
  while (walker.nextNode()) {
    if (walker.currentNode.nodeValue.includes(translationPrefix)) nodes.push(walker.currentNode);
  }
  nodes.forEach((node) => {
    node.nodeValue = patch(node.nodeValue).replace(/\s{2,}/g, ' ').trim();
  });
  document.querySelectorAll('[aria-label], [title], [alt]').forEach((node) => {
    ['aria-label', 'title', 'alt'].forEach((attribute) => {
      const value = node.getAttribute(attribute);
      if (value && value.includes(translationPrefix)) node.setAttribute(attribute, patch(value));
    });
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ohaPatchTranslationMissingText);
} else {
  ohaPatchTranslationMissingText();
}

function ohaPatchStaleCategoryRailCache() {
  const grid = document.querySelector('.oha-category-rail__grid');
  if (!grid) return;

  const currentLabels = Array.from(grid.querySelectorAll('.oha-category-rail__item')).map((item) =>
    (item.textContent || '').replace(/\s+/g, ' ').trim()
  );
  const categories = [
    ['Integrált erősítő', '/collections/integralt-erositok', 'integrated-amplifier'],
    ['Végerősítő', '/collections/vegerositok', 'power-amplifier'],
    ['Előerősítő-végfok páros', '/collections/eloerosito-vegerosito-paros', 'pre-power-pair'],
    ['Lemezjátszó', '/collections/lemezjatszok', 'turntable'],
    ['Orsós magnó', '/collections/szalagos-magno', 'reel'],
    ['CD-lejátszó', '/collections/cd-lejatszok', 'cd-player'],
    ['DAT', '/collections/dat', 'dat']
  ];
  const desiredLabels = categories.map(([label]) => label);
  const alreadyFresh =
    currentLabels.length === desiredLabels.length &&
    desiredLabels.every((label, index) => currentLabels[index] === label);
  const looksStale = !alreadyFresh;
  const spriteUrl =
    'https://cdn.shopify.com/s/files/1/0960/2170/9147/t/3/assets/oha-icons.sprite.svg?v=1781186306';

  if (!document.getElementById('oha-category-cache-guard-style')) {
    const style = document.createElement('style');
    style.id = 'oha-category-cache-guard-style';
    style.textContent = `
      body.template-index .oha-category-rail__grid{grid-template-columns:repeat(4,minmax(0,1fr));gap:18px;padding:26px 0 22px}
      body.template-index .oha-category-rail__item{min-height:92px;display:grid;grid-template-columns:78px minmax(0,1fr);gap:14px;align-items:center;justify-content:start;padding:0;border:0;border-radius:0;background:transparent;box-shadow:none;text-align:left;font-size:15px;font-weight:850;line-height:1.18}
      body.template-index .oha-category-rail__icon{display:grid;place-items:center;width:78px;height:78px;border:1px solid var(--oha-index-line,#dfc9a5);border-radius:50%;background:#f9f0df;color:#7f6038;box-shadow:inset 0 0 0 7px rgba(255,250,240,.72)}
      body.template-index .oha-category-rail__icon .oha-icon{width:42px;height:42px}
      @media (max-width:1180px){body.template-index .oha-category-rail__grid{grid-template-columns:repeat(2,minmax(0,1fr))}}
      @media (max-width:749px){body.template-index .oha-category-rail__grid{grid-template-columns:repeat(2,minmax(0,1fr));gap:10px;padding:16px 0}body.template-index .oha-category-rail__item{grid-template-columns:56px minmax(0,1fr);min-height:74px;padding:10px 12px;border:1px solid var(--oha-index-line,#dfc9a5);border-radius:8px;background:#fffaf0;font-size:14px}body.template-index .oha-category-rail__icon{width:52px;height:52px;box-shadow:none}body.template-index .oha-category-rail__icon .oha-icon{width:34px;height:34px}}
    `;
    document.head.append(style);
  }

  if (alreadyFresh || !looksStale) return;

  const fragment = document.createDocumentFragment();
  categories.forEach(([label, href, icon]) => {
    const link = document.createElement('a');
    link.className = 'oha-category-rail__item';
    link.href = href;

    const iconWrap = document.createElement('span');
    iconWrap.className = 'oha-category-rail__icon';
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('class', 'oha-icon');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    const use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
    use.setAttribute('href', `${spriteUrl}#oha-icon-${icon}`);
    use.setAttributeNS('http://www.w3.org/1999/xlink', 'href', `${spriteUrl}#oha-icon-${icon}`);
    svg.append(use);
    iconWrap.append(svg);

    const text = document.createElement('span');
    text.textContent = label;
    link.append(iconWrap, text);
    fragment.append(link);
  });

  const section = grid.closest('.oha-category-rail');
  if (section) section.setAttribute('aria-label', 'Termékkategóriák');
  grid.replaceChildren(fragment);
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ohaPatchStaleCategoryRailCache);
} else {
  ohaPatchStaleCategoryRailCache();
}
setTimeout(ohaPatchStaleCategoryRailCache, 500);
